export const waterSystemsData = [
  {
    "pwsid": "MI0000011",
    "name": "ACME TOWNSHIP  HOPE VILLAGE",
    "population": 128,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.77368021,
    "longitude": -85.50202394,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000011&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000012",
    "name": "ADA TOWNSHIP",
    "population": 7068,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2431,
    "totalLines": 2431,
    "exceedance": "",
    "latitude": 42.94588332,
    "longitude": -85.50816724,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000012&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000020",
    "name": "ADAMS TOWNSHIP",
    "population": 2010,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 154,
    "totalToReplace": 154,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 481,
    "totalLines": 635,
    "exceedance": "",
    "latitude": 47.04857945,
    "longitude": -88.6653503,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000020&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000030",
    "name": "ADDISON",
    "population": 605,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 118,
    "totalLines": 152,
    "exceedance": "",
    "latitude": 41.98676106,
    "longitude": -84.34824006,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000030&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0000040",
    "name": "ADRIAN",
    "population": 23663,
    "y2021": 57,
    "y2022": 124,
    "y2023": 58,
    "y2024": 88,
    "y2025": 190,
    "leadLines": 5,
    "gpcl": 2280,
    "unknown": 0,
    "totalToReplace": 2285,
    "totalReplaced": 517,
    "percentReplaced": 18.451106352605283,
    "nonLead": 3876,
    "totalLines": 6161,
    "exceedance": "",
    "latitude": 41.89813345,
    "longitude": -84.04586038,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000040&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001352",
    "name": "ADVENTURE ACRES",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.82856261,
    "longitude": -83.54939391,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001352&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000050",
    "name": "AHMEEK",
    "population": 148,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 9,
    "unknown": 0,
    "totalToReplace": 9,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 98,
    "totalLines": 107,
    "exceedance": "",
    "latitude": 47.29891793,
    "longitude": -88.38142499,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000050&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000070",
    "name": "AKRON",
    "population": 402,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 202,
    "totalLines": 202,
    "exceedance": "",
    "latitude": 43.56991667,
    "longitude": -83.51468428,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000070&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000072",
    "name": "AKRON TOWNSHIP",
    "population": 219,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 98,
    "totalLines": 98,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000082",
    "name": "ALABASTER TOWNSHIP",
    "population": 86,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 45,
    "totalLines": 45,
    "exceedance": "",
    "latitude": 44.22678093,
    "longitude": -83.5489467,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000082&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060085",
    "name": "ALAMO COVE NURSING HOME",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040458",
    "name": "ALAN'S PARK  DURAND",
    "population": 41,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 157,
    "totalLines": 157,
    "exceedance": "",
    "latitude": 42.94550398,
    "longitude": -83.93538338,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040458&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040319",
    "name": "ALAN'S PARK  FOWLERVILLE",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 157,
    "totalLines": 157,
    "exceedance": "",
    "latitude": 42.65265374,
    "longitude": -84.11371916,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040319&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040129",
    "name": "ALANSON ESTATES MOBILE HOME PARK",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 45.51328336,
    "longitude": -84.66976458,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040129&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000088",
    "name": "ALBEE TOWNSHIP",
    "population": 411,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 203,
    "totalLines": 203,
    "exceedance": "",
    "latitude": 43.26471542,
    "longitude": -83.95224622,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000088&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000100",
    "name": "ALBION",
    "population": 9144,
    "y2021": 0,
    "y2022": 0,
    "y2023": 4,
    "y2024": 3,
    "y2025": 75,
    "leadLines": 609,
    "gpcl": 18,
    "unknown": 0,
    "totalToReplace": 627,
    "totalReplaced": 82,
    "percentReplaced": 11.56558533145275,
    "nonLead": 2142,
    "totalLines": 2769,
    "exceedance": "",
    "latitude": 42.24992671,
    "longitude": -84.75480233,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000100&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040259",
    "name": "ALGOMA ESTATES",
    "population": 580,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 343,
    "totalLines": 343,
    "exceedance": "",
    "latitude": 43.17226164,
    "longitude": -85.57229585,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040259&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000110",
    "name": "ALGONAC, CITY OF",
    "population": 4110,
    "y2021": 0,
    "y2022": 1,
    "y2023": 2,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 29,
    "unknown": 1059,
    "totalToReplace": 1088,
    "totalReplaced": 3,
    "percentReplaced": 0.27497708524289644,
    "nonLead": 739,
    "totalLines": 1827,
    "exceedance": "",
    "latitude": 42.63109215,
    "longitude": -82.53261813,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000110&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000120",
    "name": "ALLEGAN",
    "population": 5930,
    "y2021": 12,
    "y2022": 17,
    "y2023": 243,
    "y2024": 124,
    "y2025": 106,
    "leadLines": 631,
    "gpcl": 433,
    "unknown": 1,
    "totalToReplace": 1065,
    "totalReplaced": 502,
    "percentReplaced": 32.03573707721761,
    "nonLead": 656,
    "totalLines": 1721,
    "exceedance": "",
    "latitude": 42.52938725,
    "longitude": -85.85095054,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000120&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000125",
    "name": "ALLEGAN COUNTY SERVICES CENTER",
    "population": 101,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 8,
    "exceedance": "",
    "latitude": 42.62021375,
    "longitude": -85.84286916,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000125&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040002",
    "name": "ALLEGAN MOBILE ESTATES",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 38,
    "totalToReplace": 38,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 42,
    "exceedance": "",
    "latitude": 42.50977008,
    "longitude": -85.82368521,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040002&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000130",
    "name": "ALLEN PARK",
    "population": 28210,
    "y2021": 8,
    "y2022": 55,
    "y2023": 15,
    "y2024": 43,
    "y2025": 74,
    "leadLines": 236,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 236,
    "totalReplaced": 195,
    "percentReplaced": 45.243619489559165,
    "nonLead": 11611,
    "totalLines": 11847,
    "exceedance": "",
    "latitude": 42.25975727,
    "longitude": -83.21058889,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000130&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000127",
    "name": "ALLENDALE TOWNSHIP",
    "population": 19725,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3790,
    "totalLines": 3790,
    "exceedance": "",
    "latitude": 42.96852528,
    "longitude": -85.92232101,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000127&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000140",
    "name": "ALMA, CITY OF",
    "population": 9182,
    "y2021": 0,
    "y2022": 7,
    "y2023": 6,
    "y2024": 6,
    "y2025": 49,
    "leadLines": 0,
    "gpcl": 115,
    "unknown": 505,
    "totalToReplace": 620,
    "totalReplaced": 68,
    "percentReplaced": 9.883720930232558,
    "nonLead": 2379,
    "totalLines": 2999,
    "exceedance": "",
    "latitude": 43.38332779,
    "longitude": -84.65527638,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000140&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000150",
    "name": "ALMONT, VILLAGE OF",
    "population": 2674,
    "y2021": 7,
    "y2022": 20,
    "y2023": 0,
    "y2024": 3,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 16,
    "totalToReplace": 16,
    "totalReplaced": 30,
    "percentReplaced": 65.21739130434783,
    "nonLead": 1055,
    "totalLines": 1071,
    "exceedance": "",
    "latitude": 42.91730579,
    "longitude": -83.03962119,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000150&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000160",
    "name": "ALPENA, CITY OF",
    "population": 10128,
    "y2021": 25,
    "y2022": 14,
    "y2023": 18,
    "y2024": 51,
    "y2025": 24,
    "leadLines": 7,
    "gpcl": 76,
    "unknown": 4022,
    "totalToReplace": 4105,
    "totalReplaced": 132,
    "percentReplaced": 3.1154118480056647,
    "nonLead": 538,
    "totalLines": 4643,
    "exceedance": "",
    "latitude": 45.05731219,
    "longitude": -83.454121,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000160&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000180",
    "name": "ALPHA",
    "population": 198,
    "y2021": 0,
    "y2022": 4,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 3,
    "gpcl": 9,
    "unknown": 18,
    "totalToReplace": 30,
    "totalReplaced": 5,
    "percentReplaced": 14.285714285714285,
    "nonLead": 96,
    "totalLines": 126,
    "exceedance": "",
    "latitude": 46.04532268,
    "longitude": -88.3775196,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000180&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040681",
    "name": "ALTO MEADOWS",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 95,
    "totalLines": 95,
    "exceedance": "",
    "latitude": 42.85263361,
    "longitude": -85.3851259,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040681&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040023",
    "name": "AMBER ESTATES MOBILE HOME PARK",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 49,
    "exceedance": "",
    "latitude": 42.66885066,
    "longitude": -86.00910506,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040023&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000215",
    "name": "ANDELINA FARMS",
    "population": 156,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 289,
    "totalLines": 289,
    "exceedance": "",
    "latitude": 42.15181213,
    "longitude": -83.70474344,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000215&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040246",
    "name": "ANDREWS ESTATES",
    "population": 178,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 42.2861731,
    "longitude": -85.38962715,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040246&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000210",
    "name": "ANDREWS UNIVERSITY",
    "population": 3000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 118,
    "totalLines": 118,
    "exceedance": "",
    "latitude": 41.95804863,
    "longitude": -86.3505465,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000210&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000220",
    "name": "ANN ARBOR",
    "population": 118017,
    "y2021": 112,
    "y2022": 137,
    "y2023": 103,
    "y2024": 63,
    "y2025": 77,
    "leadLines": 0,
    "gpcl": 471,
    "unknown": 2,
    "totalToReplace": 473,
    "totalReplaced": 492,
    "percentReplaced": 50.984455958549226,
    "nonLead": 25402,
    "totalLines": 25875,
    "exceedance": "",
    "latitude": 42.27450486,
    "longitude": -83.73111038,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000220&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000221",
    "name": "ANN ARBOR TOWNSHIP",
    "population": 1338,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 443,
    "totalLines": 443,
    "exceedance": "",
    "latitude": 42.36129871,
    "longitude": -83.68729949,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000221&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040355",
    "name": "APPLE CARR VILLAGE",
    "population": 1125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 719,
    "totalLines": 719,
    "exceedance": "",
    "latitude": 43.24669374,
    "longitude": -86.11639054,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040355&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040664",
    "name": "APPLE GROVE ESTATES",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 43.22067359,
    "longitude": -85.71512448,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040664&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040668",
    "name": "APPLEWOOD",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 31,
    "totalLines": 31,
    "exceedance": "",
    "latitude": 42.22340689,
    "longitude": -86.16553069,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040668&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000236",
    "name": "ARBOR RIDGE CONDOMINIUMS",
    "population": 58,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 12,
    "exceedance": "2019",
    "latitude": 42.24120436,
    "longitude": -84.49845386,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000236&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004778",
    "name": "ARBOR VIEW",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040223",
    "name": "ARBOR VILLAGE",
    "population": 670,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 268,
    "totalLines": 268,
    "exceedance": "",
    "latitude": 42.22840028,
    "longitude": -84.55361898,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040223&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0066355",
    "name": "ARGENTINE CARE CENTER",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 2,
    "totalToReplace": 2,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.79104439,
    "longitude": -83.84156973,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0066355&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040356",
    "name": "ARLINGTON WOODS",
    "population": 1650,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 660,
    "totalLines": 660,
    "exceedance": "",
    "latitude": 43.20929818,
    "longitude": -86.14799181,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040356&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000240",
    "name": "ARMADA, VILLAGE OF",
    "population": 1794,
    "y2021": 0,
    "y2022": 4,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 151,
    "gpcl": 3,
    "unknown": 0,
    "totalToReplace": 154,
    "totalReplaced": 4,
    "percentReplaced": 2.5316455696202533,
    "nonLead": 459,
    "totalLines": 613,
    "exceedance": "",
    "latitude": 42.83621201,
    "longitude": -82.89857401,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000240&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000242",
    "name": "ARTESIAN SPRINGS RV RESORT",
    "population": 61,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000245",
    "name": "ASH TOWNSHIP",
    "population": 5959,
    "y2021": 2,
    "y2022": 0,
    "y2023": 2,
    "y2024": 1,
    "y2025": 5,
    "leadLines": 49,
    "gpcl": 3,
    "unknown": 905,
    "totalToReplace": 957,
    "totalReplaced": 10,
    "percentReplaced": 1.0341261633919339,
    "nonLead": 1484,
    "totalLines": 2441,
    "exceedance": "",
    "latitude": 42.05860723,
    "longitude": -83.37073586,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000245&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000250",
    "name": "ASHLEY, VILLAGE OF",
    "population": 526,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 245,
    "totalLines": 245,
    "exceedance": "",
    "latitude": 43.18661937,
    "longitude": -84.47730942,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000250&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000260",
    "name": "ATHENS",
    "population": 956,
    "y2021": 1,
    "y2022": 5,
    "y2023": 13,
    "y2024": 10,
    "y2025": 18,
    "leadLines": 0,
    "gpcl": 127,
    "unknown": 7,
    "totalToReplace": 134,
    "totalReplaced": 47,
    "percentReplaced": 25.96685082872928,
    "nonLead": 313,
    "totalLines": 447,
    "exceedance": "",
    "latitude": 42.09309742,
    "longitude": -85.26368723,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000260&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000285",
    "name": "AU GRES TOWNSHIP",
    "population": 66,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 38,
    "totalLines": 38,
    "exceedance": "",
    "latitude": 44.04763671,
    "longitude": -83.6932066,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000285&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000280",
    "name": "AU GRES, CITY OF",
    "population": 945,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 582,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 44.04407674,
    "longitude": -83.69037171,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000280&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0000290",
    "name": "AU SABLE TOWNSHIP",
    "population": 2370,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1340,
    "totalLines": 1340,
    "exceedance": "",
    "latitude": 44.38646017,
    "longitude": -83.33356643,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000290&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000300",
    "name": "AUBURN",
    "population": 2087,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 757,
    "totalToReplace": 757,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 196,
    "totalLines": 953,
    "exceedance": "",
    "latitude": 43.59988993,
    "longitude": -84.09276037,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000300&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005450",
    "name": "AUBURN HILLS",
    "population": 21412,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5630,
    "totalLines": 5630,
    "exceedance": "",
    "latitude": 42.68074129,
    "longitude": -83.24543955,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005450&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000320",
    "name": "AUGUSTA",
    "population": 885,
    "y2021": 7,
    "y2022": 0,
    "y2023": 5,
    "y2024": 10,
    "y2025": 1,
    "leadLines": 10,
    "gpcl": 12,
    "unknown": 0,
    "totalToReplace": 22,
    "totalReplaced": 23,
    "percentReplaced": 51.11111111111111,
    "nonLead": 363,
    "totalLines": 385,
    "exceedance": "",
    "latitude": 42.33819134,
    "longitude": -85.35162608,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000320&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000321",
    "name": "AUGUSTA TOWNSHIP",
    "population": 3907,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1537,
    "totalLines": 1537,
    "exceedance": "",
    "latitude": 42.13304792,
    "longitude": -83.58034254,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000321&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000324",
    "name": "AUSABLE VALLEY COMMUNITY",
    "population": 147,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 12,
    "exceedance": "2019",
    "latitude": 44.71849261,
    "longitude": -84.0410189,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000324&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000322",
    "name": "AUSTIN COMMONS II",
    "population": 280,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 112,
    "totalLines": 112,
    "exceedance": "",
    "latitude": 42.15752313,
    "longitude": -83.80163876,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000322&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001910",
    "name": "AUTUMN HILLS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": 41.98614097,
    "longitude": -86.07083994,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001910&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040074",
    "name": "AVRA ESTATES",
    "population": 87,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 61,
    "exceedance": "",
    "latitude": 41.84247451,
    "longitude": -85.03141275,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040074&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000340",
    "name": "BAD AXE",
    "population": 3129,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 337,
    "totalLines": 337,
    "exceedance": "",
    "latitude": 43.80428625,
    "longitude": -82.99883428,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000340&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000347",
    "name": "BAIR LAKE BIBLE CAMP",
    "population": 372,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 2,
    "unknown": 0,
    "totalToReplace": 2,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 23,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000355",
    "name": "BALDWIN TOWNSHIP",
    "population": 650,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 404,
    "totalLines": 404,
    "exceedance": "",
    "latitude": 44.33094198,
    "longitude": -83.65494983,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000355&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000350",
    "name": "BALDWIN, VILLAGE OF",
    "population": 1060,
    "y2021": 0,
    "y2022": 0,
    "y2023": 116,
    "y2024": 10,
    "y2025": 53,
    "leadLines": 23,
    "gpcl": 5,
    "unknown": 51,
    "totalToReplace": 79,
    "totalReplaced": 179,
    "percentReplaced": 69.37984496124031,
    "nonLead": 328,
    "totalLines": 407,
    "exceedance": "",
    "latitude": 43.9021118,
    "longitude": -85.83492661,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000350&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040041",
    "name": "BALTIMORE TERRACE",
    "population": 155,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 65,
    "totalLines": 65,
    "exceedance": "",
    "latitude": 42.5813113,
    "longitude": -85.26422587,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040041&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000370",
    "name": "BANCROFT, VILLAGE OF",
    "population": 616,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 71,
    "totalToReplace": 71,
    "totalReplaced": 1,
    "percentReplaced": 1.3888888888888888,
    "nonLead": 126,
    "totalLines": 197,
    "exceedance": "",
    "latitude": 42.87253909,
    "longitude": -84.06235926,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000370&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000380",
    "name": "BANGOR",
    "population": 2000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 2,
    "gpcl": 56,
    "unknown": 617,
    "totalToReplace": 675,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 98,
    "totalLines": 773,
    "exceedance": "",
    "latitude": 42.3126575,
    "longitude": -86.10967661,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000380&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000390",
    "name": "BANGOR TOWNSHIP",
    "population": 11999,
    "y2021": 0,
    "y2022": 5,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 12,
    "gpcl": 12,
    "unknown": 0,
    "totalToReplace": 24,
    "totalReplaced": 5,
    "percentReplaced": 17.24137931034483,
    "nonLead": 4746,
    "totalLines": 4770,
    "exceedance": "",
    "latitude": 43.60117515,
    "longitude": -83.8845006,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000390&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000400",
    "name": "BANGORMONITOR METRO DISTRICT",
    "population": 2971,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 8,
    "totalToReplace": 8,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1242,
    "totalLines": 1250,
    "exceedance": "",
    "latitude": 43.59154321,
    "longitude": -83.96739918,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000400&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000410",
    "name": "BARAGA",
    "population": 2182,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 92,
    "totalToReplace": 92,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 655,
    "totalLines": 747,
    "exceedance": "",
    "latitude": 46.78157134,
    "longitude": -88.49504248,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000410&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000418",
    "name": "BARN SWALLOW APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000420",
    "name": "BARODA",
    "population": 910,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 6,
    "unknown": 282,
    "totalToReplace": 288,
    "totalReplaced": 2,
    "percentReplaced": 0.6896551724137931,
    "nonLead": 57,
    "totalLines": 345,
    "exceedance": "",
    "latitude": 41.95564524,
    "longitude": -86.48731269,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000420&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040092",
    "name": "BARRON LAKE/ROSEBUSH",
    "population": 114,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 49,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000426",
    "name": "BARRY TOWNSHIP",
    "population": 260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 101,
    "totalLines": 101,
    "exceedance": "",
    "latitude": 42.49820828,
    "longitude": -85.40682781,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000426&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040042",
    "name": "BARRY'S RESORT",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 53,
    "totalLines": 53,
    "exceedance": "2020",
    "latitude": 42.61245025,
    "longitude": -85.21902008,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040042&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000430",
    "name": "BARTON HILLS",
    "population": 450,
    "y2021": 2,
    "y2022": 1,
    "y2023": 3,
    "y2024": 1,
    "y2025": 3,
    "leadLines": 0,
    "gpcl": 3,
    "unknown": 90,
    "totalToReplace": 93,
    "totalReplaced": 10,
    "percentReplaced": 9.70873786407767,
    "nonLead": 48,
    "totalLines": 141,
    "exceedance": "",
    "latitude": 42.32210158,
    "longitude": -83.76338999,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000430&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040005",
    "name": "BASELINE MOBILE HOME PARK",
    "population": 188,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": 42.4240803,
    "longitude": -85.85905216,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040005&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000440",
    "name": "BATES TOWNSHIP",
    "population": 921,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 612,
    "totalLines": 612,
    "exceedance": "",
    "latitude": 46.13844569,
    "longitude": -88.5871516,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000440&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000450",
    "name": "BATTLE CREEK  VERONA SYSTEM",
    "population": 43975,
    "y2021": 227,
    "y2022": 194,
    "y2023": 330,
    "y2024": 254,
    "y2025": 425,
    "leadLines": 3614,
    "gpcl": 167,
    "unknown": 7066,
    "totalToReplace": 10847,
    "totalReplaced": 1430,
    "percentReplaced": 11.647796693003176,
    "nonLead": 7936,
    "totalLines": 18783,
    "exceedance": "",
    "latitude": 42.29916454,
    "longitude": -85.22937542,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000450&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006077",
    "name": "BAVARIAN SOFTWATER VILLAGE",
    "population": 420,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 48,
    "totalLines": 48,
    "exceedance": "",
    "latitude": 42.74232495,
    "longitude": -83.46507791,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006077&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000465",
    "name": "BAY AREA WATER SYSTEM",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0000470",
    "name": "BAY CITY, CITY OF",
    "population": 32255,
    "y2021": 278,
    "y2022": 523,
    "y2023": 475,
    "y2024": 628,
    "y2025": 689,
    "leadLines": 3323,
    "gpcl": 879,
    "unknown": 0,
    "totalToReplace": 4202,
    "totalReplaced": 2593,
    "percentReplaced": 38.16041206769684,
    "nonLead": 9826,
    "totalLines": 14028,
    "exceedance": "",
    "latitude": 43.61697345,
    "longitude": -83.89720103,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000470&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000485",
    "name": "BAY CO. DEPT OF WATER & SEWER",
    "population": 8465,
    "y2021": 0,
    "y2022": 4,
    "y2023": 4,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 9,
    "gpcl": 7,
    "unknown": 0,
    "totalToReplace": 16,
    "totalReplaced": 8,
    "percentReplaced": 33.33333333333333,
    "nonLead": 3029,
    "totalLines": 3045,
    "exceedance": "",
    "latitude": 43.6280191,
    "longitude": -83.88176549,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000485&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000487",
    "name": "BAY HARBOR CLUB",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 45.07562881,
    "longitude": -85.3581293,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000487&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040128",
    "name": "BAY SHORE ESTATES",
    "population": 208,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 84,
    "totalLines": 84,
    "exceedance": "",
    "latitude": 45.35732999,
    "longitude": -85.09405534,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040128&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000490",
    "name": "BAY VIEW ASSOCIATION",
    "population": 831,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 482,
    "totalLines": 482,
    "exceedance": "",
    "latitude": 45.36764537,
    "longitude": -84.93077498,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000490&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040190",
    "name": "BAYSIDE (DBA CONTINENTAL MHP)",
    "population": 158,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 43.75828067,
    "longitude": -83.42726845,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040190&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000501",
    "name": "BEACH HOUSE APARTMENTS",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 17,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0000503",
    "name": "BEACON HOME AT COLBY",
    "population": 36,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040554",
    "name": "BEAN CREEK RESORT",
    "population": 112,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 73,
    "totalLines": 73,
    "exceedance": "",
    "latitude": 41.97914568,
    "longitude": -84.30122568,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040554&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000505",
    "name": "BEAR CREEK ESTATES CONDOMINIUM",
    "population": 210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 35,
    "totalLines": 35,
    "exceedance": "",
    "latitude": 45.34594431,
    "longitude": -84.96122625,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000505&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000508",
    "name": "BEAR CREEK VILLA",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": 42.84338653,
    "longitude": -85.24351209,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000508&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000510",
    "name": "BEAR LAKE, VILLAGE OF",
    "population": 318,
    "y2021": 0,
    "y2022": 1,
    "y2023": 0,
    "y2024": 2,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 146,
    "unknown": 0,
    "totalToReplace": 146,
    "totalReplaced": 3,
    "percentReplaced": 2.013422818791946,
    "nonLead": 52,
    "totalLines": 198,
    "exceedance": "",
    "latitude": 44.42122821,
    "longitude": -86.15437887,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000510&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000514",
    "name": "BEAVER CREEK RESORT",
    "population": 76,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": 44.96411175,
    "longitude": -84.70333331,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000514&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000513",
    "name": "BEAVER CREEKGRAYLING TOWNSHIPS UA",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000517",
    "name": "BEAVER ROAD AREA WATER ASSOC.",
    "population": 829,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 283,
    "totalLines": 283,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000518",
    "name": "BEAVER TOWNSHIP",
    "population": 1211,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 471,
    "totalLines": 471,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000520",
    "name": "BEAVERTON",
    "population": 1071,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 361,
    "totalToReplace": 361,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 91,
    "totalLines": 452,
    "exceedance": "",
    "latitude": 43.881007,
    "longitude": -84.49206397,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000520&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040080",
    "name": "BEDFORD HILLS",
    "population": 850,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 339,
    "totalLines": 339,
    "exceedance": "",
    "latitude": 42.35901827,
    "longitude": -85.26833907,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040080&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006435",
    "name": "BEDFORD MEADOWS",
    "population": 156,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7,
    "totalLines": 7,
    "exceedance": "",
    "latitude": 41.73984749,
    "longitude": -83.65646459,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006435&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000540",
    "name": "BEECHER METROPOLITAN DISTRICT",
    "population": 9400,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5063,
    "totalLines": 5063,
    "exceedance": "",
    "latitude": 43.09310938,
    "longitude": -83.71315509,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000540&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006627",
    "name": "BEECHWOOD HILLS  TIMBER RIDGE",
    "population": 160,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 64,
    "totalLines": 64,
    "exceedance": "",
    "latitude": 42.2480026,
    "longitude": -86.35829659,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006627&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000560",
    "name": "BELDING",
    "population": 5769,
    "y2021": 84,
    "y2022": 94,
    "y2023": 91,
    "y2024": 189,
    "y2025": 265,
    "leadLines": 0,
    "gpcl": 884,
    "unknown": 0,
    "totalToReplace": 884,
    "totalReplaced": 723,
    "percentReplaced": 44.99066583696328,
    "nonLead": 1001,
    "totalLines": 1885,
    "exceedance": "",
    "latitude": 43.09839245,
    "longitude": -85.22904784,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000560&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000570",
    "name": "BELLAIRE, VILLAGE OF",
    "population": 1086,
    "y2021": 16,
    "y2022": 16,
    "y2023": 6,
    "y2024": 4,
    "y2025": 0,
    "leadLines": 361,
    "gpcl": 10,
    "unknown": 0,
    "totalToReplace": 371,
    "totalReplaced": 42,
    "percentReplaced": 10.16949152542373,
    "nonLead": 218,
    "totalLines": 589,
    "exceedance": "",
    "latitude": 44.97284782,
    "longitude": -85.20770362,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000570&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000580",
    "name": "BELLEVILLE",
    "population": 3964,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.20104314,
    "longitude": -83.48355499,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000580&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040081",
    "name": "BELLEVUE MOBILE HOME PARK",
    "population": 190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": 42.42029698,
    "longitude": -85.00675536,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040081&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000590",
    "name": "BELLEVUE, VILLAGE OF",
    "population": 1282,
    "y2021": 2,
    "y2022": 0,
    "y2023": 1,
    "y2024": 2,
    "y2025": 3,
    "leadLines": 3,
    "gpcl": 7,
    "unknown": 0,
    "totalToReplace": 10,
    "totalReplaced": 8,
    "percentReplaced": 44.44444444444444,
    "nonLead": 524,
    "totalLines": 534,
    "exceedance": "",
    "latitude": 42.44487466,
    "longitude": -85.01852963,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000590&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000605",
    "name": "BENTON CHARTER TOWNSHIP",
    "population": 6768,
    "y2021": 1,
    "y2022": 2,
    "y2023": 1,
    "y2024": 5,
    "y2025": 59,
    "leadLines": 33,
    "gpcl": 7,
    "unknown": 71,
    "totalToReplace": 111,
    "totalReplaced": 68,
    "percentReplaced": 37.988826815642454,
    "nonLead": 2646,
    "totalLines": 2757,
    "exceedance": "2024",
    "latitude": 42.13794017,
    "longitude": -86.45282372,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000605&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000600",
    "name": "BENTON HARBOR",
    "population": 9103,
    "y2021": 191,
    "y2022": 3056,
    "y2023": 24,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 3271,
    "percentReplaced": 100,
    "nonLead": 4531,
    "totalLines": 4531,
    "exceedance": "2021",
    "latitude": 42.10811755,
    "longitude": -86.44344045,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000600&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0000610",
    "name": "BENZONIA VILLAGE OF",
    "population": 511,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 5,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 53,
    "unknown": 0,
    "totalToReplace": 53,
    "totalReplaced": 6,
    "percentReplaced": 10.16949152542373,
    "nonLead": 222,
    "totalLines": 275,
    "exceedance": "",
    "latitude": 44.61637301,
    "longitude": -86.0984494,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000610&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000620",
    "name": "BERGLAND TOWNSHIP",
    "population": 210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 88,
    "gpcl": 0,
    "unknown": 61,
    "totalToReplace": 149,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 149,
    "exceedance": "",
    "latitude": 46.59444617,
    "longitude": -89.56864215,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000620&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000630",
    "name": "BERKLEY",
    "population": 14970,
    "y2021": 35,
    "y2022": 111,
    "y2023": 77,
    "y2024": 54,
    "y2025": 83,
    "leadLines": 97,
    "gpcl": 2,
    "unknown": 5684,
    "totalToReplace": 5783,
    "totalReplaced": 360,
    "percentReplaced": 5.860328829562103,
    "nonLead": 1125,
    "totalLines": 6908,
    "exceedance": "",
    "latitude": 42.49740964,
    "longitude": -83.1894626,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000630&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000635",
    "name": "BERLIN TOWNSHIP",
    "population": 9900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2645,
    "totalLines": 2645,
    "exceedance": "",
    "latitude": 41.9981441,
    "longitude": -83.28245575,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000635&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000650",
    "name": "BERRIEN SPRINGS",
    "population": 1910,
    "y2021": 5,
    "y2022": 0,
    "y2023": 17,
    "y2024": 12,
    "y2025": 46,
    "leadLines": 132,
    "gpcl": 377,
    "unknown": 0,
    "totalToReplace": 509,
    "totalReplaced": 80,
    "percentReplaced": 13.582342954159593,
    "nonLead": 271,
    "totalLines": 780,
    "exceedance": "",
    "latitude": 41.95475477,
    "longitude": -86.33042848,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000650&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000660",
    "name": "BESSEMER",
    "population": 1619,
    "y2021": 17,
    "y2022": 25,
    "y2023": 48,
    "y2024": 20,
    "y2025": 0,
    "leadLines": 47,
    "gpcl": 0,
    "unknown": 46,
    "totalToReplace": 93,
    "totalReplaced": 110,
    "percentReplaced": 54.187192118226605,
    "nonLead": 958,
    "totalLines": 1051,
    "exceedance": "",
    "latitude": 46.48148425,
    "longitude": -90.06112078,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000660&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005600",
    "name": "BESSEMER TOWNSHIP",
    "population": 551,
    "y2021": 3,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 30,
    "gpcl": 0,
    "unknown": 242,
    "totalToReplace": 272,
    "totalReplaced": 3,
    "percentReplaced": 1.090909090909091,
    "nonLead": 140,
    "totalLines": 412,
    "exceedance": "",
    "latitude": 46.46894168,
    "longitude": -89.99618298,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005600&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000680",
    "name": "BEULAH, VILLAGE OF",
    "population": 380,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 308,
    "totalLines": 308,
    "exceedance": "2021",
    "latitude": 44.6417635,
    "longitude": -86.07146137,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000680&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000690",
    "name": "BEVERLY HILLS",
    "population": 10451,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 2,
    "unknown": 125,
    "totalToReplace": 127,
    "totalReplaced": 4,
    "percentReplaced": 3.0534351145038165,
    "nonLead": 3916,
    "totalLines": 4043,
    "exceedance": "2017",
    "latitude": 42.52182277,
    "longitude": -83.24035257,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000690&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000705",
    "name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "population": 622,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 244,
    "totalLines": 244,
    "exceedance": "",
    "latitude": 44.6503102,
    "longitude": -84.13502694,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000705&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000710",
    "name": "BIG RAPIDS",
    "population": 10403,
    "y2021": 49,
    "y2022": 0,
    "y2023": 135,
    "y2024": 0,
    "y2025": 6,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 64,
    "totalToReplace": 64,
    "totalReplaced": 190,
    "percentReplaced": 74.80314960629921,
    "nonLead": 2535,
    "totalLines": 2599,
    "exceedance": "",
    "latitude": 43.69135168,
    "longitude": -85.48697236,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000710&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000715",
    "name": "BINGHAM FARMS",
    "population": 888,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 369,
    "totalLines": 369,
    "exceedance": "",
    "latitude": 42.51727161,
    "longitude": -83.27749055,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000715&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000716",
    "name": "BINGHAM TOWNSHIP",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 56,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.92853646,
    "longitude": -84.45925506,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000716&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0000722",
    "name": "BIRCH RUN TOWNSHIP",
    "population": 2080,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 906,
    "totalLines": 906,
    "exceedance": "",
    "latitude": 43.26020624,
    "longitude": -83.7782678,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000722&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000720",
    "name": "BIRCH RUN, VILLAGE OF",
    "population": 1555,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 459,
    "totalLines": 459,
    "exceedance": "",
    "latitude": 43.26752898,
    "longitude": -83.79869862,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000720&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040082",
    "name": "BIRCHWOOD ESTATES",
    "population": 168,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 67,
    "totalLines": 67,
    "exceedance": "",
    "latitude": 42.12802214,
    "longitude": -85.2250604,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040082&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000725",
    "name": "BIRCHWOOD FARMS",
    "population": 1227,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 434,
    "totalLines": 434,
    "exceedance": "",
    "latitude": 45.45319856,
    "longitude": -85.04862816,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000725&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000730",
    "name": "BIRMINGHAM",
    "population": 20472,
    "y2021": 216,
    "y2022": 204,
    "y2023": 83,
    "y2024": 27,
    "y2025": 35,
    "leadLines": 153,
    "gpcl": 2,
    "unknown": 33,
    "totalToReplace": 188,
    "totalReplaced": 565,
    "percentReplaced": 75.0332005312085,
    "nonLead": 8968,
    "totalLines": 9156,
    "exceedance": "2019",
    "latitude": 42.54947187,
    "longitude": -83.21697719,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000730&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000731",
    "name": "BISHOP LAKE APARTMENTS",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.54737353,
    "longitude": -83.85241888,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000731&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000733",
    "name": "BLACK BEAR FARMS",
    "population": 110,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 101,
    "totalLines": 101,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000740",
    "name": "BLACKMAN TOWNSHIP",
    "population": 14817,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2858,
    "totalLines": 2858,
    "exceedance": "2020",
    "latitude": 42.2859678,
    "longitude": -84.43829767,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000740&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000743",
    "name": "BLAIR TOWNSHIP",
    "population": 2788,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1583,
    "totalLines": 1583,
    "exceedance": "",
    "latitude": 44.6774849,
    "longitude": -85.66447538,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000743&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000750",
    "name": "BLISSFIELD",
    "population": 3276,
    "y2021": 10,
    "y2022": 23,
    "y2023": 11,
    "y2024": 7,
    "y2025": 14,
    "leadLines": 718,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 718,
    "totalReplaced": 65,
    "percentReplaced": 8.301404853128991,
    "nonLead": 828,
    "totalLines": 1546,
    "exceedance": "",
    "latitude": 41.83217042,
    "longitude": -83.86548822,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000750&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000775",
    "name": "BLOOMFIELD HILLS",
    "population": 3540,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1488,
    "totalLines": 1488,
    "exceedance": "",
    "latitude": 42.57811073,
    "longitude": -83.24566234,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000775&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000790",
    "name": "BLOOMFIELD TOWNSHIP",
    "population": 41070,
    "y2021": 9,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 9,
    "percentReplaced": 100,
    "nonLead": 15150,
    "totalLines": 15150,
    "exceedance": "",
    "latitude": 42.57393292,
    "longitude": -83.28921806,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000790&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0003925",
    "name": "BLUE LAKE RESIDENCES",
    "population": 212,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 43.37091191,
    "longitude": -86.18599469,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003925&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000794",
    "name": "BLUE SPRUCE APARTMENTS",
    "population": 96,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": 42.86615262,
    "longitude": -84.91686448,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000794&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000795",
    "name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "population": 114,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 12,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000798",
    "name": "BLUMFIELDREESE WATER AUTH.",
    "population": 3024,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1533,
    "totalLines": 1533,
    "exceedance": "",
    "latitude": 43.45161389,
    "longitude": -83.69466807,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000798&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000799",
    "name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "population": 54,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": 45.50657042,
    "longitude": -84.93220387,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000799&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000800",
    "name": "BOYNE CITY, CITY OF",
    "population": 3735,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 64,
    "leadLines": 725,
    "gpcl": 355,
    "unknown": 0,
    "totalToReplace": 1080,
    "totalReplaced": 64,
    "percentReplaced": 5.594405594405594,
    "nonLead": 491,
    "totalLines": 1571,
    "exceedance": "",
    "latitude": 45.21064351,
    "longitude": -85.0065004,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000800&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000810",
    "name": "BOYNE FALLS, VILLAGE OF",
    "population": 370,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 160,
    "totalLines": 160,
    "exceedance": "",
    "latitude": 45.1697425,
    "longitude": -84.91353027,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000810&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000815",
    "name": "BOYNE MOUNTAIN RESORT",
    "population": 950,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 156,
    "totalLines": 156,
    "exceedance": "2023",
    "latitude": 45.18098348,
    "longitude": -84.94409612,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000815&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000820",
    "name": "BRECKENRIDGE, VILLAGE OF",
    "population": 1339,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 12,
    "totalToReplace": 12,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 598,
    "totalLines": 610,
    "exceedance": "",
    "latitude": 43.40685589,
    "longitude": -84.47745503,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000820&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001980",
    "name": "BREITUNG TWP.EAST KINGSFORD",
    "population": 1200,
    "y2021": 4,
    "y2022": 12,
    "y2023": 2,
    "y2024": 8,
    "y2025": 13,
    "leadLines": 203,
    "gpcl": 164,
    "unknown": 0,
    "totalToReplace": 367,
    "totalReplaced": 39,
    "percentReplaced": 9.60591133004926,
    "nonLead": 175,
    "totalLines": 542,
    "exceedance": "",
    "latitude": 45.82742452,
    "longitude": -87.96193454,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001980&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002450",
    "name": "BRIARCLIFF HOMEOWNERS ASSN",
    "population": 483,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 193,
    "totalLines": 193,
    "exceedance": "",
    "latitude": 42.53302665,
    "longitude": -83.34720123,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002450&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000840",
    "name": "BRIDGEPORT TOWNSHIP",
    "population": 10104,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4111,
    "totalLines": 4111,
    "exceedance": "",
    "latitude": 43.37038547,
    "longitude": -83.87972325,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000840&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000850",
    "name": "BRIDGMAN",
    "population": 2291,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1131,
    "totalLines": 1131,
    "exceedance": "",
    "latitude": 41.92652559,
    "longitude": -86.56176202,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000850&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000860",
    "name": "BRIGHTON, CITY OF",
    "population": 10210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3983,
    "totalLines": 3983,
    "exceedance": "",
    "latitude": 42.54673836,
    "longitude": -83.77551249,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000860&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000877",
    "name": "BRILEY TOWNSHIP",
    "population": 435,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 163,
    "totalLines": 163,
    "exceedance": "2018",
    "latitude": 45.00647468,
    "longitude": -84.15040814,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000877&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000890",
    "name": "BRITTON",
    "population": 611,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 280,
    "totalLines": 280,
    "exceedance": "",
    "latitude": 41.98860462,
    "longitude": -83.83099184,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000890&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000910",
    "name": "BRONSON",
    "population": 2421,
    "y2021": 0,
    "y2022": 4,
    "y2023": 4,
    "y2024": 13,
    "y2025": 12,
    "leadLines": 298,
    "gpcl": 319,
    "unknown": 0,
    "totalToReplace": 617,
    "totalReplaced": 33,
    "percentReplaced": 5.076923076923077,
    "nonLead": 320,
    "totalLines": 937,
    "exceedance": "",
    "latitude": 41.87312999,
    "longitude": -85.19421716,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000910&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000894",
    "name": "BROOK OF HOUGHTON LAKE",
    "population": 105,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.36294823,
    "longitude": -84.70096561,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000894&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000045",
    "name": "BROOKDALE ADRIAN",
    "population": 115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 152,
    "totalLines": 152,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000920",
    "name": "BROOKLYN",
    "population": 1313,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 579,
    "totalLines": 579,
    "exceedance": "",
    "latitude": 42.10396457,
    "longitude": -84.24188469,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000920&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040218",
    "name": "BROOMFIELD VALLEY",
    "population": 212,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 100,
    "totalToReplace": 100,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 27,
    "totalLines": 127,
    "exceedance": "",
    "latitude": 43.58917613,
    "longitude": -84.97703984,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040218&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000930",
    "name": "BROWN CITY",
    "population": 1316,
    "y2021": 5,
    "y2022": 0,
    "y2023": 1,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 4,
    "gpcl": 29,
    "unknown": 0,
    "totalToReplace": 33,
    "totalReplaced": 6,
    "percentReplaced": 15.384615384615385,
    "nonLead": 465,
    "totalLines": 498,
    "exceedance": "",
    "latitude": 43.21188418,
    "longitude": -82.98842243,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000930&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000940",
    "name": "BROWNSTOWN TOWNSHIP",
    "population": 33194,
    "y2021": 1,
    "y2022": 0,
    "y2023": 1,
    "y2024": 8,
    "y2025": 11,
    "leadLines": 7,
    "gpcl": 6,
    "unknown": 0,
    "totalToReplace": 13,
    "totalReplaced": 21,
    "percentReplaced": 61.76470588235294,
    "nonLead": 9019,
    "totalLines": 9032,
    "exceedance": "",
    "latitude": 42.14033888,
    "longitude": -83.26435283,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000940&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000951",
    "name": "BRUCE TOWNSHIP",
    "population": 115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 143,
    "totalLines": 143,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000960",
    "name": "BUCHANAN",
    "population": 4871,
    "y2021": 0,
    "y2022": 1,
    "y2023": 2,
    "y2024": 10,
    "y2025": 85,
    "leadLines": 132,
    "gpcl": 426,
    "unknown": 0,
    "totalToReplace": 558,
    "totalReplaced": 98,
    "percentReplaced": 14.939024390243901,
    "nonLead": 1267,
    "totalLines": 1825,
    "exceedance": "",
    "latitude": 41.8297245,
    "longitude": -86.36436436,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000960&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000970",
    "name": "BUCKLEY, VILLAGE OF",
    "population": 529,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 202,
    "totalLines": 202,
    "exceedance": "",
    "latitude": 44.49448611,
    "longitude": -85.67724577,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000970&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040051",
    "name": "BUENA VISTA ESTATES",
    "population": 79,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 44.72358029,
    "longitude": -85.82372489,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040051&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000980",
    "name": "BUENA VISTA TOWNSHIP",
    "population": 8676,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 1637,
    "totalToReplace": 1637,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1133,
    "totalLines": 2770,
    "exceedance": "",
    "latitude": 43.42327834,
    "longitude": -83.89121064,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000980&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001000",
    "name": "BURR OAK",
    "population": 828,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 272,
    "totalToReplace": 272,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 346,
    "exceedance": "",
    "latitude": 41.84709554,
    "longitude": -85.32278922,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001000&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002780",
    "name": "BURT TOWNSHIP",
    "population": 411,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 324,
    "totalLines": 324,
    "exceedance": "",
    "latitude": 46.66832991,
    "longitude": -85.98168505,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002780&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001005",
    "name": "BURT VIEW ASSOCIATION",
    "population": 42,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001008",
    "name": "BURTCHVILLE TOWNSHIP",
    "population": 2900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1237,
    "totalLines": 1237,
    "exceedance": "",
    "latitude": 43.122641,
    "longitude": -82.49158224,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001008&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001010",
    "name": "BURTON, CITY OF",
    "population": 21000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6751,
    "totalLines": 6751,
    "exceedance": "",
    "latitude": 42.99620105,
    "longitude": -83.62573487,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001010&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001015",
    "name": "BUTTERCUP SHORES",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 70,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0001018",
    "name": "BUTTERFIELD WOODS SUBDIVISION",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 35,
    "totalLines": 35,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001019",
    "name": "BYRAM RIDGE",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 105,
    "totalLines": 105,
    "exceedance": "",
    "latitude": 42.79537369,
    "longitude": -83.78813967,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001019&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001020",
    "name": "BYRON, VILLAGE OF",
    "population": 581,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 187,
    "totalToReplace": 187,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 236,
    "exceedance": "",
    "latitude": 42.83946926,
    "longitude": -83.93295151,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001020&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001023",
    "name": "BYRONGAINES UTILITY AUTHORITY",
    "population": 37464,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12600,
    "totalLines": 12600,
    "exceedance": "",
    "latitude": 42.82977359,
    "longitude": -85.66722702,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001023&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040093",
    "name": "C & M MOBILE HOME COURT",
    "population": 70,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 27,
    "totalLines": 27,
    "exceedance": "",
    "latitude": 41.77189293,
    "longitude": -86.05079904,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040093&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040599",
    "name": "CADGEWITH FARMS",
    "population": 344,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 226,
    "totalLines": 226,
    "exceedance": "",
    "latitude": 42.84745342,
    "longitude": -84.57578538,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040599&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001030",
    "name": "CADILLAC, CITY OF",
    "population": 10355,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 98,
    "unknown": 333,
    "totalToReplace": 431,
    "totalReplaced": 1,
    "percentReplaced": 0.23148148148148145,
    "nonLead": 3444,
    "totalLines": 3875,
    "exceedance": "",
    "latitude": 44.2506439,
    "longitude": -85.41206068,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001030&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001037",
    "name": "CALEDONIA ESTATES",
    "population": 160,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001039",
    "name": "CALEDONIA TOWNSHIP",
    "population": 4573,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1553,
    "totalLines": 1553,
    "exceedance": "",
    "latitude": 42.79961434,
    "longitude": -85.50454035,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001039&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001040",
    "name": "CALUMET",
    "population": 726,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 15,
    "totalToReplace": 15,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 320,
    "totalLines": 335,
    "exceedance": "",
    "latitude": 47.24253013,
    "longitude": -88.45188268,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001040&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001046",
    "name": "CALUMET TOWNSHIP",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 6,
    "totalToReplace": 6,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 59,
    "totalLines": 65,
    "exceedance": "",
    "latitude": 47.26997938,
    "longitude": -88.52171687,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001046&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040068",
    "name": "CAMBRIDGE VILLAGE",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 41.93719969,
    "longitude": -84.93608646,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040068&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001050",
    "name": "CAMDEN",
    "population": 512,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 236,
    "totalLines": 236,
    "exceedance": "",
    "latitude": 41.75437436,
    "longitude": -84.75671598,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001050&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001052",
    "name": "CAMP ARCADIA / LCA",
    "population": 400,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 59,
    "totalLines": 59,
    "exceedance": "",
    "latitude": 44.49200494,
    "longitude": -86.23563653,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001052&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040617",
    "name": "CANTERBURY ESTATES MHP",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 290,
    "totalLines": 290,
    "exceedance": "",
    "latitude": 42.94893699,
    "longitude": -85.06846587,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040617&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001100",
    "name": "CANTON TOWNSHIP",
    "population": 99627,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 26626,
    "totalLines": 26626,
    "exceedance": "",
    "latitude": 42.3095344,
    "longitude": -83.48670087,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001100&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001110",
    "name": "CAPAC, VILLAGE OF",
    "population": 1775,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 692,
    "totalLines": 692,
    "exceedance": "",
    "latitude": 43.0107052,
    "longitude": -82.9278321,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001110&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040675",
    "name": "CAPITAL CROSSINGS",
    "population": 345,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 299,
    "totalLines": 299,
    "exceedance": "",
    "latitude": 42.81130504,
    "longitude": -84.79080153,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040675&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001125",
    "name": "CARNEYNADEAU WATER & SEWER AUTHORITY",
    "population": 200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 87,
    "totalLines": 87,
    "exceedance": "",
    "latitude": 45.59022042,
    "longitude": -87.55476774,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001125&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040482",
    "name": "CARO RIVERVIEW MHP LLC",
    "population": 175,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 98,
    "totalLines": 98,
    "exceedance": "",
    "latitude": 43.47376288,
    "longitude": -83.40449476,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040482&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001130",
    "name": "CARO, CITY OF",
    "population": 5029,
    "y2021": 0,
    "y2022": 2,
    "y2023": 6,
    "y2024": 7,
    "y2025": 6,
    "leadLines": 29,
    "gpcl": 8,
    "unknown": 75,
    "totalToReplace": 112,
    "totalReplaced": 21,
    "percentReplaced": 15.789473684210526,
    "nonLead": 2083,
    "totalLines": 2195,
    "exceedance": "",
    "latitude": 43.48968493,
    "longitude": -83.40309751,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001130&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001160",
    "name": "CARROLLTON TOWNSHIP",
    "population": 6103,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 3,
    "unknown": 736,
    "totalToReplace": 739,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1677,
    "totalLines": 2416,
    "exceedance": "",
    "latitude": 43.46680606,
    "longitude": -83.94381805,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001160&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001170",
    "name": "CARSON CITY",
    "population": 3322,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 34,
    "leadLines": 33,
    "gpcl": 85,
    "unknown": 213,
    "totalToReplace": 331,
    "totalReplaced": 35,
    "percentReplaced": 9.562841530054644,
    "nonLead": 201,
    "totalLines": 532,
    "exceedance": "",
    "latitude": 43.1751996,
    "longitude": -84.85026501,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001170&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001180",
    "name": "CARSONVILLE, VILLAGE OF",
    "population": 527,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 259,
    "totalLines": 259,
    "exceedance": "",
    "latitude": 43.426039,
    "longitude": -82.67100169,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001180&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001195",
    "name": "CASEVILLE TOWNSHIP",
    "population": 2005,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1012,
    "totalLines": 1012,
    "exceedance": "",
    "latitude": 43.94553112,
    "longitude": -83.27170374,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001195&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001190",
    "name": "CASEVILLE, CITY OF",
    "population": 777,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 806,
    "totalLines": 806,
    "exceedance": "",
    "latitude": 43.91229445,
    "longitude": -83.37098726,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001190&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001210",
    "name": "CASPIAN",
    "population": 997,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 1,
    "percentReplaced": 100,
    "nonLead": 482,
    "totalLines": 482,
    "exceedance": "",
    "latitude": 46.06417135,
    "longitude": -88.6323917,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001210&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0001220",
    "name": "CASS CITY, VILLAGE OF",
    "population": 2428,
    "y2021": 20,
    "y2022": 19,
    "y2023": 6,
    "y2024": 5,
    "y2025": 11,
    "leadLines": 36,
    "gpcl": 248,
    "unknown": 0,
    "totalToReplace": 284,
    "totalReplaced": 61,
    "percentReplaced": 17.681159420289855,
    "nonLead": 714,
    "totalLines": 998,
    "exceedance": "",
    "latitude": 43.60141786,
    "longitude": -83.17593829,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001220&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005234",
    "name": "CASS COUNTY WATER SYSTEM",
    "population": 1350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 830,
    "totalLines": 830,
    "exceedance": "",
    "latitude": 41.89758512,
    "longitude": -85.92409936,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005234&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001230",
    "name": "CASS LAKESIDE SUBDIVISION",
    "population": 700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 15,
    "gpcl": 0,
    "unknown": 48,
    "totalToReplace": 63,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 183,
    "totalLines": 246,
    "exceedance": "",
    "latitude": 42.61120503,
    "longitude": -83.3860709,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001230&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001250",
    "name": "CASSOPOLIS",
    "population": 1815,
    "y2021": 2,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 274,
    "gpcl": 286,
    "unknown": 1,
    "totalToReplace": 561,
    "totalReplaced": 2,
    "percentReplaced": 0.3552397868561279,
    "nonLead": 210,
    "totalLines": 771,
    "exceedance": "",
    "latitude": 41.90988314,
    "longitude": -86.00526477,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001250&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001256",
    "name": "CECIL FARMS",
    "population": 200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 76,
    "totalLines": 76,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001258",
    "name": "CEDAR CREEK TOWNSHIP",
    "population": 124,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 53,
    "totalLines": 53,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001252",
    "name": "CEDAR CREEK WATER COMPANY",
    "population": 325,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 112,
    "totalLines": 112,
    "exceedance": "",
    "latitude": 44.80205601,
    "longitude": -85.6533862,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001252&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001253",
    "name": "CEDAR HILL ASSISTED LIVING",
    "population": 45,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "2021",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001260",
    "name": "CEDAR SPRINGS",
    "population": 3520,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 915,
    "totalLines": 915,
    "exceedance": "",
    "latitude": 43.20994948,
    "longitude": -85.55523123,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001260&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040375",
    "name": "CEDARBROOK ESTATES",
    "population": 1728,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 693,
    "totalLines": 693,
    "exceedance": "",
    "latitude": 42.61676272,
    "longitude": -83.50696795,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040375&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040619",
    "name": "CEDARFIELD MOBILE HOME PARK",
    "population": 480,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 209,
    "totalLines": 209,
    "exceedance": "",
    "latitude": 43.21204423,
    "longitude": -85.60397123,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040619&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001290",
    "name": "CENTER LINE, CITY OF",
    "population": 8257,
    "y2021": 2,
    "y2022": 5,
    "y2023": 47,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 298,
    "gpcl": 9,
    "unknown": 1617,
    "totalToReplace": 1924,
    "totalReplaced": 56,
    "percentReplaced": 2.8282828282828283,
    "nonLead": 880,
    "totalLines": 2804,
    "exceedance": "",
    "latitude": 42.8715791,
    "longitude": -82.92269844,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001290&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001300",
    "name": "CENTRAL LAKE, VILLAGE OF",
    "population": 952,
    "y2021": 2,
    "y2022": 5,
    "y2023": 2,
    "y2024": 2,
    "y2025": 8,
    "leadLines": 16,
    "gpcl": 65,
    "unknown": 131,
    "totalToReplace": 212,
    "totalReplaced": 19,
    "percentReplaced": 8.225108225108226,
    "nonLead": 383,
    "totalLines": 595,
    "exceedance": "",
    "latitude": 45.06556302,
    "longitude": -85.26065258,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001300&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001310",
    "name": "CENTREVILLE",
    "population": 1579,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 499,
    "totalLines": 499,
    "exceedance": "",
    "latitude": 41.92321403,
    "longitude": -85.52831889,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001310&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001325",
    "name": "CHALET DU PAW PAW CONDOMINIUMS",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 19,
    "totalLines": 19,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040125",
    "name": "CHALET ESTATES MOBILE HOME PARK",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001327",
    "name": "CHARLESTON TOWNSHIP",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001330",
    "name": "CHARLEVOIX",
    "population": 3124,
    "y2021": 1,
    "y2022": 5,
    "y2023": 9,
    "y2024": 19,
    "y2025": 13,
    "leadLines": 76,
    "gpcl": 164,
    "unknown": 979,
    "totalToReplace": 1219,
    "totalReplaced": 47,
    "percentReplaced": 3.7124802527646126,
    "nonLead": 965,
    "totalLines": 2184,
    "exceedance": "",
    "latitude": 45.31222949,
    "longitude": -85.27168591,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001330&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001335",
    "name": "CHARLEVOIX TOWNSHIP",
    "population": 1700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 84,
    "totalToReplace": 84,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 656,
    "totalLines": 740,
    "exceedance": "",
    "latitude": 45.31983391,
    "longitude": -85.24224332,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001335&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001340",
    "name": "CHARLOTTE, CITY OF",
    "population": 9074,
    "y2021": 34,
    "y2022": 25,
    "y2023": 75,
    "y2024": 28,
    "y2025": 26,
    "leadLines": 13,
    "gpcl": 459,
    "unknown": 425,
    "totalToReplace": 897,
    "totalReplaced": 188,
    "percentReplaced": 17.327188940092167,
    "nonLead": 2840,
    "totalLines": 3737,
    "exceedance": "",
    "latitude": 42.56781233,
    "longitude": -84.83461775,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001340&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000170",
    "name": "CHARTER TOWNSHIP OF ALPENA",
    "population": 5839,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2452,
    "totalLines": 2452,
    "exceedance": "",
    "latitude": 45.32739001,
    "longitude": -83.49147201,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000170&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001790",
    "name": "CHARTER TOWNSHIP OF DELTA",
    "population": 21856,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 9471,
    "totalLines": 9471,
    "exceedance": "",
    "latitude": 42.73958862,
    "longitude": -84.65586331,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001790&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002745",
    "name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "population": 21000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 2216,
    "totalToReplace": 2216,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5225,
    "totalLines": 7441,
    "exceedance": "",
    "latitude": 42.91971782,
    "longitude": -83.63210915,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002745&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001350",
    "name": "CHASSELL TOWNSHIP",
    "population": 800,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 355,
    "totalLines": 355,
    "exceedance": "",
    "latitude": 47.02833713,
    "longitude": -88.52374942,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001350&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001353",
    "name": "CHATEAUX DU LAC CONDOMINIUMS",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "2025",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001355",
    "name": "CHATHAM",
    "population": 300,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 139,
    "totalLines": 139,
    "exceedance": "",
    "latitude": 46.40693511,
    "longitude": -86.86381251,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001355&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001360",
    "name": "CHEBOYGAN, CITY OF",
    "population": 5500,
    "y2021": 3,
    "y2022": 0,
    "y2023": 0,
    "y2024": 12,
    "y2025": 98,
    "leadLines": 23,
    "gpcl": 52,
    "unknown": 1547,
    "totalToReplace": 1622,
    "totalReplaced": 113,
    "percentReplaced": 6.512968299711816,
    "nonLead": 367,
    "totalLines": 1989,
    "exceedance": "",
    "latitude": 45.63903326,
    "longitude": -84.47934407,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001360&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001370",
    "name": "CHELSEA",
    "population": 5474,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 16,
    "totalToReplace": 16,
    "totalReplaced": 1,
    "percentReplaced": 5.88235294117647,
    "nonLead": 2028,
    "totalLines": 2044,
    "exceedance": "",
    "latitude": 42.31104974,
    "longitude": -84.02050551,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001370&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001371",
    "name": "CHERRY CREEK VILLAGE",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001380",
    "name": "CHESANING, VILLAGE OF",
    "population": 2394,
    "y2021": 2,
    "y2022": 1,
    "y2023": 1,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 20,
    "gpcl": 8,
    "unknown": 652,
    "totalToReplace": 680,
    "totalReplaced": 4,
    "percentReplaced": 0.5847953216374269,
    "nonLead": 437,
    "totalLines": 1117,
    "exceedance": "",
    "latitude": 43.18505522,
    "longitude": -84.11817102,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001380&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001390",
    "name": "CHESTERFIELD TOWNSHIP",
    "population": 41650,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 16461,
    "totalLines": 16461,
    "exceedance": "",
    "latitude": 42.66991399,
    "longitude": -82.81255224,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001390&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001397",
    "name": "CHESTNUT HILLS",
    "population": 813,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 47,
    "totalLines": 47,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001400",
    "name": "CHIKAMING TOWNSHIP",
    "population": 2825,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3030,
    "totalLines": 3030,
    "exceedance": "",
    "latitude": 41.85747246,
    "longitude": -86.65478632,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001400&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040376",
    "name": "CHILDS LAKE ESTATES MHC",
    "population": 1548,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 619,
    "totalLines": 619,
    "exceedance": "",
    "latitude": 42.53468513,
    "longitude": -83.56938654,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040376&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001416",
    "name": "CHOCOLAY BUNGALOWS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 18,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 46.4961939,
    "longitude": -87.35606044,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001416&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040679",
    "name": "CIDERMILL CROSSINGS",
    "population": 1863,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 621,
    "totalLines": 621,
    "exceedance": "",
    "latitude": 42.70676869,
    "longitude": -83.77023148,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040679&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040339",
    "name": "CIRCLE DRIVE MOBILE HOME PARK",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 50,
    "unknown": 0,
    "totalToReplace": 50,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 50,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001420",
    "name": "CLARE, CITY OF",
    "population": 3118,
    "y2021": 60,
    "y2022": 0,
    "y2023": 7,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 67,
    "percentReplaced": 100,
    "nonLead": 1071,
    "totalLines": 1071,
    "exceedance": "2020",
    "latitude": 43.82216068,
    "longitude": -84.76500279,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001420&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0040377",
    "name": "CLARKSTON LAKE ESTATES",
    "population": 1245,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 498,
    "totalLines": 498,
    "exceedance": "",
    "latitude": 42.79813074,
    "longitude": -83.36780691,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040377&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001440",
    "name": "CLAWSON",
    "population": 11825,
    "y2021": 5,
    "y2022": 4,
    "y2023": 4,
    "y2024": 7,
    "y2025": 5,
    "leadLines": 561,
    "gpcl": 0,
    "unknown": 165,
    "totalToReplace": 726,
    "totalReplaced": 25,
    "percentReplaced": 3.3288948069241013,
    "nonLead": 4281,
    "totalLines": 5007,
    "exceedance": "",
    "latitude": 42.53670527,
    "longitude": -83.15236588,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001440&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001450",
    "name": "CLAY TOWNSHIP",
    "population": 9866,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4917,
    "totalLines": 4917,
    "exceedance": "",
    "latitude": 42.62956744,
    "longitude": -82.58633797,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001450&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006901",
    "name": "CLEAN WATER ASSOCIATION, INC.",
    "population": 22,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 15,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001460",
    "name": "CLIFFORD, VILLAGE OF",
    "population": 324,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 125,
    "totalLines": 125,
    "exceedance": "",
    "latitude": 43.31813047,
    "longitude": -83.17746023,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001460&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001465",
    "name": "CLIMAX",
    "population": 767,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 284,
    "totalLines": 284,
    "exceedance": "",
    "latitude": 42.23722732,
    "longitude": -85.33590575,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001465&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040248",
    "name": "CLIMAX MOBILE HOME PARK",
    "population": 198,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": 42.23935384,
    "longitude": -85.34918812,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040248&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001470",
    "name": "CLINTON",
    "population": 2336,
    "y2021": 5,
    "y2022": 8,
    "y2023": 44,
    "y2024": 30,
    "y2025": 19,
    "leadLines": 159,
    "gpcl": 30,
    "unknown": 44,
    "totalToReplace": 233,
    "totalReplaced": 106,
    "percentReplaced": 31.268436578171094,
    "nonLead": 663,
    "totalLines": 896,
    "exceedance": "",
    "latitude": 42.07089942,
    "longitude": -83.96569391,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001470&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040305",
    "name": "CLINTON ESTATES",
    "population": 68,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 29,
    "exceedance": "",
    "latitude": 42.08102994,
    "longitude": -84.42259245,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040305&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001480",
    "name": "CLINTON TOWNSHIP",
    "population": 100513,
    "y2021": 1,
    "y2022": 0,
    "y2023": 10,
    "y2024": 4,
    "y2025": 6,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 1724,
    "totalToReplace": 1724,
    "totalReplaced": 21,
    "percentReplaced": 1.2034383954154728,
    "nonLead": 25723,
    "totalLines": 27447,
    "exceedance": "",
    "latitude": 42.58559389,
    "longitude": -82.91853419,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001480&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001490",
    "name": "CLIO, CITY OF",
    "population": 2515,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 109,
    "unknown": 381,
    "totalToReplace": 490,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 330,
    "totalLines": 820,
    "exceedance": "",
    "latitude": 43.17585468,
    "longitude": -83.74254325,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001490&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001493",
    "name": "CLYDE TOWNSHIP",
    "population": 2400,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 794,
    "totalLines": 794,
    "exceedance": "",
    "latitude": 42.99924129,
    "longitude": -82.52623425,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001493&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040225",
    "name": "COACHMANS COVE",
    "population": 388,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 250,
    "totalLines": 250,
    "exceedance": "",
    "latitude": 42.15852501,
    "longitude": -84.18150231,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040225&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001500",
    "name": "COLDWATER",
    "population": 13822,
    "y2021": 23,
    "y2022": 62,
    "y2023": 86,
    "y2024": 170,
    "y2025": 255,
    "leadLines": 972,
    "gpcl": 97,
    "unknown": 0,
    "totalToReplace": 1069,
    "totalReplaced": 596,
    "percentReplaced": 35.7957957957958,
    "nonLead": 2399,
    "totalLines": 3468,
    "exceedance": "",
    "latitude": 41.94072055,
    "longitude": -84.99929729,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001500&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001520",
    "name": "COLEMAN, CITY OF",
    "population": 1243,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 4,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 5,
    "unknown": 0,
    "totalToReplace": 5,
    "totalReplaced": 5,
    "percentReplaced": 50,
    "nonLead": 548,
    "totalLines": 553,
    "exceedance": "",
    "latitude": 43.75921113,
    "longitude": -84.5891815,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001520&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040379",
    "name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "population": 405,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 343,
    "totalLines": 343,
    "exceedance": "",
    "latitude": 42.6366861,
    "longitude": -83.2172374,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040379&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001530",
    "name": "COLOMA",
    "population": 1555,
    "y2021": 6,
    "y2022": 3,
    "y2023": 3,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 12,
    "percentReplaced": 100,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.18833924,
    "longitude": -86.30342071,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001530&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0001535",
    "name": "COLOMA TOWNSHIP",
    "population": 1425,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 549,
    "totalLines": 549,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001572",
    "name": "COLOMBIERE CENTER",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001540",
    "name": "COLON",
    "population": 1190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 630,
    "totalLines": 630,
    "exceedance": "",
    "latitude": 41.95969764,
    "longitude": -85.32183756,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001540&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040094",
    "name": "COLONIAL ACRES",
    "population": 265,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 106,
    "totalLines": 106,
    "exceedance": "",
    "latitude": 41.79532697,
    "longitude": -86.04841577,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040094&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001552",
    "name": "COLONY BAY CONDOMINIUMS",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 25,
    "totalLines": 25,
    "exceedance": "2022",
    "latitude": 41.90211359,
    "longitude": -85.95870673,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001552&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001565",
    "name": "COLUMBIA LAKES ESTATES",
    "population": 700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 299,
    "totalLines": 299,
    "exceedance": "",
    "latitude": 42.5770776,
    "longitude": -84.50781105,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001565&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001570",
    "name": "COLUMBIAVILLE, VILLAGE OF",
    "population": 787,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 333,
    "totalLines": 333,
    "exceedance": "",
    "latitude": 43.1567747,
    "longitude": -83.40619134,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001570&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001573",
    "name": "COMMERCE TOWNSHIP",
    "population": 19811,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7066,
    "totalLines": 7066,
    "exceedance": "",
    "latitude": 42.57249098,
    "longitude": -83.4851016,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001573&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001580",
    "name": "CONCORD",
    "population": 1050,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 579,
    "totalLines": 579,
    "exceedance": "",
    "latitude": 42.17396826,
    "longitude": -84.64320299,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001580&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001600",
    "name": "CONSTANTINE",
    "population": 2075,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 63,
    "totalToReplace": 63,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 499,
    "totalLines": 620,
    "exceedance": "",
    "latitude": 41.83597827,
    "longitude": -85.66438647,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001600&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040126",
    "name": "CONWAY COMMONS MOBILE HOME PARK",
    "population": 165,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 200,
    "totalLines": 200,
    "exceedance": "",
    "latitude": 45.4286445,
    "longitude": -84.85261467,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040126&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001610",
    "name": "COOPERSVILLE",
    "population": 4519,
    "y2021": 5,
    "y2022": 14,
    "y2023": 33,
    "y2024": 18,
    "y2025": 7,
    "leadLines": 0,
    "gpcl": 8,
    "unknown": 0,
    "totalToReplace": 8,
    "totalReplaced": 77,
    "percentReplaced": 90.58823529411765,
    "nonLead": 1442,
    "totalLines": 1450,
    "exceedance": "",
    "latitude": 43.06581766,
    "longitude": -85.94084467,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001610&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001620",
    "name": "COPPER CITY",
    "population": 210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 125,
    "totalLines": 125,
    "exceedance": "",
    "latitude": 47.29067368,
    "longitude": -88.39101122,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001620&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001631",
    "name": "COPPER MEADOWS",
    "population": 128,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 51,
    "totalLines": 51,
    "exceedance": "",
    "latitude": 42.39435496,
    "longitude": -83.94992094,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001631&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060640",
    "name": "COREWELL HEALTHBERRIEN CNTR",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0070017",
    "name": "COREWELLHEALTH GR KALAMAZOO",
    "population": 165,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001640",
    "name": "CORUNNA, CITY OF",
    "population": 2028,
    "y2021": 2,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 885,
    "totalLines": 885,
    "exceedance": "",
    "latitude": 42.98573144,
    "longitude": -84.1181542,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001640&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0001643",
    "name": "COTTAGE COVE ON ELK LAKE",
    "population": 34,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 29,
    "exceedance": "",
    "latitude": 44.93080398,
    "longitude": -85.36942568,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001643&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005349",
    "name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "2022",
    "latitude": 45.42374504,
    "longitude": -84.89729956,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005349&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001650",
    "name": "COTTRELLVILLE TOWNSHIP",
    "population": 3200,
    "y2021": 0,
    "y2022": 1,
    "y2023": 1,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 798,
    "totalLines": 798,
    "exceedance": "",
    "latitude": 42.68718786,
    "longitude": -82.52141056,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001650&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0001655",
    "name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "population": 180,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 41.92265904,
    "longitude": -86.39396849,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001655&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040006",
    "name": "COUNTRY ACRES MOBILE HOME PARK",
    "population": 282,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 90,
    "totalToReplace": 90,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 23,
    "totalLines": 113,
    "exceedance": "",
    "latitude": 42.72438733,
    "longitude": -86.12642204,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040006&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004045",
    "name": "COUNTRY EDEN  L.L.C.",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": 44.75244736,
    "longitude": -85.69949375,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004045&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040591",
    "name": "COUNTRY HILL PINES",
    "population": 174,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 69,
    "totalLines": 69,
    "exceedance": "",
    "latitude": 43.26421506,
    "longitude": -82.64662703,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040591&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040488",
    "name": "COUNTRY HOLIDAY ESTATES",
    "population": 148,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 46,
    "totalLines": 46,
    "exceedance": "",
    "latitude": 42.30570306,
    "longitude": -85.96686275,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040488&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001648",
    "name": "COUNTRY LIVING ADULT FOSTER CARE",
    "population": 56,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "2018",
    "latitude": 41.84126079,
    "longitude": -84.51632075,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001648&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001653",
    "name": "COUNTRY LOG APTS",
    "population": 35,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 46.01499063,
    "longitude": -87.54987321,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001653&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040457",
    "name": "COUNTRY MANOR",
    "population": 87,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 45,
    "totalLines": 45,
    "exceedance": "",
    "latitude": 42.91149017,
    "longitude": -84.02653762,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040457&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040656",
    "name": "COUNTRY MANOR",
    "population": 190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 78,
    "totalLines": 78,
    "exceedance": "2024",
    "latitude": 43.73419574,
    "longitude": -85.49682507,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040656&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040193",
    "name": "COUNTRY MANOR M H P",
    "population": 98,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 41,
    "totalLines": 41,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040004",
    "name": "COUNTRY MEADOWS",
    "population": 158,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 63,
    "totalLines": 63,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040220",
    "name": "COUNTRY PLACE",
    "population": 115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 66,
    "exceedance": "",
    "latitude": 43.65796407,
    "longitude": -84.76424907,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040220&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001649",
    "name": "COUNTRY PLACE SENIOR CARE CENTER",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 43.72606017,
    "longitude": -85.30228818,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001649&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001657",
    "name": "COUNTRY VIEW MANOR CONDOS",
    "population": 62,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 9,
    "totalLines": 9,
    "exceedance": "2022",
    "latitude": 42.21310522,
    "longitude": -86.27750144,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001657&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040598",
    "name": "COUNTRY VIEW MOBILE HOME COMMUNITY",
    "population": 55,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 43,
    "totalLines": 43,
    "exceedance": "",
    "latitude": 41.78716796,
    "longitude": -85.82944042,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040598&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040306",
    "name": "COUNTRY VILLA ESTATES",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 58,
    "totalToReplace": 58,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 73,
    "exceedance": "",
    "latitude": 42.07243576,
    "longitude": -84.08361392,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040306&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040418",
    "name": "COUNTRY VILLAGE",
    "population": 78,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 32,
    "exceedance": "",
    "latitude": 42.82205714,
    "longitude": -85.83498705,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040418&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001652",
    "name": "COUNTRY VILLAGE APARTMENTS",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 41,
    "totalLines": 41,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040070",
    "name": "COUNTRYSIDE MOBILE COURT",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 41.81250613,
    "longitude": -84.97128676,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040070&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040450",
    "name": "COUNTRYSIDE VILLAGE",
    "population": 490,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 360,
    "totalLines": 360,
    "exceedance": "",
    "latitude": 42.80323956,
    "longitude": -84.2898191,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040450&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040649",
    "name": "COVENTRY WOODS MHC",
    "population": 823,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 195,
    "totalLines": 195,
    "exceedance": "2019",
    "latitude": 42.4355875,
    "longitude": -83.80283929,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040649&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001661",
    "name": "COVERT TOWNSHIP",
    "population": 1755,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 826,
    "totalLines": 826,
    "exceedance": "",
    "latitude": 42.2949131,
    "longitude": -86.2614037,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001661&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040382",
    "name": "CRANBERRY LAKE MHC",
    "population": 820,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 326,
    "totalLines": 326,
    "exceedance": "",
    "latitude": 42.65906805,
    "longitude": -83.47681512,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040382&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002274",
    "name": "CREEKSIDE AT FENTON HEIGHTS",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040119",
    "name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "population": 387,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 210,
    "totalLines": 210,
    "exceedance": "",
    "latitude": 42.97406443,
    "longitude": -84.56466542,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040119&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040183",
    "name": "CREEKSIDE MHC",
    "population": 70,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 41.95305618,
    "longitude": -84.63192236,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040183&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040425",
    "name": "CRICKLEWOOD COURT",
    "population": 155,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 63,
    "totalLines": 63,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040417",
    "name": "CROCKERY MOBILE HOME PARK",
    "population": 413,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 165,
    "totalLines": 165,
    "exceedance": "",
    "latitude": 43.09518857,
    "longitude": -86.13016637,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040417&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001664",
    "name": "CROCKERY TOWNSHIP",
    "population": 1847,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 508,
    "totalToReplace": 508,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 284,
    "totalLines": 792,
    "exceedance": "",
    "latitude": 43.08150991,
    "longitude": -86.07291217,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001664&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001666",
    "name": "CROOKED RIVER APARTMENTS",
    "population": 32,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.43355903,
    "longitude": -84.79421478,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001666&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001067",
    "name": "CROSSROADS FOR YOUTH",
    "population": 120,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001690",
    "name": "CROSWELL, CITY OF",
    "population": 2447,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 9,
    "y2025": 465,
    "leadLines": 5,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 5,
    "totalReplaced": 474,
    "percentReplaced": 98.95615866388309,
    "nonLead": 307,
    "totalLines": 312,
    "exceedance": "",
    "latitude": 43.27496914,
    "longitude": -82.61996391,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001690&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040357",
    "name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "population": 260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 104,
    "totalLines": 104,
    "exceedance": "",
    "latitude": 43.39896041,
    "longitude": -86.30699154,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040357&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001700",
    "name": "CRYSTAL FALLS",
    "population": 1922,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 38,
    "unknown": 0,
    "totalToReplace": 38,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 852,
    "totalLines": 890,
    "exceedance": "",
    "latitude": 46.09954301,
    "longitude": -88.33401053,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001700&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003880",
    "name": "CRYSTAL FALLS TOWNSHIP  LIND",
    "population": 990,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 1,
    "leadLines": 21,
    "gpcl": 0,
    "unknown": 217,
    "totalToReplace": 238,
    "totalReplaced": 3,
    "percentReplaced": 1.2448132780082988,
    "nonLead": 440,
    "totalLines": 678,
    "exceedance": "",
    "latitude": 46.08515961,
    "longitude": -88.41904047,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003880&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006630",
    "name": "CRYSTAL FALLS TWP  TOWNLINE",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 1,
    "leadLines": 21,
    "gpcl": 0,
    "unknown": 217,
    "totalToReplace": 238,
    "totalReplaced": 3,
    "percentReplaced": 1.2448132780082988,
    "nonLead": 440,
    "totalLines": 678,
    "exceedance": "",
    "latitude": 46.2031089,
    "longitude": -88.43833649,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006630&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001715",
    "name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 32,
    "exceedance": "",
    "latitude": 44.67342685,
    "longitude": -86.15586158,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001715&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001716",
    "name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "population": 700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 298,
    "totalLines": 298,
    "exceedance": "",
    "latitude": 44.50790422,
    "longitude": -85.97415526,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001716&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001694",
    "name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0061700",
    "name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "population": 76,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.03699011,
    "longitude": -85.68404262,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0061700&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001718",
    "name": "DANSVILLE, VILLAGE OF",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 69,
    "totalLines": 69,
    "exceedance": "",
    "latitude": 42.55315682,
    "longitude": -84.29980943,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001718&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001720",
    "name": "DAVISON, CITY OF",
    "population": 5000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1738,
    "totalLines": 1738,
    "exceedance": "",
    "latitude": 43.03179406,
    "longitude": -83.51862373,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001720&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001730",
    "name": "DEARBORN",
    "population": 109976,
    "y2021": 328,
    "y2022": 0,
    "y2023": 389,
    "y2024": 358,
    "y2025": 556,
    "leadLines": 7306,
    "gpcl": 0,
    "unknown": 2420,
    "totalToReplace": 9726,
    "totalReplaced": 1631,
    "percentReplaced": 14.361186933168971,
    "nonLead": 22998,
    "totalLines": 32724,
    "exceedance": "",
    "latitude": 42.31372265,
    "longitude": -83.21663898,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001730&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001740",
    "name": "DEARBORN HEIGHTS",
    "population": 57774,
    "y2021": 0,
    "y2022": 5,
    "y2023": 9,
    "y2024": 0,
    "y2025": 64,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 78,
    "percentReplaced": 100,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "2020",
    "latitude": 42.31640299,
    "longitude": -83.27687479,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001740&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0001750",
    "name": "DECATUR",
    "population": 1838,
    "y2021": 6,
    "y2022": 5,
    "y2023": 5,
    "y2024": 57,
    "y2025": 19,
    "leadLines": 285,
    "gpcl": 178,
    "unknown": 0,
    "totalToReplace": 463,
    "totalReplaced": 92,
    "percentReplaced": 16.576576576576578,
    "nonLead": 229,
    "totalLines": 692,
    "exceedance": "",
    "latitude": 42.11015301,
    "longitude": -85.97450184,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001750&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001760",
    "name": "DECKERVILLE, VILLAGE OF",
    "population": 830,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 408,
    "totalLines": 408,
    "exceedance": "",
    "latitude": 43.52692886,
    "longitude": -82.74104919,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001760&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001765",
    "name": "DEEPWATER POINTE ASSOCIATION",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 13,
    "totalLines": 13,
    "exceedance": "",
    "latitude": 44.79515368,
    "longitude": -85.49594862,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001765&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001774",
    "name": "DEER PARK CONDOMINIUMS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": 42.81338661,
    "longitude": -83.01291836,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001774&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001770",
    "name": "DEERFIELD",
    "population": 943,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 3,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 37,
    "unknown": 216,
    "totalToReplace": 253,
    "totalReplaced": 5,
    "percentReplaced": 1.937984496124031,
    "nonLead": 154,
    "totalLines": 407,
    "exceedance": "",
    "latitude": 41.89214362,
    "longitude": -83.77792592,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001770&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040644",
    "name": "DEERFIELD PINES MOBILE HOME PARK",
    "population": 308,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 123,
    "totalLines": 123,
    "exceedance": "",
    "latitude": 43.18927741,
    "longitude": -83.30507696,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040644&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001768",
    "name": "DEERFIELD VILLA",
    "population": 72,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 8,
    "exceedance": "",
    "latitude": 44.29421293,
    "longitude": -84.63301457,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001768&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001773",
    "name": "DEERWOOD SUBDIVISION",
    "population": 1824,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 1,
    "unknown": 3492,
    "totalToReplace": 3493,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2952,
    "totalLines": 6445,
    "exceedance": "",
    "latitude": 42.75098381,
    "longitude": -83.41601946,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001773&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001795",
    "name": "DETOUR",
    "population": 325,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 290,
    "totalLines": 290,
    "exceedance": "",
    "latitude": 45.99335175,
    "longitude": -83.90304399,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001795&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001800",
    "name": "DETROIT CITY OF",
    "population": 633218,
    "y2021": 204,
    "y2022": 2122,
    "y2023": 2827,
    "y2024": 7468,
    "y2025": 4680,
    "leadLines": 80595,
    "gpcl": 120,
    "unknown": 39073,
    "totalToReplace": 119788,
    "totalReplaced": 17301,
    "percentReplaced": 12.620268584642094,
    "nonLead": 131743,
    "totalLines": 251531,
    "exceedance": "",
    "latitude": 42.38713682,
    "longitude": -83.1077142,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001800&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001798",
    "name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "population": 6000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 47,
    "totalLines": 47,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001810",
    "name": "DEXTER",
    "population": 4500,
    "y2021": 0,
    "y2022": 7,
    "y2023": 2,
    "y2024": 1,
    "y2025": 6,
    "leadLines": 0,
    "gpcl": 42,
    "unknown": 328,
    "totalToReplace": 370,
    "totalReplaced": 16,
    "percentReplaced": 4.145077720207254,
    "nonLead": 1492,
    "totalLines": 1862,
    "exceedance": "",
    "latitude": 42.33175616,
    "longitude": -83.88276255,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001810&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0063477",
    "name": "DIMONDALE HEALTH CARE CENTER",
    "population": 177,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 108,
    "totalLines": 108,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040008",
    "name": "DOGWOOD MANOR MOBILE HOME PARK",
    "population": 190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 76,
    "totalLines": 76,
    "exceedance": "",
    "latitude": 42.60706774,
    "longitude": -86.06623295,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040008&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001845",
    "name": "DORRLEIGHTON",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 232,
    "totalLines": 232,
    "exceedance": "",
    "latitude": 42.73071013,
    "longitude": -85.71523006,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001845&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001860",
    "name": "DOWAGIAC",
    "population": 6350,
    "y2021": 3,
    "y2022": 3,
    "y2023": 6,
    "y2024": 47,
    "y2025": 26,
    "leadLines": 1068,
    "gpcl": 388,
    "unknown": 0,
    "totalToReplace": 1456,
    "totalReplaced": 85,
    "percentReplaced": 5.515898767034393,
    "nonLead": 1493,
    "totalLines": 2949,
    "exceedance": "2024",
    "latitude": 41.98127476,
    "longitude": -86.10617235,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001860&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001865",
    "name": "DRUMMOND ISLAND APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 46.01040514,
    "longitude": -83.75443764,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001865&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001870",
    "name": "DRYDEN, VILLAGE OF",
    "population": 1034,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 248,
    "totalToReplace": 248,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 79,
    "totalLines": 327,
    "exceedance": "",
    "latitude": 42.94558943,
    "longitude": -83.12399111,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001870&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040563",
    "name": "DUMONT CREEK ESTATES",
    "population": 188,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": 42.55887032,
    "longitude": -85.88981675,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040563&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001880",
    "name": "DUNDEE",
    "population": 5400,
    "y2021": 1,
    "y2022": 2,
    "y2023": 0,
    "y2024": 6,
    "y2025": 3,
    "leadLines": 5,
    "gpcl": 170,
    "unknown": 0,
    "totalToReplace": 175,
    "totalReplaced": 12,
    "percentReplaced": 6.417112299465241,
    "nonLead": 1726,
    "totalLines": 1901,
    "exceedance": "",
    "latitude": 41.9583199,
    "longitude": -83.66414684,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001880&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040045",
    "name": "DUNLOPS ORCHARD PARK",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 22,
    "totalLines": 22,
    "exceedance": "",
    "latitude": 42.49284881,
    "longitude": -85.54349292,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040045&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001905",
    "name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "population": 81,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 29,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001900",
    "name": "DURAND, CITY OF",
    "population": 3446,
    "y2021": 27,
    "y2022": 6,
    "y2023": 2,
    "y2024": 11,
    "y2025": 12,
    "leadLines": 302,
    "gpcl": 3,
    "unknown": 0,
    "totalToReplace": 305,
    "totalReplaced": 58,
    "percentReplaced": 15.977961432506888,
    "nonLead": 1219,
    "totalLines": 1524,
    "exceedance": "",
    "latitude": 42.91436035,
    "longitude": -83.99236287,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001900&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040116",
    "name": "DUTCH HILLS",
    "population": 620,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 276,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.77857071,
    "longitude": -84.4022484,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040116&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0001915",
    "name": "DUVERNAY PARK APARTMENTS",
    "population": 68,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": 44.03848317,
    "longitude": -85.68391512,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001915&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001920",
    "name": "EAGLE HARBOR TOWNSHIP",
    "population": 300,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 145,
    "totalLines": 145,
    "exceedance": "",
    "latitude": 47.43122469,
    "longitude": -88.12400341,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001920&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001925",
    "name": "EAGLE LAKE CONDOMINIUMS",
    "population": 26,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 16,
    "totalToReplace": 16,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 16,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 41.80127547,
    "longitude": -85.9924472,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001925&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040103",
    "name": "EAGLE LAKE ESTATES MHP",
    "population": 230,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 92,
    "totalLines": 92,
    "exceedance": "",
    "latitude": 41.80898615,
    "longitude": -86.03207246,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040103&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007285",
    "name": "EAGLE POINTE CONDOMINIUMS",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001932",
    "name": "EAGLE VILLAGE, INC.",
    "population": 84,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7,
    "totalLines": 7,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040615",
    "name": "EAGLES LANDING ESTATES",
    "population": 174,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 168,
    "totalLines": 168,
    "exceedance": "",
    "latitude": 43.26398176,
    "longitude": -82.71782965,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040615&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001935",
    "name": "EAST BAY CHARTER TOWNSHIP",
    "population": 3720,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1700,
    "totalLines": 1700,
    "exceedance": "",
    "latitude": 44.72745437,
    "longitude": -85.54751708,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001935&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040607",
    "name": "EAST BAY MOBILE HOME PARK",
    "population": 155,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001960",
    "name": "EAST GRAND RAPIDS",
    "population": 11637,
    "y2021": 65,
    "y2022": 47,
    "y2023": 86,
    "y2024": 180,
    "y2025": 235,
    "leadLines": 375,
    "gpcl": 58,
    "unknown": 1285,
    "totalToReplace": 1718,
    "totalReplaced": 613,
    "percentReplaced": 26.2977262977263,
    "nonLead": 2201,
    "totalLines": 3919,
    "exceedance": "",
    "latitude": 42.9552854,
    "longitude": -85.58176872,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001960&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001970",
    "name": "EAST JORDAN, CITY OF",
    "population": 2215,
    "y2021": 9,
    "y2022": 0,
    "y2023": 9,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 200,
    "unknown": 0,
    "totalToReplace": 200,
    "totalReplaced": 18,
    "percentReplaced": 8.256880733944955,
    "nonLead": 861,
    "totalLines": 1061,
    "exceedance": "",
    "latitude": 45.16079896,
    "longitude": -85.13007622,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001970&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001995",
    "name": "EAST LANSING MERIDIAN WATER AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0001990",
    "name": "EAST LANSING, CITY OF",
    "population": 33000,
    "y2021": 38,
    "y2022": 35,
    "y2023": 67,
    "y2024": 30,
    "y2025": 27,
    "leadLines": 105,
    "gpcl": 63,
    "unknown": 4971,
    "totalToReplace": 5139,
    "totalReplaced": 197,
    "percentReplaced": 3.691904047976012,
    "nonLead": 3228,
    "totalLines": 8367,
    "exceedance": "",
    "latitude": 42.74725833,
    "longitude": -84.48143804,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001990&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002010",
    "name": "EAST TAWAS, CITY OF",
    "population": 2808,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1395,
    "totalLines": 1395,
    "exceedance": "",
    "latitude": 44.28915542,
    "longitude": -83.47601938,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002010&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002292",
    "name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.70905907,
    "longitude": -83.97731743,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002292&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0001950",
    "name": "EASTPOINTE, CITY OF",
    "population": 32442,
    "y2021": 182,
    "y2022": 50,
    "y2023": 513,
    "y2024": 1084,
    "y2025": 158,
    "leadLines": 779,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 779,
    "totalReplaced": 1987,
    "percentReplaced": 71.83658712942878,
    "nonLead": 12725,
    "totalLines": 13504,
    "exceedance": "2023",
    "latitude": 42.46589058,
    "longitude": -82.94452315,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001950&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002025",
    "name": "EATON GREEN ESTATES SUBDIVISION",
    "population": 363,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 147,
    "totalLines": 147,
    "exceedance": "",
    "latitude": 42.54299851,
    "longitude": -84.79259434,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002025&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002020",
    "name": "EATON RAPIDS, CITY OF",
    "population": 5340,
    "y2021": 7,
    "y2022": 6,
    "y2023": 7,
    "y2024": 7,
    "y2025": 6,
    "leadLines": 1469,
    "gpcl": 0,
    "unknown": 446,
    "totalToReplace": 1915,
    "totalReplaced": 33,
    "percentReplaced": 1.6940451745379879,
    "nonLead": 451,
    "totalLines": 2366,
    "exceedance": "",
    "latitude": 42.50693635,
    "longitude": -84.65032519,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002020&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002030",
    "name": "EAU CLAIRE",
    "population": 610,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 262,
    "totalLines": 262,
    "exceedance": "2019",
    "latitude": 41.98602566,
    "longitude": -86.30360483,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002030&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002050",
    "name": "ECORSE",
    "population": 9512,
    "y2021": 54,
    "y2022": 196,
    "y2023": 166,
    "y2024": 0,
    "y2025": 142,
    "leadLines": 1815,
    "gpcl": 3,
    "unknown": 403,
    "totalToReplace": 2221,
    "totalReplaced": 558,
    "percentReplaced": 20.079165167326376,
    "nonLead": 1528,
    "totalLines": 3749,
    "exceedance": "",
    "latitude": 42.26063814,
    "longitude": -83.15129948,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002050&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002055",
    "name": "EDGE 72",
    "population": 288,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040359",
    "name": "EDGEWOOD MOBILE HOME PARK",
    "population": 162,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 46,
    "totalLines": 46,
    "exceedance": "",
    "latitude": 43.39374583,
    "longitude": -86.30254992,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040359&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002070",
    "name": "EDMORE",
    "population": 1256,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 1,
    "gpcl": 4,
    "unknown": 418,
    "totalToReplace": 423,
    "totalReplaced": 2,
    "percentReplaced": 0.4705882352941176,
    "nonLead": 157,
    "totalLines": 580,
    "exceedance": "",
    "latitude": 43.4048908,
    "longitude": -85.04180267,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002070&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002077",
    "name": "EDWARDSBURG",
    "population": 1260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 556,
    "totalLines": 556,
    "exceedance": "",
    "latitude": 41.7917824,
    "longitude": -86.09074876,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002077&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040600",
    "name": "EGELCRAFT MOBILE HOME PARK",
    "population": 1125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 455,
    "totalLines": 455,
    "exceedance": "",
    "latitude": 43.21649689,
    "longitude": -86.14352089,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040600&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002079",
    "name": "EL RANCHO ALANSON",
    "population": 274,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 139,
    "totalLines": 139,
    "exceedance": "2023",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002080",
    "name": "ELBERTA, VILLAGE OF",
    "population": 372,
    "y2021": 0,
    "y2022": 0,
    "y2023": 36,
    "y2024": 58,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 35,
    "unknown": 44,
    "totalToReplace": 79,
    "totalReplaced": 95,
    "percentReplaced": 54.59770114942529,
    "nonLead": 154,
    "totalLines": 233,
    "exceedance": "",
    "latitude": 44.61979619,
    "longitude": -86.23156196,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002080&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002090",
    "name": "ELK RAPIDS, VILLAGE OF",
    "population": 1642,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 10,
    "unknown": 0,
    "totalToReplace": 10,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1111,
    "totalLines": 1121,
    "exceedance": "",
    "latitude": 44.90075491,
    "longitude": -85.40225742,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002090&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002100",
    "name": "ELKTON, VILLAGE OF",
    "population": 808,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 1,
    "unknown": 0,
    "totalToReplace": 1,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 375,
    "totalLines": 376,
    "exceedance": "",
    "latitude": 43.80970885,
    "longitude": -83.159951,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002100&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002110",
    "name": "ELLSWORTH, VILLAGE OF",
    "population": 349,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 235,
    "totalLines": 235,
    "exceedance": "",
    "latitude": 45.1678388,
    "longitude": -85.24344295,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002110&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002115",
    "name": "ELMWOOD TOWNSHIP",
    "population": 255,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 44.79551986,
    "longitude": -85.64920196,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002115&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006625",
    "name": "ELMWOOD TWP  TIMBERLEE",
    "population": 510,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 127,
    "totalLines": 127,
    "exceedance": "",
    "latitude": 44.82532306,
    "longitude": -85.70044325,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006625&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002120",
    "name": "ELSIE, VILLAGE OF",
    "population": 966,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 49,
    "totalToReplace": 49,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 383,
    "totalLines": 432,
    "exceedance": "",
    "latitude": 43.0896197,
    "longitude": -84.38950868,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002120&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001820",
    "name": "ELY TOWNSHIPDIORITE",
    "population": 168,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 67,
    "totalLines": 67,
    "exceedance": "",
    "latitude": 46.47835764,
    "longitude": -87.89962829,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001820&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002860",
    "name": "ELY TOWNSHIPGREENWOOD",
    "population": 266,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 109,
    "totalLines": 109,
    "exceedance": "",
    "latitude": 46.48518934,
    "longitude": -87.75666325,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002860&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002124",
    "name": "EMERY PINES",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002125",
    "name": "EMMETT TOWNSHIP",
    "population": 2550,
    "y2021": 39,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 7,
    "unknown": 0,
    "totalToReplace": 7,
    "totalReplaced": 39,
    "percentReplaced": 84.78260869565217,
    "nonLead": 907,
    "totalLines": 914,
    "exceedance": "",
    "latitude": 42.29650688,
    "longitude": -85.15530926,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002125&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002130",
    "name": "EMPIRE, VILLAGE OF",
    "population": 400,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 92,
    "totalToReplace": 92,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 286,
    "totalLines": 378,
    "exceedance": "",
    "latitude": 44.81437492,
    "longitude": -86.05786451,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002130&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002170",
    "name": "ESCANABA",
    "population": 13659,
    "y2021": 87,
    "y2022": 240,
    "y2023": 240,
    "y2024": 655,
    "y2025": 701,
    "leadLines": 3572,
    "gpcl": 322,
    "unknown": 0,
    "totalToReplace": 3894,
    "totalReplaced": 1923,
    "percentReplaced": 33.058277462609595,
    "nonLead": 1486,
    "totalLines": 5380,
    "exceedance": "",
    "latitude": 45.74500176,
    "longitude": -87.07603121,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002170&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002180",
    "name": "ESSEXVILLE, CITY OF",
    "population": 3478,
    "y2021": 103,
    "y2022": 65,
    "y2023": 74,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 125,
    "totalToReplace": 125,
    "totalReplaced": 242,
    "percentReplaced": 65.9400544959128,
    "nonLead": 1415,
    "totalLines": 1540,
    "exceedance": "2020",
    "latitude": 43.61400188,
    "longitude": -83.83875357,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002180&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002190",
    "name": "EVART, CITY OF",
    "population": 1742,
    "y2021": 42,
    "y2022": 0,
    "y2023": 2,
    "y2024": 0,
    "y2025": 14,
    "leadLines": 156,
    "gpcl": 286,
    "unknown": 0,
    "totalToReplace": 442,
    "totalReplaced": 58,
    "percentReplaced": 11.600000000000001,
    "nonLead": 232,
    "totalLines": 674,
    "exceedance": "",
    "latitude": 43.89418915,
    "longitude": -85.28916946,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002190&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040484",
    "name": "EVERGREEN ESTATES",
    "population": 145,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 78,
    "totalLines": 78,
    "exceedance": "",
    "latitude": 43.46309991,
    "longitude": -83.43398164,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040484&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040206",
    "name": "EVERGREEN MOBILE HOME COMMUNITY",
    "population": 272,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 109,
    "totalLines": 109,
    "exceedance": "",
    "latitude": 43.01735961,
    "longitude": -85.07413681,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040206&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040250",
    "name": "EVERGREEN PARK",
    "population": 190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 76,
    "totalLines": 76,
    "exceedance": "",
    "latitude": 42.37122638,
    "longitude": -85.64286489,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040250&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040454",
    "name": "EVERGREEN PLEASANT VALLEY TRAILER PARK",
    "population": 94,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.94207898,
    "longitude": -83.22440746,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040454&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0002212",
    "name": "FAIRFIELD TOWNSHIP",
    "population": 717,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 260,
    "totalLines": 260,
    "exceedance": "",
    "latitude": 41.79461934,
    "longitude": -84.03777719,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002212&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040316",
    "name": "FAIRLANE ESTATES",
    "population": 88,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 60,
    "totalLines": 60,
    "exceedance": "",
    "latitude": 42.60109262,
    "longitude": -83.90963055,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040316&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040318",
    "name": "FAIRLAWN MEADOWS",
    "population": 57,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 42,
    "totalLines": 42,
    "exceedance": "",
    "latitude": 42.62178145,
    "longitude": -83.91334521,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040318&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002215",
    "name": "FAIRWAY LAKE CONDOMINIUMS",
    "population": 56,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 11,
    "totalLines": 11,
    "exceedance": "",
    "latitude": 44.91943644,
    "longitude": -84.64780334,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002215&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002240",
    "name": "FARMINGTON HILLS, CITY OF",
    "population": 56823,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 23250,
    "totalLines": 23250,
    "exceedance": "",
    "latitude": 42.48587311,
    "longitude": -83.37696706,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002240&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002230",
    "name": "FARMINGTON, CITY OF",
    "population": 11597,
    "y2021": 10,
    "y2022": 3,
    "y2023": 6,
    "y2024": 7,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 20,
    "unknown": 31,
    "totalToReplace": 51,
    "totalReplaced": 27,
    "percentReplaced": 34.61538461538461,
    "nonLead": 3368,
    "totalLines": 3419,
    "exceedance": "",
    "latitude": 42.46838859,
    "longitude": -83.40422254,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002230&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002250",
    "name": "FARWELL, VILLAGE OF",
    "population": 871,
    "y2021": 0,
    "y2022": 0,
    "y2023": 3,
    "y2024": 4,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 114,
    "unknown": 0,
    "totalToReplace": 114,
    "totalReplaced": 8,
    "percentReplaced": 6.557377049180328,
    "nonLead": 234,
    "totalLines": 348,
    "exceedance": "",
    "latitude": 43.83698756,
    "longitude": -84.86272164,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002250&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002260",
    "name": "FENNVILLE",
    "population": 1459,
    "y2021": 10,
    "y2022": 11,
    "y2023": 5,
    "y2024": 0,
    "y2025": 20,
    "leadLines": 53,
    "gpcl": 39,
    "unknown": 0,
    "totalToReplace": 92,
    "totalReplaced": 46,
    "percentReplaced": 33.33333333333333,
    "nonLead": 573,
    "totalLines": 665,
    "exceedance": "",
    "latitude": 42.60254682,
    "longitude": -86.08007899,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002260&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002273",
    "name": "FENTON HARBOR CONDOMINIUMS",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "2020",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040144",
    "name": "FENTON LAKEFRONT COMMUNITY LLC",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.8043913,
    "longitude": -83.86058655,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040144&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0002270",
    "name": "FENTON, CITY OF",
    "population": 11746,
    "y2021": 90,
    "y2022": 24,
    "y2023": 45,
    "y2024": 18,
    "y2025": 79,
    "leadLines": 0,
    "gpcl": 302,
    "unknown": 183,
    "totalToReplace": 485,
    "totalReplaced": 256,
    "percentReplaced": 34.54790823211876,
    "nonLead": 3511,
    "totalLines": 3996,
    "exceedance": "",
    "latitude": 42.81307381,
    "longitude": -83.72996205,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002270&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002280",
    "name": "FERNDALE",
    "population": 22105,
    "y2021": 555,
    "y2022": 611,
    "y2023": 501,
    "y2024": 516,
    "y2025": 148,
    "leadLines": 595,
    "gpcl": 72,
    "unknown": 6143,
    "totalToReplace": 6810,
    "totalReplaced": 2331,
    "percentReplaced": 25.500492287495895,
    "nonLead": 3145,
    "totalLines": 9955,
    "exceedance": "2020",
    "latitude": 42.45928869,
    "longitude": -83.13134293,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002280&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002285",
    "name": "FERRYSBURG",
    "population": 3268,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1546,
    "totalLines": 1546,
    "exceedance": "",
    "latitude": 43.08549365,
    "longitude": -86.22013077,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002285&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002287",
    "name": "FIFE LAKE TOWNHOUSES",
    "population": 54,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 44.598705,
    "longitude": -85.32247311,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002287&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002290",
    "name": "FILER CHARTER TOWNSHIP",
    "population": 940,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 418,
    "totalLines": 418,
    "exceedance": "",
    "latitude": 44.21946528,
    "longitude": -86.29279541,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002290&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002291",
    "name": "FILLMORE TOWNSHIP",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 29,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040302",
    "name": "FIRST POINT MOBILE COURT",
    "population": 110,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 53,
    "totalLines": 53,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002300",
    "name": "FLAT ROCK",
    "population": 10541,
    "y2021": 0,
    "y2022": 0,
    "y2023": 32,
    "y2024": 44,
    "y2025": 34,
    "leadLines": 178,
    "gpcl": 0,
    "unknown": 12,
    "totalToReplace": 190,
    "totalReplaced": 110,
    "percentReplaced": 36.666666666666664,
    "nonLead": 2807,
    "totalLines": 2997,
    "exceedance": "",
    "latitude": 42.09396593,
    "longitude": -83.27724523,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002300&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002310",
    "name": "FLINT, CITY OF",
    "population": 81252,
    "y2021": 214,
    "y2022": 122,
    "y2023": 247,
    "y2024": 62,
    "y2025": 382,
    "leadLines": 722,
    "gpcl": 120,
    "unknown": 3283,
    "totalToReplace": 4125,
    "totalReplaced": 1027,
    "percentReplaced": 19.934006211180126,
    "nonLead": 31914,
    "totalLines": 36039,
    "exceedance": "",
    "latitude": 43.02867211,
    "longitude": -83.68745504,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002310&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002340",
    "name": "FLUSHING, CITY OF",
    "population": 8311,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 5,
    "unknown": 0,
    "totalToReplace": 5,
    "totalReplaced": 5,
    "percentReplaced": 50,
    "nonLead": 3305,
    "totalLines": 3310,
    "exceedance": "",
    "latitude": 43.0698587,
    "longitude": -83.84147408,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002340&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002347",
    "name": "FONDA LAKE WATER AUTHORITY",
    "population": 1200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 581,
    "totalLines": 581,
    "exceedance": "",
    "latitude": 42.51324428,
    "longitude": -83.75274711,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002347&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000090",
    "name": "FORD FORESTRY CENTER",
    "population": 168,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 23,
    "totalLines": 23,
    "exceedance": "",
    "latitude": 46.64289762,
    "longitude": -88.48067977,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000090&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002350",
    "name": "FORD RIVER TOWNSHIP",
    "population": 385,
    "y2021": 1,
    "y2022": 1,
    "y2023": 0,
    "y2024": 1,
    "y2025": 4,
    "leadLines": 109,
    "gpcl": 2,
    "unknown": 0,
    "totalToReplace": 111,
    "totalReplaced": 7,
    "percentReplaced": 5.932203389830509,
    "nonLead": 90,
    "totalLines": 201,
    "exceedance": "",
    "latitude": 45.67693728,
    "longitude": -87.14523061,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002350&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002356",
    "name": "FORESTER TOWNSHIP",
    "population": 950,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 538,
    "totalLines": 538,
    "exceedance": "",
    "latitude": 43.5304017,
    "longitude": -82.58016757,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002356&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002360",
    "name": "FORESTVILLE VILLAGE OF",
    "population": 836,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 503,
    "totalLines": 503,
    "exceedance": "",
    "latitude": 43.69881121,
    "longitude": -82.61129568,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002360&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002370",
    "name": "FORSYTH TOWNSHIP",
    "population": 2479,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 104,
    "unknown": 123,
    "totalToReplace": 227,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 605,
    "totalLines": 832,
    "exceedance": "",
    "latitude": 46.28813429,
    "longitude": -87.44289129,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002370&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002385",
    "name": "FORT GRATIOT TOWNSHIP",
    "population": 11616,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4274,
    "totalLines": 4274,
    "exceedance": "",
    "latitude": 43.03707176,
    "longitude": -82.47816686,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002385&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002390",
    "name": "FOWLER, VILLAGE OF",
    "population": 1136,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 563,
    "totalLines": 563,
    "exceedance": "",
    "latitude": 43.00286317,
    "longitude": -84.74074649,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002390&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002400",
    "name": "FOWLERVILLE, VILLAGE OF",
    "population": 2951,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 162,
    "totalToReplace": 162,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 636,
    "totalLines": 798,
    "exceedance": "",
    "latitude": 42.65918007,
    "longitude": -84.07268975,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002400&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002403",
    "name": "FOXFIELD APARTMENTS",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 45.42255912,
    "longitude": -84.82613268,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002403&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002410",
    "name": "FRANKENLUST TOWNSHIP",
    "population": 3626,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1304,
    "totalLines": 1304,
    "exceedance": "",
    "latitude": 43.56193854,
    "longitude": -83.913491,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002410&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002425",
    "name": "FRANKENMUTH TOWNSHIP",
    "population": 1389,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 493,
    "totalLines": 493,
    "exceedance": "",
    "latitude": 43.39099661,
    "longitude": -83.75328504,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002425&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002420",
    "name": "FRANKENMUTH, CITY OF",
    "population": 4944,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2117,
    "totalLines": 2117,
    "exceedance": "",
    "latitude": 43.32857589,
    "longitude": -83.74523573,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002420&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002430",
    "name": "FRANKFORT, CITY OF",
    "population": 1286,
    "y2021": 38,
    "y2022": 0,
    "y2023": 9,
    "y2024": 8,
    "y2025": 10,
    "leadLines": 273,
    "gpcl": 3,
    "unknown": 0,
    "totalToReplace": 276,
    "totalReplaced": 65,
    "percentReplaced": 19.06158357771261,
    "nonLead": 607,
    "totalLines": 883,
    "exceedance": "",
    "latitude": 44.64447001,
    "longitude": -86.2325175,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002430&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002440",
    "name": "FRANKLIN KNOLLS SUBDIVISION",
    "population": 500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 157,
    "totalLines": 157,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005680",
    "name": "FRANKLIN TOWNSHIP",
    "population": 300,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 29,
    "exceedance": "",
    "latitude": 47.12770934,
    "longitude": -88.55395712,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005680&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005585",
    "name": "FRANKLINQUINCY WATER AUTHORITY",
    "population": 260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 43,
    "totalLines": 43,
    "exceedance": "",
    "latitude": 47.14316239,
    "longitude": -88.57189858,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005585&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002465",
    "name": "FRASER TOWNSHIP",
    "population": 1226,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 537,
    "totalLines": 537,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002460",
    "name": "FRASER, CITY OF",
    "population": 16500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 159,
    "totalToReplace": 159,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5203,
    "totalLines": 5362,
    "exceedance": "",
    "latitude": 42.53883371,
    "longitude": -82.94962084,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002460&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040438",
    "name": "FREELAND MOBILE HOME PARK",
    "population": 280,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 120,
    "totalLines": 120,
    "exceedance": "",
    "latitude": 43.56296413,
    "longitude": -84.17069476,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040438&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002480",
    "name": "FREEPORT",
    "population": 483,
    "y2021": 1,
    "y2022": 8,
    "y2023": 3,
    "y2024": 2,
    "y2025": 24,
    "leadLines": 0,
    "gpcl": 51,
    "unknown": 5,
    "totalToReplace": 56,
    "totalReplaced": 38,
    "percentReplaced": 40.42553191489361,
    "nonLead": 127,
    "totalLines": 183,
    "exceedance": "",
    "latitude": 42.77082131,
    "longitude": -85.31392957,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002480&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002490",
    "name": "FREMONT",
    "population": 4516,
    "y2021": 10,
    "y2022": 14,
    "y2023": 16,
    "y2024": 5,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 39,
    "unknown": 0,
    "totalToReplace": 39,
    "totalReplaced": 47,
    "percentReplaced": 54.65116279069767,
    "nonLead": 1504,
    "totalLines": 1543,
    "exceedance": "",
    "latitude": 43.46753388,
    "longitude": -85.94949676,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002490&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002500",
    "name": "FRENCHTOWN TOWNSHIP",
    "population": 16481,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6534,
    "totalLines": 6534,
    "exceedance": "",
    "latitude": 41.94527435,
    "longitude": -83.35987215,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002500&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002507",
    "name": "FRUITPORT TOWNSHIP",
    "population": 9355,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4721,
    "totalLines": 4721,
    "exceedance": "",
    "latitude": 43.1553059,
    "longitude": -86.17954813,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002507&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002510",
    "name": "GAASTRA",
    "population": 376,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 7,
    "y2025": 7,
    "leadLines": 7,
    "gpcl": 14,
    "unknown": 44,
    "totalToReplace": 65,
    "totalReplaced": 14,
    "percentReplaced": 17.72151898734177,
    "nonLead": 117,
    "totalLines": 182,
    "exceedance": "",
    "latitude": 46.06189646,
    "longitude": -88.59850136,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002510&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002520",
    "name": "GAGETOWN, VILLAGE OF",
    "population": 388,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 5,
    "y2025": 0,
    "leadLines": 18,
    "gpcl": 22,
    "unknown": 0,
    "totalToReplace": 40,
    "totalReplaced": 5,
    "percentReplaced": 11.11111111111111,
    "nonLead": 131,
    "totalLines": 171,
    "exceedance": "",
    "latitude": 43.65469863,
    "longitude": -83.24449113,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002520&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002530",
    "name": "GALESBURG",
    "population": 2377,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 4,
    "leadLines": 9,
    "gpcl": 23,
    "unknown": 0,
    "totalToReplace": 32,
    "totalReplaced": 5,
    "percentReplaced": 13.513513513513514,
    "nonLead": 778,
    "totalLines": 810,
    "exceedance": "",
    "latitude": 42.29273379,
    "longitude": -85.41820841,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002530&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002540",
    "name": "GARDEN",
    "population": 270,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 89,
    "totalToReplace": 89,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 150,
    "exceedance": "",
    "latitude": 45.77388011,
    "longitude": -86.57597041,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002540&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002550",
    "name": "GARDEN CITY",
    "population": 27625,
    "y2021": 7,
    "y2022": 37,
    "y2023": 68,
    "y2024": 29,
    "y2025": 60,
    "leadLines": 315,
    "gpcl": 0,
    "unknown": 577,
    "totalToReplace": 892,
    "totalReplaced": 201,
    "percentReplaced": 18.389752973467523,
    "nonLead": 10740,
    "totalLines": 11632,
    "exceedance": "2025",
    "latitude": 42.32423897,
    "longitude": -83.33936987,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002550&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002565",
    "name": "GARFIELD CHARTER TOWNSHIP",
    "population": 12899,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3101,
    "totalLines": 3101,
    "exceedance": "",
    "latitude": 44.72883337,
    "longitude": -85.64899891,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002565&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040174",
    "name": "GARFIELD OAKS",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 44.7310718,
    "longitude": -85.59623212,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040174&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002568",
    "name": "GARLAND RESORT",
    "population": 53,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7,
    "totalLines": 7,
    "exceedance": "",
    "latitude": 44.82918092,
    "longitude": -84.29027688,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002568&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002600",
    "name": "GAYLORD, CITY OF",
    "population": 3629,
    "y2021": 5,
    "y2022": 0,
    "y2023": 4,
    "y2024": 0,
    "y2025": 4,
    "leadLines": 176,
    "gpcl": 166,
    "unknown": 413,
    "totalToReplace": 755,
    "totalReplaced": 13,
    "percentReplaced": 1.6927083333333333,
    "nonLead": 1117,
    "totalLines": 1872,
    "exceedance": "",
    "latitude": 45.01935369,
    "longitude": -84.68142767,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002600&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000796",
    "name": "GENERAL WHITE APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.38611298,
    "longitude": -85.95312321,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000796&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002615",
    "name": "GENESEE COUNTY WATER SYSTEM",
    "population": 71500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 18693,
    "totalLines": 18693,
    "exceedance": "",
    "latitude": 43.03806192,
    "longitude": -83.68539177,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002615&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002617",
    "name": "GENESEE TOWNSHIP",
    "population": 8473,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1912,
    "totalLines": 1912,
    "exceedance": "",
    "latitude": 43.12644656,
    "longitude": -83.61485192,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002617&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002620",
    "name": "GEORGETOWN TOWNSHIP",
    "population": 41086,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15416,
    "totalLines": 15416,
    "exceedance": "",
    "latitude": 42.90487084,
    "longitude": -85.84144135,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002620&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002625",
    "name": "GERMFASK TOWNSHIP",
    "population": 200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 86,
    "totalLines": 86,
    "exceedance": "",
    "latitude": 46.24211704,
    "longitude": -85.92675111,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002625&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002630",
    "name": "GIBRALTAR",
    "population": 4997,
    "y2021": 1,
    "y2022": 1,
    "y2023": 1,
    "y2024": 1,
    "y2025": 34,
    "leadLines": 23,
    "gpcl": 2,
    "unknown": 0,
    "totalToReplace": 25,
    "totalReplaced": 38,
    "percentReplaced": 60.317460317460316,
    "nonLead": 1186,
    "totalLines": 1211,
    "exceedance": "",
    "latitude": 42.0878008,
    "longitude": -83.2059344,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002630&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002640",
    "name": "GLADSTONE",
    "population": 4632,
    "y2021": 11,
    "y2022": 7,
    "y2023": 11,
    "y2024": 20,
    "y2025": 3,
    "leadLines": 318,
    "gpcl": 15,
    "unknown": 0,
    "totalToReplace": 333,
    "totalReplaced": 52,
    "percentReplaced": 13.506493506493506,
    "nonLead": 1826,
    "totalLines": 2159,
    "exceedance": "",
    "latitude": 45.82305614,
    "longitude": -87.05429499,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002640&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0062653",
    "name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 44.11563587,
    "longitude": -84.46527851,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0062653&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002650",
    "name": "GLADWIN, CITY OF",
    "population": 2933,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 8,
    "totalToReplace": 8,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1208,
    "totalLines": 1216,
    "exceedance": "",
    "latitude": 43.9835511,
    "longitude": -84.48747598,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002650&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002654",
    "name": "GLEN DEVON CONDOMINIUMS",
    "population": 260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 42.85167167,
    "longitude": -83.74401693,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002654&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002656",
    "name": "GLEN MEADOWS CONDOMINIUMS",
    "population": 142,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 71,
    "totalLines": 71,
    "exceedance": "",
    "latitude": 45.02909895,
    "longitude": -84.73862852,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002656&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002657",
    "name": "GLEN OAKS COMMUNITY COLLEGE",
    "population": 1233,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 41.90278823,
    "longitude": -85.4806422,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002657&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002655",
    "name": "GLENN HAVEN SHORES",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 57,
    "totalLines": 57,
    "exceedance": "",
    "latitude": 42.50257,
    "longitude": -86.24340454,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002655&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002659",
    "name": "GLENNWOODS SUBDIVISION",
    "population": 77,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 34,
    "totalLines": 34,
    "exceedance": "2019",
    "latitude": 42.52045528,
    "longitude": -86.23327145,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002659&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040566",
    "name": "GLENWOOD ESTATES",
    "population": 585,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 186,
    "totalToReplace": 186,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 236,
    "exceedance": "",
    "latitude": 43.08510777,
    "longitude": -85.74441809,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040566&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002680",
    "name": "GOBLES",
    "population": 725,
    "y2021": 2,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 294,
    "totalLines": 294,
    "exceedance": "",
    "latitude": 42.36304199,
    "longitude": -85.87523162,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002680&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0002685",
    "name": "GOGEBIC RANGE WATER AUTH",
    "population": 177,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 76,
    "totalLines": 76,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040476",
    "name": "GOLDEN POND ESTATES",
    "population": 102,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": 41.92636327,
    "longitude": -85.75245492,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040476&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002730",
    "name": "GRAND BEACH",
    "population": 272,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 479,
    "totalLines": 479,
    "exceedance": "",
    "latitude": 41.77541657,
    "longitude": -86.78780886,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002730&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002740",
    "name": "GRAND BLANC, CITY OF",
    "population": 8276,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3184,
    "totalLines": 3184,
    "exceedance": "",
    "latitude": 42.92396729,
    "longitude": -83.61162066,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002740&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040419",
    "name": "GRAND COUNTRY",
    "population": 130,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 52,
    "exceedance": "",
    "latitude": 43.01108061,
    "longitude": -85.99685611,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040419&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002750",
    "name": "GRAND HAVEN",
    "population": 10412,
    "y2021": 10,
    "y2022": 26,
    "y2023": 191,
    "y2024": 12,
    "y2025": 48,
    "leadLines": 1223,
    "gpcl": 130,
    "unknown": 0,
    "totalToReplace": 1353,
    "totalReplaced": 287,
    "percentReplaced": 17.5,
    "nonLead": 3121,
    "totalLines": 4474,
    "exceedance": "",
    "latitude": 43.05308101,
    "longitude": -86.21851431,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002750&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002760",
    "name": "GRAND HAVEN TOWNSHIP",
    "population": 15051,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 1422,
    "gpcl": 116,
    "unknown": 0,
    "totalToReplace": 1538,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3225,
    "totalLines": 4763,
    "exceedance": "",
    "latitude": 43.02086349,
    "longitude": -86.18936176,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002760&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002770",
    "name": "GRAND LEDGE, CITY OF",
    "population": 8701,
    "y2021": 7,
    "y2022": 16,
    "y2023": 0,
    "y2024": 11,
    "y2025": 12,
    "leadLines": 4,
    "gpcl": 10,
    "unknown": 0,
    "totalToReplace": 14,
    "totalReplaced": 46,
    "percentReplaced": 76.66666666666667,
    "nonLead": 2967,
    "totalLines": 2981,
    "exceedance": "",
    "latitude": 42.74668248,
    "longitude": -84.75009624,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002770&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002785",
    "name": "GRAND POINTE SUBDIVISION",
    "population": 219,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 93,
    "totalLines": 93,
    "exceedance": "2025",
    "latitude": 42.66667551,
    "longitude": -84.64407627,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002785&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002790",
    "name": "GRAND RAPIDS",
    "population": 273005,
    "y2021": 640,
    "y2022": 946,
    "y2023": 2478,
    "y2024": 1419,
    "y2025": 1667,
    "leadLines": 19430,
    "gpcl": 0,
    "unknown": 394,
    "totalToReplace": 19824,
    "totalReplaced": 7150,
    "percentReplaced": 26.507006747238083,
    "nonLead": 60142,
    "totalLines": 79963,
    "exceedance": "",
    "latitude": 42.95054896,
    "longitude": -85.63455377,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002790&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002805",
    "name": "GRAND TRAVERSE CONDOMINIUMS",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 44.77480544,
    "longitude": -85.49730223,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002805&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002809",
    "name": "GRAND VALLEY ESTATES",
    "population": 288,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 104,
    "totalLines": 104,
    "exceedance": "",
    "latitude": 43.00183806,
    "longitude": -85.53366847,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002809&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040069",
    "name": "GRAND VILLAGE MOBILE HOME PARK",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 41.9284417,
    "longitude": -85.0688355,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040069&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002820",
    "name": "GRANDVILLE",
    "population": 15948,
    "y2021": 0,
    "y2022": 0,
    "y2023": 29,
    "y2024": 44,
    "y2025": 33,
    "leadLines": 0,
    "gpcl": 100,
    "unknown": 0,
    "totalToReplace": 100,
    "totalReplaced": 106,
    "percentReplaced": 51.45631067961165,
    "nonLead": 5347,
    "totalLines": 5447,
    "exceedance": "",
    "latitude": 42.88925974,
    "longitude": -85.75990451,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002820&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002823",
    "name": "GRANT",
    "population": 894,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 337,
    "totalLines": 337,
    "exceedance": "",
    "latitude": 43.33460771,
    "longitude": -85.80982494,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002823&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001630",
    "name": "GRANT TOWNSHIP  COPPER HARBOR",
    "population": 200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 114,
    "totalLines": 114,
    "exceedance": "",
    "latitude": 47.47259623,
    "longitude": -87.93603561,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001630&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002830",
    "name": "GRASS LAKE",
    "population": 1986,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 242,
    "totalToReplace": 242,
    "totalReplaced": 3,
    "percentReplaced": 1.2244897959183674,
    "nonLead": 394,
    "totalLines": 636,
    "exceedance": "",
    "latitude": 42.25153342,
    "longitude": -84.20433638,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002830&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002836",
    "name": "GRATIOT AREA WATER AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0002840",
    "name": "GRAYLING, CITY OF",
    "population": 1884,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 243,
    "unknown": 0,
    "totalToReplace": 243,
    "totalReplaced": 2,
    "percentReplaced": 0.8163265306122449,
    "nonLead": 503,
    "totalLines": 746,
    "exceedance": "",
    "latitude": 44.66129963,
    "longitude": -84.70834005,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002840&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002839",
    "name": "GREAT LAKES ADVENTIST ACADEMY",
    "population": 360,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 43.4059499,
    "longitude": -84.98018745,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002839&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002838",
    "name": "GREAT LAKES WATER AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only; no inventory submitted"
  },
  {
    "pwsid": "MI0040273",
    "name": "GREEN ACRES MOBILE HOME PARK",
    "population": 135,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 54,
    "totalLines": 54,
    "exceedance": "",
    "latitude": 43.22254139,
    "longitude": -85.71295906,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040273&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005395",
    "name": "GREEN BROOK ESTATES",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.59573707,
    "longitude": -83.8481101,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005395&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0002843",
    "name": "GREEN LAKE TOWNSHIP",
    "population": 1,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001543",
    "name": "GREEN OAK TWP  CENTENNIAL FARMS",
    "population": 900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 81,
    "totalLines": 81,
    "exceedance": "",
    "latitude": 42.46196976,
    "longitude": -83.7078206,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001543&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040352",
    "name": "GREENBRIER ESTATES",
    "population": 142,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 57,
    "totalLines": 57,
    "exceedance": "",
    "latitude": 43.12785663,
    "longitude": -85.26074701,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040352&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002837",
    "name": "GREENFIELD ESTATES",
    "population": 68,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 23,
    "totalLines": 23,
    "exceedance": "",
    "latitude": 42.68143812,
    "longitude": -86.01544702,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002837&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002846",
    "name": "GREENFIELD POINTE SUBDIVISION",
    "population": 265,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 98,
    "totalLines": 98,
    "exceedance": "",
    "latitude": 42.51590413,
    "longitude": -83.77013857,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002846&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040405",
    "name": "GREENLAWN MOBILE HOME COURT",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.50360768,
    "longitude": -86.34590272,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040405&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0002847",
    "name": "GREENS LAKE APARTMENTS",
    "population": 330,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002850",
    "name": "GREENVILLE",
    "population": 8816,
    "y2021": 20,
    "y2022": 0,
    "y2023": 40,
    "y2024": 7,
    "y2025": 20,
    "leadLines": 20,
    "gpcl": 1627,
    "unknown": 0,
    "totalToReplace": 1647,
    "totalReplaced": 87,
    "percentReplaced": 5.017301038062284,
    "nonLead": 1389,
    "totalLines": 3036,
    "exceedance": "",
    "latitude": 43.17851662,
    "longitude": -85.25760856,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002850&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002845",
    "name": "GREGG APARTMENTS",
    "population": 64,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002870",
    "name": "GROSSE ILE TOWNSHIP",
    "population": 10371,
    "y2021": 3,
    "y2022": 2,
    "y2023": 1,
    "y2024": 2,
    "y2025": 11,
    "leadLines": 28,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 28,
    "totalReplaced": 19,
    "percentReplaced": 40.42553191489361,
    "nonLead": 4004,
    "totalLines": 4032,
    "exceedance": "2025",
    "latitude": 42.13290305,
    "longitude": -83.15562186,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002870&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002890",
    "name": "GROSSE POINTE FARMS",
    "population": 9757,
    "y2021": 14,
    "y2022": 14,
    "y2023": 14,
    "y2024": 14,
    "y2025": 27,
    "leadLines": 244,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 244,
    "totalReplaced": 83,
    "percentReplaced": 25.382262996941897,
    "nonLead": 3815,
    "totalLines": 4059,
    "exceedance": "",
    "latitude": 42.40730501,
    "longitude": -82.89926314,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002890&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002900",
    "name": "GROSSE POINTE PARK",
    "population": 11555,
    "y2021": 2,
    "y2022": 6,
    "y2023": 7,
    "y2024": 81,
    "y2025": 79,
    "leadLines": 1999,
    "gpcl": 1,
    "unknown": 13,
    "totalToReplace": 2013,
    "totalReplaced": 175,
    "percentReplaced": 7.998171846435101,
    "nonLead": 2171,
    "totalLines": 4184,
    "exceedance": "",
    "latitude": 42.37934308,
    "longitude": -82.9297176,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002900&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002910",
    "name": "GROSSE POINTE SHORES",
    "population": 2929,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 6,
    "leadLines": 1,
    "gpcl": 0,
    "unknown": 689,
    "totalToReplace": 690,
    "totalReplaced": 6,
    "percentReplaced": 0.8620689655172413,
    "nonLead": 429,
    "totalLines": 1119,
    "exceedance": "",
    "latitude": 42.43868513,
    "longitude": -82.87846703,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002910&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002920",
    "name": "GROSSE POINTE WOODS",
    "population": 16135,
    "y2021": 3,
    "y2022": 36,
    "y2023": 25,
    "y2024": 4,
    "y2025": 20,
    "leadLines": 69,
    "gpcl": 35,
    "unknown": 6448,
    "totalToReplace": 6552,
    "totalReplaced": 88,
    "percentReplaced": 1.3253012048192772,
    "nonLead": 322,
    "totalLines": 6874,
    "exceedance": "2025",
    "latitude": 42.43743087,
    "longitude": -82.89740983,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002920&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002880",
    "name": "GROSSE POINTE, CITY OF",
    "population": 5421,
    "y2021": 24,
    "y2022": 0,
    "y2023": 35,
    "y2024": 26,
    "y2025": 2,
    "leadLines": 113,
    "gpcl": 5,
    "unknown": 1199,
    "totalToReplace": 1317,
    "totalReplaced": 87,
    "percentReplaced": 6.196581196581197,
    "nonLead": 868,
    "totalLines": 2185,
    "exceedance": "",
    "latitude": 42.38861962,
    "longitude": -82.90697014,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002880&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040384",
    "name": "GROVELAND MANOR",
    "population": 435,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 186,
    "totalLines": 186,
    "exceedance": "",
    "latitude": 42.84002143,
    "longitude": -83.56742274,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040384&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040046",
    "name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040044",
    "name": "GUN LAKE MOBILE HOME COMMUNITY",
    "population": 148,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 73,
    "totalLines": 73,
    "exceedance": "",
    "latitude": 42.58573526,
    "longitude": -85.52380939,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040044&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002926",
    "name": "GUN PLAIN TOWNSHIP",
    "population": 1,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 145,
    "totalLines": 145,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040029",
    "name": "GUN RIVER ESTATES WEST",
    "population": 152,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 61,
    "exceedance": "2018",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040011",
    "name": "GUN RIVER MOBILE ESTATES",
    "population": 415,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 168,
    "totalLines": 168,
    "exceedance": "",
    "latitude": 42.46931597,
    "longitude": -85.6417175,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040011&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040138",
    "name": "GUNTHER MOBILE HOME COURT INC",
    "population": 105,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.09490554,
    "longitude": -83.67252578,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040138&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0062942",
    "name": "HALE CREEK MANOR",
    "population": 43,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 44.37752041,
    "longitude": -83.80335637,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0062942&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002943",
    "name": "HALE HOMESTEAD APARTMENTS",
    "population": 72,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "2025",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040317",
    "name": "HAMBURG HILLS ESTATES",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 152,
    "totalLines": 152,
    "exceedance": "",
    "latitude": 42.45680381,
    "longitude": -83.90281477,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040317&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002944",
    "name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "population": 126,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 45,
    "totalToReplace": 45,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 44,
    "totalLines": 89,
    "exceedance": "",
    "latitude": 45.46848481,
    "longitude": -84.90368111,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002944&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002945",
    "name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "population": 133,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 76,
    "totalToReplace": 76,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 76,
    "exceedance": "",
    "latitude": 45.46986067,
    "longitude": -84.91736324,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002945&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040194",
    "name": "HAMLIN MOBILE HOME PARK",
    "population": 458,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 230,
    "totalLines": 230,
    "exceedance": "2020",
    "latitude": 42.63811785,
    "longitude": -84.15454604,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040194&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002960",
    "name": "HAMPTON TOWNSHIP",
    "population": 9652,
    "y2021": 6,
    "y2022": 0,
    "y2023": 7,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 48,
    "gpcl": 10,
    "unknown": 0,
    "totalToReplace": 58,
    "totalReplaced": 13,
    "percentReplaced": 18.30985915492958,
    "nonLead": 3587,
    "totalLines": 3645,
    "exceedance": "2019",
    "latitude": 43.59888082,
    "longitude": -83.81712394,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002960&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002970",
    "name": "HAMTRAMCK",
    "population": 22413,
    "y2021": 179,
    "y2022": 361,
    "y2023": 429,
    "y2024": 790,
    "y2025": 780,
    "leadLines": 793,
    "gpcl": 41,
    "unknown": 4551,
    "totalToReplace": 5385,
    "totalReplaced": 2539,
    "percentReplaced": 32.04189803129732,
    "nonLead": 840,
    "totalLines": 6225,
    "exceedance": "2021",
    "latitude": 42.3959584,
    "longitude": -83.05572626,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002970&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002980",
    "name": "HANCOCK",
    "population": 4500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 412,
    "totalToReplace": 412,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1430,
    "totalLines": 1842,
    "exceedance": "",
    "latitude": 47.13397293,
    "longitude": -88.59169746,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002980&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002982",
    "name": "HANDY TOWNSHIP  RED CEDARS CROSSING",
    "population": 1030,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 460,
    "totalLines": 460,
    "exceedance": "",
    "latitude": 42.67231575,
    "longitude": -84.08196029,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002982&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003000",
    "name": "HARBOR BEACH, CITY OF",
    "population": 1604,
    "y2021": 0,
    "y2022": 4,
    "y2023": 3,
    "y2024": 5,
    "y2025": 15,
    "leadLines": 0,
    "gpcl": 9,
    "unknown": 656,
    "totalToReplace": 665,
    "totalReplaced": 27,
    "percentReplaced": 3.901734104046243,
    "nonLead": 148,
    "totalLines": 813,
    "exceedance": "",
    "latitude": 43.84141007,
    "longitude": -82.65157825,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003000&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003001",
    "name": "HARBOR COVE APARTMENTS",
    "population": 288,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 12,
    "exceedance": "",
    "latitude": 42.41915163,
    "longitude": -83.76112876,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003001&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003005",
    "name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 10,
    "totalToReplace": 10,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 25,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003015",
    "name": "HARBOR SPRINGS AREA AUTHORITY",
    "population": 303,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 22,
    "totalLines": 22,
    "exceedance": "",
    "latitude": 45.45287962,
    "longitude": -84.90342069,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003015&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003010",
    "name": "HARBOR SPRINGS, CITY OF",
    "population": 1194,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1343,
    "totalLines": 1343,
    "exceedance": "",
    "latitude": 45.43367812,
    "longitude": -84.99236945,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003010&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040369",
    "name": "HARDY PARK",
    "population": 140,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 23,
    "leadLines": 0,
    "gpcl": 56,
    "unknown": 0,
    "totalToReplace": 56,
    "totalReplaced": 23,
    "percentReplaced": 29.11392405063291,
    "nonLead": 0,
    "totalLines": 56,
    "exceedance": "",
    "latitude": 43.45584435,
    "longitude": -85.65419236,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040369&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003018",
    "name": "HARING CHARTER TOWNSHIP",
    "population": 839,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 349,
    "totalLines": 349,
    "exceedance": "",
    "latitude": 44.28440262,
    "longitude": -85.40673665,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003018&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003020",
    "name": "HARPER WOODS",
    "population": 14236,
    "y2021": 8,
    "y2022": 10,
    "y2023": 10,
    "y2024": 0,
    "y2025": 92,
    "leadLines": 152,
    "gpcl": 720,
    "unknown": 1597,
    "totalToReplace": 2469,
    "totalReplaced": 120,
    "percentReplaced": 4.634994206257242,
    "nonLead": 4001,
    "totalLines": 6470,
    "exceedance": "2023",
    "latitude": 42.43927666,
    "longitude": -82.9318358,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003020&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003040",
    "name": "HARRISON TOWNSHIP",
    "population": 24314,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8790,
    "totalLines": 8790,
    "exceedance": "",
    "latitude": 42.57833005,
    "longitude": -82.83523417,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003040&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003030",
    "name": "HARRISON, CITY OF",
    "population": 1100,
    "y2021": 0,
    "y2022": 2,
    "y2023": 17,
    "y2024": 5,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 114,
    "unknown": 45,
    "totalToReplace": 159,
    "totalReplaced": 24,
    "percentReplaced": 13.114754098360656,
    "nonLead": 636,
    "totalLines": 795,
    "exceedance": "",
    "latitude": 44.01716284,
    "longitude": -84.80401365,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003030&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003050",
    "name": "HARRISVILLE, CITY OF",
    "population": 493,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 2,
    "gpcl": 87,
    "unknown": 0,
    "totalToReplace": 89,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 261,
    "totalLines": 350,
    "exceedance": "",
    "latitude": 44.64284917,
    "longitude": -83.29966422,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003050&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003060",
    "name": "HART",
    "population": 2126,
    "y2021": 5,
    "y2022": 0,
    "y2023": 7,
    "y2024": 53,
    "y2025": 2,
    "leadLines": 438,
    "gpcl": 250,
    "unknown": 0,
    "totalToReplace": 688,
    "totalReplaced": 67,
    "percentReplaced": 8.874172185430464,
    "nonLead": 218,
    "totalLines": 906,
    "exceedance": "",
    "latitude": 43.6956893,
    "longitude": -86.36894323,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003060&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003070",
    "name": "HARTFORD",
    "population": 2688,
    "y2021": 0,
    "y2022": 0,
    "y2023": 25,
    "y2024": 0,
    "y2025": 14,
    "leadLines": 283,
    "gpcl": 340,
    "unknown": 0,
    "totalToReplace": 623,
    "totalReplaced": 39,
    "percentReplaced": 5.8912386706948645,
    "nonLead": 282,
    "totalLines": 905,
    "exceedance": "",
    "latitude": 42.20788985,
    "longitude": -86.16440387,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003070&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003073",
    "name": "HARTLAND HILLS CONDOMINIUMS",
    "population": 67,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040654",
    "name": "HARTLAND MEADOWS",
    "population": 1543,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 617,
    "totalLines": 617,
    "exceedance": "",
    "latitude": 42.62787186,
    "longitude": -83.69083859,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040654&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003075",
    "name": "HARTLAND TOWNSHIP",
    "population": 3022,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 505,
    "totalLines": 505,
    "exceedance": "",
    "latitude": 42.6333649,
    "longitude": -83.76368572,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003075&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040620",
    "name": "HARTWICK PINES ESTATES",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 49,
    "exceedance": "",
    "latitude": 44.78119229,
    "longitude": -84.75259287,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040620&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003080",
    "name": "HARVEST HILLS SUBDIVISION ASSO",
    "population": 225,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 85,
    "totalLines": 85,
    "exceedance": "",
    "latitude": 42.53202956,
    "longitude": -83.74516126,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003080&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003090",
    "name": "HASTINGS",
    "population": 7350,
    "y2021": 9,
    "y2022": 7,
    "y2023": 34,
    "y2024": 62,
    "y2025": 92,
    "leadLines": 783,
    "gpcl": 767,
    "unknown": 0,
    "totalToReplace": 1550,
    "totalReplaced": 204,
    "percentReplaced": 11.630558722919043,
    "nonLead": 1113,
    "totalLines": 2663,
    "exceedance": "",
    "latitude": 42.64936563,
    "longitude": -85.2910326,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003090&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040343",
    "name": "HAVEN VIEW MOBILE COURT",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 82,
    "totalLines": 82,
    "exceedance": "",
    "latitude": 43.73450323,
    "longitude": -85.50635454,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040343&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003100",
    "name": "HAZEL PARK",
    "population": 16400,
    "y2021": 32,
    "y2022": 29,
    "y2023": 31,
    "y2024": 80,
    "y2025": 86,
    "leadLines": 568,
    "gpcl": 0,
    "unknown": 1718,
    "totalToReplace": 2286,
    "totalReplaced": 258,
    "percentReplaced": 10.141509433962264,
    "nonLead": 4776,
    "totalLines": 7062,
    "exceedance": "2020",
    "latitude": 42.46181683,
    "longitude": -83.09754109,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003100&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040680",
    "name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 197,
    "totalLines": 197,
    "exceedance": "",
    "latitude": 45.40175044,
    "longitude": -84.87289318,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040680&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000200",
    "name": "HEMATITE TOWNSHIP",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 46.2330461,
    "longitude": -88.4504433,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000200&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003115",
    "name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 68,
    "totalLines": 68,
    "exceedance": "",
    "latitude": 45.25415782,
    "longitude": -85.17052562,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003115&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003110",
    "name": "HEMLOCK/RICHLAND TOWNSHIP",
    "population": 1632,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 604,
    "totalLines": 604,
    "exceedance": "",
    "latitude": 43.42545979,
    "longitude": -84.2063546,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003110&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003117",
    "name": "HERITAGE APARTMENTS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.55632329,
    "longitude": -83.47459165,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003117&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003118",
    "name": "HERITAGE DRIVE APARTMENTS",
    "population": 41,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 46.54174901,
    "longitude": -87.57338673,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003118&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040333",
    "name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 30,
    "totalLines": 30,
    "exceedance": "",
    "latitude": 43.89055172,
    "longitude": -86.4002488,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040333&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003120",
    "name": "HERMANSVILLE HOUSING COMM.",
    "population": 36,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "2025",
    "latitude": 45.70830965,
    "longitude": -87.60704734,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003120&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003130",
    "name": "HESPERIA",
    "population": 954,
    "y2021": 3,
    "y2022": 0,
    "y2023": 7,
    "y2024": 0,
    "y2025": 106,
    "leadLines": 187,
    "gpcl": 46,
    "unknown": 83,
    "totalToReplace": 316,
    "totalReplaced": 116,
    "percentReplaced": 26.851851851851855,
    "nonLead": 36,
    "totalLines": 410,
    "exceedance": "",
    "latitude": 43.56913125,
    "longitude": -86.03424435,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003130&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040587",
    "name": "HESPERIA MHP LLC",
    "population": 248,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 99,
    "totalLines": 99,
    "exceedance": "",
    "latitude": 43.66066865,
    "longitude": -86.07729695,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040587&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040370",
    "name": "HESS LAKE RV AND MOBILE HOME PARK",
    "population": 160,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "2023",
    "latitude": 43.39268629,
    "longitude": -85.7698822,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040370&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040084",
    "name": "HICKORY HILLS",
    "population": 708,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 286,
    "totalLines": 286,
    "exceedance": "",
    "latitude": 42.22209652,
    "longitude": -85.17642475,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040084&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040469",
    "name": "HICKORY LANE MOBILE HOME PARK",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 32,
    "exceedance": "",
    "latitude": 41.91817647,
    "longitude": -85.66493177,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040469&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040682",
    "name": "HIDDEN CREEK ESTATES",
    "population": 318,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 209,
    "totalLines": 209,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003131",
    "name": "HIDDEN GLEN APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.89402528,
    "longitude": -84.34796272,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003131&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003132",
    "name": "HIDDEN HAMLET ASSOCIATION",
    "population": 465,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 156,
    "totalLines": 156,
    "exceedance": "2023",
    "latitude": 45.47472392,
    "longitude": -84.91031799,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003132&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040386",
    "name": "HIDDEN LAKE ESTATES",
    "population": 673,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 269,
    "totalLines": 269,
    "exceedance": "",
    "latitude": 42.80734903,
    "longitude": -83.14655333,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040386&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003137",
    "name": "HIDDEN LAKES OF GREEN OAKS",
    "population": 759,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 372,
    "totalLines": 372,
    "exceedance": "",
    "latitude": 42.45452615,
    "longitude": -83.72488089,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003137&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005819",
    "name": "HIDDEN SHORES WEST",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 42.5115656,
    "longitude": -83.71555244,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005819&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040208",
    "name": "HIDDEN VALLEY",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 42.99302877,
    "longitude": -84.99851275,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040208&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003134",
    "name": "HIGHFIELDS YOUTH CAMP",
    "population": 96,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 9,
    "totalLines": 9,
    "exceedance": "",
    "latitude": 42.43311708,
    "longitude": -84.53082758,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003134&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040387",
    "name": "HIGHLAND GREENS ESTATES",
    "population": 2268,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 879,
    "totalLines": 879,
    "exceedance": "",
    "latitude": 42.62250601,
    "longitude": -83.57956481,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040387&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003138",
    "name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.64648474,
    "longitude": -83.57879679,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003138&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040388",
    "name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "population": 260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 306,
    "totalLines": 306,
    "exceedance": "",
    "latitude": 42.6384348,
    "longitude": -83.6572547,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040388&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003139",
    "name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003140",
    "name": "HIGHLAND PARK",
    "population": 8977,
    "y2021": 59,
    "y2022": 365,
    "y2023": 12,
    "y2024": 12,
    "y2025": 412,
    "leadLines": 2828,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 2828,
    "totalReplaced": 860,
    "percentReplaced": 23.318872017353577,
    "nonLead": 686,
    "totalLines": 3514,
    "exceedance": "2019",
    "latitude": 42.40522431,
    "longitude": -83.09761986,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003140&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003312",
    "name": "HIGHLAND TOWNSHIP",
    "population": 3786,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1194,
    "totalLines": 1194,
    "exceedance": "",
    "latitude": 42.64824698,
    "longitude": -83.62258683,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003312&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000813",
    "name": "HIGHLANDS AT HARBOR SPRINGS",
    "population": 450,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 192,
    "totalLines": 192,
    "exceedance": "",
    "latitude": 45.48475852,
    "longitude": -84.92823092,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000813&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040231",
    "name": "HILLANLAKE VILLAGE",
    "population": 372,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 151,
    "exceedance": "",
    "latitude": 42.09089057,
    "longitude": -84.19539328,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040231&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003160",
    "name": "HILLMAN, VILLAGE OF",
    "population": 697,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 339,
    "totalLines": 339,
    "exceedance": "",
    "latitude": 45.07193394,
    "longitude": -83.91619094,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003160&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040057",
    "name": "HILLS HAVEN MOBILE HOME PARK",
    "population": 235,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 94,
    "totalLines": 94,
    "exceedance": "",
    "latitude": 41.87951807,
    "longitude": -86.3596267,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040057&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003165",
    "name": "HILLS OF WALLOON ASSOCIATION",
    "population": 87,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 30,
    "totalToReplace": 30,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 33,
    "exceedance": "2018",
    "latitude": 45.31037494,
    "longitude": -85.03432427,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003165&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003170",
    "name": "HILLSDALE",
    "population": 8163,
    "y2021": 49,
    "y2022": 21,
    "y2023": 127,
    "y2024": 88,
    "y2025": 91,
    "leadLines": 211,
    "gpcl": 694,
    "unknown": 0,
    "totalToReplace": 905,
    "totalReplaced": 376,
    "percentReplaced": 29.352068696330992,
    "nonLead": 1677,
    "totalLines": 2582,
    "exceedance": "",
    "latitude": 41.92500977,
    "longitude": -84.63604665,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003170&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040180",
    "name": "HILLSIDE ACRES",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 44,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 41.88620155,
    "longitude": -84.69402421,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040180&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003175",
    "name": "HILLVIEW ESTATES SUBDIVISION",
    "population": 354,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 1,
    "unknown": 3492,
    "totalToReplace": 3493,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2952,
    "totalLines": 6445,
    "exceedance": "",
    "latitude": 42.78226309,
    "longitude": -83.33449133,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003175&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040122",
    "name": "HIWAY MOBILE HAVEN",
    "population": 168,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 67,
    "totalLines": 67,
    "exceedance": "",
    "latitude": 42.59980502,
    "longitude": -84.77556648,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040122&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040344",
    "name": "HOLIDAY TERRACE",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 38,
    "totalLines": 38,
    "exceedance": "",
    "latitude": 43.61592786,
    "longitude": -85.32003228,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040344&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040335",
    "name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "population": 185,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 43.95357361,
    "longitude": -86.32439316,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040335&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003190",
    "name": "HOLLAND BOARD OF PUBLIC WORKS",
    "population": 49687,
    "y2021": 71,
    "y2022": 113,
    "y2023": 118,
    "y2024": 86,
    "y2025": 107,
    "leadLines": 1728,
    "gpcl": 1468,
    "unknown": 202,
    "totalToReplace": 3398,
    "totalReplaced": 495,
    "percentReplaced": 12.715129720010273,
    "nonLead": 14226,
    "totalLines": 17624,
    "exceedance": "",
    "latitude": 42.77563265,
    "longitude": -86.11328337,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003190&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003195",
    "name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "population": 26100,
    "y2021": 0,
    "y2022": 2,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 13078,
    "totalLines": 13078,
    "exceedance": "",
    "latitude": 42.80958055,
    "longitude": -86.07943127,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003195&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0040665",
    "name": "HOLLY HILLS MHC",
    "population": 435,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 313,
    "totalLines": 313,
    "exceedance": "",
    "latitude": 42.79881732,
    "longitude": -83.59569667,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040665&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003200",
    "name": "HOLLY, VILLAGE OF",
    "population": 8557,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.79844485,
    "longitude": -83.62894026,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003200&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003215",
    "name": "HOLTON COTTAGES",
    "population": 34,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 18,
    "totalLines": 18,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040014",
    "name": "HOMECREST VILLA MOBILE HOME PARK",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 58,
    "totalLines": 58,
    "exceedance": "",
    "latitude": 42.53451963,
    "longitude": -85.87705144,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040014&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003220",
    "name": "HOMER",
    "population": 1668,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.14137842,
    "longitude": -84.80765777,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003220&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003223",
    "name": "HOMER TOWNSHIP",
    "population": 3097,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1335,
    "totalLines": 1335,
    "exceedance": "",
    "latitude": 43.60988488,
    "longitude": -84.31836819,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003223&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003225",
    "name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "population": 84,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 17,
    "totalLines": 17,
    "exceedance": "",
    "latitude": 45.44316601,
    "longitude": -84.8643407,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003225&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007103",
    "name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "population": 1365,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 203,
    "totalLines": 203,
    "exceedance": "",
    "latitude": 44.91114417,
    "longitude": -85.97258151,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007103&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003228",
    "name": "HOPE NETWORK  WEST LAKE FACILITY",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 12,
    "exceedance": "2019",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006773",
    "name": "HORSELL MANOR",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.14180191,
    "longitude": -84.65421419,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006773&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003229",
    "name": "HORTON BAY CLUB",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 30,
    "totalLines": 30,
    "exceedance": "",
    "latitude": 45.27854124,
    "longitude": -85.07223261,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003229&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003230",
    "name": "HOUGHTON",
    "population": 8386,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1843,
    "totalLines": 1843,
    "exceedance": "",
    "latitude": 47.11203963,
    "longitude": -88.56117563,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003230&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003235",
    "name": "HOUGHTON CO MEMORIAL AIRPORT",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003237",
    "name": "HOUGHTON HEIGHTS MANOR",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 44.34221556,
    "longitude": -84.77735064,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003237&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003238",
    "name": "HOUGHTON LAKE TIMBER APTS.",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.30169193,
    "longitude": -84.7042496,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003238&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001930",
    "name": "HOUGHTON TOWNSHIP",
    "population": 138,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 66,
    "exceedance": "",
    "latitude": 47.41691683,
    "longitude": -88.28262039,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001930&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003240",
    "name": "HOWARD CITY",
    "population": 1800,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 334,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 334,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 288,
    "totalLines": 622,
    "exceedance": "",
    "latitude": 43.38959506,
    "longitude": -85.46923139,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003240&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003250",
    "name": "HOWELL, CITY OF",
    "population": 10068,
    "y2021": 23,
    "y2022": 6,
    "y2023": 0,
    "y2024": 4,
    "y2025": 4,
    "leadLines": 7,
    "gpcl": 63,
    "unknown": 1485,
    "totalToReplace": 1555,
    "totalReplaced": 37,
    "percentReplaced": 2.3241206030150754,
    "nonLead": 1356,
    "totalLines": 2911,
    "exceedance": "",
    "latitude": 42.61340695,
    "longitude": -83.94875581,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003250&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003280",
    "name": "HUDSON",
    "population": 2307,
    "y2021": 0,
    "y2022": 1,
    "y2023": 3,
    "y2024": 1,
    "y2025": 3,
    "leadLines": 30,
    "gpcl": 25,
    "unknown": 760,
    "totalToReplace": 815,
    "totalReplaced": 8,
    "percentReplaced": 0.9720534629404617,
    "nonLead": 169,
    "totalLines": 984,
    "exceedance": "",
    "latitude": 41.8554064,
    "longitude": -84.34600653,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003280&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003290",
    "name": "HUDSONVILLE",
    "population": 7708,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2306,
    "totalLines": 2306,
    "exceedance": "",
    "latitude": 42.86285866,
    "longitude": -85.86289463,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003290&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040342",
    "name": "HUNTERS CREEK ESTATES",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 50,
    "unknown": 0,
    "totalToReplace": 50,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 43.63126504,
    "longitude": -85.32234544,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040342&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040660",
    "name": "HUNTERS GLEN",
    "population": 700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 425,
    "totalLines": 425,
    "exceedance": "",
    "latitude": 42.73628207,
    "longitude": -85.65928812,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040660&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003310",
    "name": "HUNTINGTON WOODS",
    "population": 6200,
    "y2021": 27,
    "y2022": 4,
    "y2023": 0,
    "y2024": 0,
    "y2025": 3,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 34,
    "percentReplaced": 100,
    "nonLead": 2499,
    "totalLines": 2499,
    "exceedance": "",
    "latitude": 42.48347307,
    "longitude": -83.16898185,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003310&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0005033",
    "name": "HUNTMORE ESTATES",
    "population": 288,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 118,
    "totalLines": 118,
    "exceedance": "",
    "latitude": 42.59905252,
    "longitude": -83.75727247,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005033&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040448",
    "name": "HURON BAY RESORT",
    "population": 140,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 66,
    "exceedance": "",
    "latitude": 43.35796436,
    "longitude": -82.53831252,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040448&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003315",
    "name": "HURON DUNES SUBDIVISION",
    "population": 175,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 68,
    "totalLines": 68,
    "exceedance": "",
    "latitude": 43.99933217,
    "longitude": -83.08808232,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003315&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003317",
    "name": "HURON REGIONAL WATER AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 44.03936715,
    "longitude": -82.99816601,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003317&sys=SDWIS",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0003319",
    "name": "HURON SHORE REGIONAL UTILITY AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 44.29649016,
    "longitude": -83.41202333,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003319&sys=SDWIS",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0003323",
    "name": "HURON TOWNSHIP",
    "population": 437,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 259,
    "totalLines": 259,
    "exceedance": "",
    "latitude": 44.00164663,
    "longitude": -82.77930954,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003323&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003320",
    "name": "HURON TWP",
    "population": 15879,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 5053,
    "unknown": 0,
    "totalToReplace": 5053,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 5053,
    "exceedance": "",
    "latitude": 42.14075588,
    "longitude": -83.36005866,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003320&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040520",
    "name": "HWY M553 MOBILE ESTATES",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 23,
    "unknown": 0,
    "totalToReplace": 23,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 29,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040406",
    "name": "HYLANDER VALLEY",
    "population": 158,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 63,
    "totalLines": 63,
    "exceedance": "",
    "latitude": 43.76228048,
    "longitude": -86.35856581,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040406&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040299",
    "name": "IDEAL VILLA MANUFACTURED HOME COMMUNITY",
    "population": 266,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 167,
    "totalLines": 167,
    "exceedance": "",
    "latitude": 42.97219748,
    "longitude": -83.37049543,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040299&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007233",
    "name": "IDLEWILD GARDEN HOUSING",
    "population": 27,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": 43.90043789,
    "longitude": -85.77729566,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007233&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003340",
    "name": "IMLAY CITY, CITY OF",
    "population": 3579,
    "y2021": 3,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 12,
    "leadLines": 20,
    "gpcl": 11,
    "unknown": 185,
    "totalToReplace": 216,
    "totalReplaced": 15,
    "percentReplaced": 6.493506493506493,
    "nonLead": 939,
    "totalLines": 1155,
    "exceedance": "",
    "latitude": 43.01865913,
    "longitude": -83.07681971,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003340&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003342",
    "name": "INDEPENDENCE TOWNSHIP",
    "population": 11790,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 1,
    "unknown": 3492,
    "totalToReplace": 3493,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2952,
    "totalLines": 6445,
    "exceedance": "",
    "latitude": 42.72902766,
    "longitude": -83.389787,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003342&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040015",
    "name": "INDIAN ACRES MOBILE HOME PARK",
    "population": 88,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 35,
    "totalLines": 35,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040108",
    "name": "INDIAN RIVER MHP",
    "population": 28,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 45.38774229,
    "longitude": -84.6317922,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040108&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040233",
    "name": "INDIAN VILLAGE",
    "population": 394,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 300,
    "totalLines": 300,
    "exceedance": "",
    "latitude": 42.22237285,
    "longitude": -84.3570052,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040233&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003360",
    "name": "INKSTER",
    "population": 25369,
    "y2021": 67,
    "y2022": 77,
    "y2023": 114,
    "y2024": 88,
    "y2025": 149,
    "leadLines": 199,
    "gpcl": 77,
    "unknown": 1792,
    "totalToReplace": 2068,
    "totalReplaced": 495,
    "percentReplaced": 19.313304721030043,
    "nonLead": 6512,
    "totalLines": 8580,
    "exceedance": "2025",
    "latitude": 42.29253581,
    "longitude": -83.31525439,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003360&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003362",
    "name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.41445474,
    "longitude": -84.86508271,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003362&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006680",
    "name": "INTERIOR TOWNSHIP",
    "population": 200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 102,
    "totalLines": 102,
    "exceedance": "",
    "latitude": 46.48038206,
    "longitude": -89.00711973,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006680&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003365",
    "name": "INTERLOCHEN CENTER FOR THE ARTS",
    "population": 750,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 189,
    "totalLines": 189,
    "exceedance": "",
    "latitude": 44.6558672,
    "longitude": -85.77149569,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003365&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003370",
    "name": "IONIA",
    "population": 12997,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 16,
    "y2025": 6,
    "leadLines": 0,
    "gpcl": 139,
    "unknown": 1850,
    "totalToReplace": 1989,
    "totalReplaced": 22,
    "percentReplaced": 1.093983092988563,
    "nonLead": 811,
    "totalLines": 2800,
    "exceedance": "",
    "latitude": 42.97586354,
    "longitude": -85.07363857,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003370&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003390",
    "name": "IRA TOWNSHIP",
    "population": 8679,
    "y2021": 6,
    "y2022": 4,
    "y2023": 0,
    "y2024": 1,
    "y2025": 2,
    "leadLines": 2,
    "gpcl": 1,
    "unknown": 0,
    "totalToReplace": 3,
    "totalReplaced": 13,
    "percentReplaced": 81.25,
    "nonLead": 1396,
    "totalLines": 1399,
    "exceedance": "",
    "latitude": 42.69081596,
    "longitude": -82.66922623,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003390&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003400",
    "name": "IRON MOUNTAIN",
    "population": 7500,
    "y2021": 53,
    "y2022": 10,
    "y2023": 17,
    "y2024": 46,
    "y2025": 195,
    "leadLines": 923,
    "gpcl": 307,
    "unknown": 31,
    "totalToReplace": 1261,
    "totalReplaced": 321,
    "percentReplaced": 20.290771175726928,
    "nonLead": 2313,
    "totalLines": 3574,
    "exceedance": "",
    "latitude": 45.8250447,
    "longitude": -88.06307913,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003400&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003410",
    "name": "IRON RIVER",
    "population": 3019,
    "y2021": 11,
    "y2022": 1,
    "y2023": 7,
    "y2024": 3,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 22,
    "percentReplaced": 100,
    "nonLead": 1636,
    "totalLines": 1636,
    "exceedance": "",
    "latitude": 46.09178363,
    "longitude": -88.65524595,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003410&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0000550",
    "name": "IRON RIVER TOWNSHIPBEECHWOOD",
    "population": 440,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 165,
    "totalLines": 165,
    "exceedance": "",
    "latitude": 46.17425095,
    "longitude": -88.8873899,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000550&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004610",
    "name": "IRON RIVER TOWNSHIPNASH",
    "population": 340,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 249,
    "totalLines": 249,
    "exceedance": "",
    "latitude": 46.10223743,
    "longitude": -88.68835282,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004610&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005760",
    "name": "IRON RIVER TOWNSHIPRYDEN ROAD",
    "population": 290,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 141,
    "totalLines": 141,
    "exceedance": "",
    "latitude": 46.11573238,
    "longitude": -88.67671291,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005760&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003420",
    "name": "IRONWOOD",
    "population": 5387,
    "y2021": 79,
    "y2022": 43,
    "y2023": 91,
    "y2024": 164,
    "y2025": 259,
    "leadLines": 25,
    "gpcl": 144,
    "unknown": 664,
    "totalToReplace": 833,
    "totalReplaced": 636,
    "percentReplaced": 43.29475833900613,
    "nonLead": 2174,
    "totalLines": 3007,
    "exceedance": "",
    "latitude": 46.46314227,
    "longitude": -90.15312204,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003420&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003430",
    "name": "IRONWOOD TOWNSHIP",
    "population": 474,
    "y2021": 1,
    "y2022": 1,
    "y2023": 1,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 20,
    "unknown": 7,
    "totalToReplace": 27,
    "totalReplaced": 5,
    "percentReplaced": 15.625,
    "nonLead": 383,
    "totalLines": 372,
    "exceedance": "",
    "latitude": 46.48803641,
    "longitude": -90.15400041,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003430&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003440",
    "name": "ISHPEMING",
    "population": 6470,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 3,
    "leadLines": 0,
    "gpcl": 7,
    "unknown": 2198,
    "totalToReplace": 2205,
    "totalReplaced": 4,
    "percentReplaced": 0.1810774105930285,
    "nonLead": 344,
    "totalLines": 2549,
    "exceedance": "",
    "latitude": 46.4845431,
    "longitude": -87.67429253,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003440&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004775",
    "name": "ISHPEMING TWP  EAST",
    "population": 305,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 134,
    "totalLines": 134,
    "exceedance": "",
    "latitude": 46.51075822,
    "longitude": -87.67097872,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004775&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003450",
    "name": "ISHPEMING TWP  WEST",
    "population": 2148,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 126,
    "gpcl": 6,
    "unknown": 68,
    "totalToReplace": 200,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 725,
    "totalLines": 925,
    "exceedance": "",
    "latitude": 46.4856987,
    "longitude": -87.72598894,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003450&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003942",
    "name": "ISLAND LAKE APARTMENTS",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "2024",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003452",
    "name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "population": 54,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 19,
    "totalLines": 19,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003460",
    "name": "ITHACA, CITY OF",
    "population": 3098,
    "y2021": 0,
    "y2022": 8,
    "y2023": 41,
    "y2024": 11,
    "y2025": 10,
    "leadLines": 0,
    "gpcl": 38,
    "unknown": 0,
    "totalToReplace": 38,
    "totalReplaced": 70,
    "percentReplaced": 64.81481481481481,
    "nonLead": 1102,
    "totalLines": 1140,
    "exceedance": "",
    "latitude": 43.29229832,
    "longitude": -84.60027267,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003460&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003470",
    "name": "JACKSON",
    "population": 33165,
    "y2021": 338,
    "y2022": 103,
    "y2023": 186,
    "y2024": 368,
    "y2025": 583,
    "leadLines": 7840,
    "gpcl": 1,
    "unknown": 3360,
    "totalToReplace": 11201,
    "totalReplaced": 1578,
    "percentReplaced": 12.348384067610924,
    "nonLead": 1292,
    "totalLines": 12493,
    "exceedance": "",
    "latitude": 42.2413658,
    "longitude": -84.3993578,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003470&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003475",
    "name": "JAMES TOWNSHIP",
    "population": 2023,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 842,
    "totalLines": 842,
    "exceedance": "",
    "latitude": 43.38312331,
    "longitude": -84.03993842,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003475&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003474",
    "name": "JAMESTOWN TOWNSHIP",
    "population": 3330,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1189,
    "totalLines": 1189,
    "exceedance": "",
    "latitude": 42.83271194,
    "longitude": -85.85136724,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003474&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0063476",
    "name": "JAMIESON NURSING HOME",
    "population": 39,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040016",
    "name": "JOHNSONS MOBILE VILLAGE",
    "population": 188,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 42.58665909,
    "longitude": -86.21894369,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040016&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003490",
    "name": "JONESVILLE",
    "population": 2258,
    "y2021": 2,
    "y2022": 1,
    "y2023": 27,
    "y2024": 23,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 230,
    "unknown": 204,
    "totalToReplace": 434,
    "totalReplaced": 55,
    "percentReplaced": 11.247443762781186,
    "nonLead": 444,
    "totalLines": 878,
    "exceedance": "",
    "latitude": 41.97912918,
    "longitude": -84.66439467,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003490&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003505",
    "name": "JUNIPER HILLS CONDOMINIUMS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 44.76811436,
    "longitude": -85.49712045,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003505&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003510",
    "name": "K I SAWYER",
    "population": 3000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 5,
    "leadLines": 3,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 3,
    "totalReplaced": 5,
    "percentReplaced": 62.5,
    "nonLead": 789,
    "totalLines": 792,
    "exceedance": "",
    "latitude": 46.32681412,
    "longitude": -87.37767517,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003510&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003520",
    "name": "KALAMAZOO",
    "population": 192992,
    "y2021": 940,
    "y2022": 829,
    "y2023": 363,
    "y2024": 810,
    "y2025": 1045,
    "leadLines": 4328,
    "gpcl": 286,
    "unknown": 0,
    "totalToReplace": 4614,
    "totalReplaced": 3987,
    "percentReplaced": 46.355074991280084,
    "nonLead": 42326,
    "totalLines": 46940,
    "exceedance": "",
    "latitude": 42.28471376,
    "longitude": -85.58000849,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003520&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003525",
    "name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "population": 5000,
    "y2021": 0,
    "y2022": 13,
    "y2023": 18,
    "y2024": 3,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 34,
    "percentReplaced": 100,
    "nonLead": 61,
    "totalLines": 61,
    "exceedance": "",
    "latitude": 42.64957068,
    "longitude": -86.20501183,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003525&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0003545",
    "name": "KALCHIK ESTATES",
    "population": 147,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 52,
    "exceedance": "",
    "latitude": 45.32536158,
    "longitude": -85.01421695,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003545&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003550",
    "name": "KALEVA, VILLAGE OF",
    "population": 464,
    "y2021": 0,
    "y2022": 21,
    "y2023": 24,
    "y2024": 7,
    "y2025": 5,
    "leadLines": 1,
    "gpcl": 53,
    "unknown": 149,
    "totalToReplace": 203,
    "totalReplaced": 57,
    "percentReplaced": 21.923076923076923,
    "nonLead": 65,
    "totalLines": 268,
    "exceedance": "",
    "latitude": 44.36976344,
    "longitude": -86.01178811,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003550&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003560",
    "name": "KALKASKA, VILLAGE OF",
    "population": 2020,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 629,
    "unknown": 0,
    "totalToReplace": 629,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 243,
    "totalLines": 872,
    "exceedance": "",
    "latitude": 44.74480385,
    "longitude": -85.17836901,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003560&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040580",
    "name": "KAMP VILLA RV PARK",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 42,
    "totalLines": 42,
    "exceedance": "",
    "latitude": 44.48303954,
    "longitude": -86.11456815,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040580&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003563",
    "name": "KAREGNONDI WATER AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.18568098,
    "longitude": -82.51064579,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003563&sys=SDWIS",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0003570",
    "name": "KAWKAWLIN METRO DIST WATER SUP",
    "population": 1480,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 428,
    "totalLines": 428,
    "exceedance": "",
    "latitude": 43.67880199,
    "longitude": -83.97575858,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003570&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003565",
    "name": "KAWKAWLIN TOWNSHIP",
    "population": 3170,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1295,
    "totalLines": 1295,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003595",
    "name": "KEEGO HARBOR, CITY OF",
    "population": 2733,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1049,
    "totalLines": 1049,
    "exceedance": "",
    "latitude": 42.60827447,
    "longitude": -83.3447473,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003595&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003598",
    "name": "KELLOGG BIOLOGICAL STATION",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10,
    "totalLines": 10,
    "exceedance": "2019",
    "latitude": 42.40899505,
    "longitude": -85.40863805,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003598&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040264",
    "name": "KENT CITY MOBILE HOME PARK",
    "population": 185,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": 43.23018126,
    "longitude": -85.77362298,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040264&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003615",
    "name": "KENT RIDGE APARTMENTS",
    "population": 120,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "2024",
    "latitude": 43.21669177,
    "longitude": -85.74861593,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003615&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003620",
    "name": "KENTWOOD",
    "population": 36072,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8488,
    "totalLines": 8488,
    "exceedance": "",
    "latitude": 42.88484157,
    "longitude": -85.59098066,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003620&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040166",
    "name": "KEY COURT MOBILE HOME PARK",
    "population": 55,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 32,
    "exceedance": "",
    "latitude": 43.98408325,
    "longitude": -84.35637156,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040166&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040276",
    "name": "KEY HEIGHTS MOBILE VILLAGE",
    "population": 715,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 286,
    "totalLines": 286,
    "exceedance": "",
    "latitude": 42.93786189,
    "longitude": -85.38736777,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040276&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003628",
    "name": "KIMBALL TOWNSHIP",
    "population": 3463,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.95951492,
    "longitude": -82.53273915,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003628&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0063635",
    "name": "KING NURSING & REHABILITATION COMMUNITY",
    "population": 61,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.30309665,
    "longitude": -84.75313046,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0063635&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040171",
    "name": "KINGS COURT MOBILE HOME PARK",
    "population": 1200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 481,
    "totalLines": 481,
    "exceedance": "",
    "latitude": 44.72433125,
    "longitude": -85.60893312,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040171&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003640",
    "name": "KINGSFORD",
    "population": 5480,
    "y2021": 10,
    "y2022": 26,
    "y2023": 6,
    "y2024": 281,
    "y2025": 175,
    "leadLines": 1262,
    "gpcl": 162,
    "unknown": 0,
    "totalToReplace": 1424,
    "totalReplaced": 498,
    "percentReplaced": 25.910509885535898,
    "nonLead": 1030,
    "totalLines": 2454,
    "exceedance": "",
    "latitude": 45.80122406,
    "longitude": -88.08870427,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003640&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003650",
    "name": "KINGSLEY, VILLAGE OF",
    "population": 1657,
    "y2021": 2,
    "y2022": 0,
    "y2023": 214,
    "y2024": 38,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 254,
    "percentReplaced": 100,
    "nonLead": 640,
    "totalLines": 640,
    "exceedance": "",
    "latitude": 44.5859795,
    "longitude": -85.53257138,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003650&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0006243",
    "name": "KINGSTON APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.75239922,
    "longitude": -83.48399329,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006243&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003660",
    "name": "KINGSTON, VILLAGE OF",
    "population": 440,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 4,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 163,
    "totalToReplace": 163,
    "totalReplaced": 4,
    "percentReplaced": 2.3952095808383236,
    "nonLead": 21,
    "totalLines": 184,
    "exceedance": "",
    "latitude": 43.41342121,
    "longitude": -83.18660343,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003660&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003630",
    "name": "KINROSS TOWNSHIP",
    "population": 7341,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1008,
    "totalLines": 1008,
    "exceedance": "",
    "latitude": 46.26682072,
    "longitude": -84.4586495,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003630&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040471",
    "name": "KLINES RESORT",
    "population": 398,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 265,
    "totalLines": 265,
    "exceedance": "",
    "latitude": 42.04618829,
    "longitude": -85.50426485,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040471&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003666",
    "name": "KNORRWOOD KNOLLS SUBDIVISION",
    "population": 240,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": 42.75973581,
    "longitude": -83.11493137,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003666&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003667",
    "name": "KOCHVILLE TOWNSHIP",
    "population": 4695,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 850,
    "totalLines": 850,
    "exceedance": "",
    "latitude": 43.49573404,
    "longitude": -83.97314698,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003667&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040181",
    "name": "KYCA COMMUNITY",
    "population": 73,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 41.92663652,
    "longitude": -84.5715199,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040181&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003670",
    "name": "L'ANSE",
    "population": 2300,
    "y2021": 18,
    "y2022": 18,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 36,
    "percentReplaced": 100,
    "nonLead": 1145,
    "totalLines": 1145,
    "exceedance": "",
    "latitude": 46.75395108,
    "longitude": -88.44157265,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003670&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0003685",
    "name": "L'ARBRE CROCHE CLUB",
    "population": 330,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 104,
    "totalToReplace": 104,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 112,
    "exceedance": "2021",
    "latitude": 45.41096825,
    "longitude": -84.90707879,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003685&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040277",
    "name": "LAEMA MOBILE HOME PARK",
    "population": 72,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 31,
    "totalLines": 31,
    "exceedance": "",
    "latitude": 43.03660307,
    "longitude": -85.37962432,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040277&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003690",
    "name": "LAGUNA VISTA SUBDIVISION",
    "population": 640,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 200,
    "totalLines": 200,
    "exceedance": "",
    "latitude": 42.56395295,
    "longitude": -83.50498084,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003690&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003691",
    "name": "LAKE ANGELA CONDO APTS #3",
    "population": 24,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003694",
    "name": "LAKE ANGELA CONDO APTS #4",
    "population": 24,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003693",
    "name": "LAKE ANGELA CONDO APTS #5",
    "population": 24,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.48487165,
    "longitude": -83.61559057,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003693&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003696",
    "name": "LAKE ANGELA CONDO APTS #6",
    "population": 24,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.4847116,
    "longitude": -83.61979867,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003696&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003692",
    "name": "LAKE ARROWHEAD ESTATES",
    "population": 231,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 66,
    "exceedance": "",
    "latitude": 41.94794548,
    "longitude": -83.97620432,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003692&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003695",
    "name": "LAKE BELLA VISTA",
    "population": 3584,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1255,
    "totalLines": 1255,
    "exceedance": "",
    "latitude": 43.09416317,
    "longitude": -85.50928958,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003695&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003741",
    "name": "LAKE CHARTER TOWNSHIP",
    "population": 4177,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1724,
    "totalLines": 1724,
    "exceedance": "",
    "latitude": 41.98407913,
    "longitude": -86.53971959,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003741&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003700",
    "name": "LAKE CITY, CITY OF",
    "population": 836,
    "y2021": 20,
    "y2022": 9,
    "y2023": 8,
    "y2024": 5,
    "y2025": 144,
    "leadLines": 189,
    "gpcl": 56,
    "unknown": 0,
    "totalToReplace": 245,
    "totalReplaced": 186,
    "percentReplaced": 43.1554524361949,
    "nonLead": 260,
    "totalLines": 505,
    "exceedance": "",
    "latitude": 44.33089686,
    "longitude": -85.21356923,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003700&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002925",
    "name": "LAKE DOSTER",
    "population": 1287,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 423,
    "totalLines": 423,
    "exceedance": "",
    "latitude": 42.44900958,
    "longitude": -85.55902029,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002925&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040158",
    "name": "LAKE FENTON MOBILE HOME PARK",
    "population": 220,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 25,
    "totalLines": 25,
    "exceedance": "",
    "latitude": 42.86420681,
    "longitude": -83.720078,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040158&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040368",
    "name": "LAKE FOREST PARK",
    "population": 185,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 74,
    "unknown": 0,
    "totalToReplace": 74,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 43.38218035,
    "longitude": -85.77508136,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040368&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003435",
    "name": "LAKE ISABELLA WATER DIST. #1",
    "population": 327,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 86,
    "totalToReplace": 86,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 118,
    "exceedance": "2024",
    "latitude": 43.63549946,
    "longitude": -85.00962029,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003435&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003720",
    "name": "LAKE LINDEN",
    "population": 1203,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 435,
    "totalToReplace": 435,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 143,
    "totalLines": 578,
    "exceedance": "",
    "latitude": 47.18769539,
    "longitude": -88.41637135,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003720&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005549",
    "name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.21349586,
    "longitude": -86.38403959,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005549&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040106",
    "name": "LAKE MICHIGAN HEIGHTS",
    "population": 270,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 87,
    "totalToReplace": 87,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 113,
    "exceedance": "",
    "latitude": 45.36829124,
    "longitude": -85.1263277,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040106&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003730",
    "name": "LAKE ODESSA",
    "population": 2018,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 875,
    "totalLines": 875,
    "exceedance": "",
    "latitude": 42.7803436,
    "longitude": -85.13591564,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003730&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003740",
    "name": "LAKE ORION, VILLAGE OF",
    "population": 2973,
    "y2021": 25,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 0,
    "leadLines": 33,
    "gpcl": 27,
    "unknown": 0,
    "totalToReplace": 60,
    "totalReplaced": 27,
    "percentReplaced": 31.03448275862069,
    "nonLead": 1340,
    "totalLines": 1400,
    "exceedance": "",
    "latitude": 42.78139927,
    "longitude": -83.24232543,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003740&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002277",
    "name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "population": 900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 110,
    "totalLines": 110,
    "exceedance": "",
    "latitude": 42.89170728,
    "longitude": -83.69362866,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002277&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003737",
    "name": "LAKE POINTE CONDOMINIUMS",
    "population": 74,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": 42.21549004,
    "longitude": -86.26758841,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003737&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040075",
    "name": "LAKECREST MOBILE COURT",
    "population": 52,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003751",
    "name": "LAKESHORE CONDOMINIUMS",
    "population": 38,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.07801548,
    "longitude": -84.1412156,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003751&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003145",
    "name": "LAKESHORE EAST CONDOMINIUMS",
    "population": 84,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 42,
    "totalLines": 42,
    "exceedance": "",
    "latitude": 44.46809702,
    "longitude": -84.67819782,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003145&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040034",
    "name": "LAKESHORE ESTATES MHP",
    "population": 115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 44,
    "totalLines": 44,
    "exceedance": "",
    "latitude": 45.26234056,
    "longitude": -83.4722713,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040034&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003753",
    "name": "LAKESHORE HILLTOP APARTMENTS",
    "population": 93,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 11,
    "totalLines": 11,
    "exceedance": "",
    "latitude": 42.7893018,
    "longitude": -83.27738959,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003753&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040169",
    "name": "LAKESHORE VILLAGE",
    "population": 118,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 47,
    "totalLines": 47,
    "exceedance": "",
    "latitude": 44.07687127,
    "longitude": -84.33687594,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040169&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005577",
    "name": "LAKESHORE VILLAGE SUBDIVISION",
    "population": 132,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 51,
    "totalLines": 51,
    "exceedance": "",
    "latitude": 42.58532947,
    "longitude": -83.77098465,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005577&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001669",
    "name": "LAKESIDE APARTMENTS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "2021",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003744",
    "name": "LAKESIDE CLUB CONDOMINIUMS",
    "population": 210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": 45.40116868,
    "longitude": -84.89383894,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003744&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003752",
    "name": "LAKESIDE DEVELOPMENT",
    "population": 82,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 44.11245503,
    "longitude": -84.43169917,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003752&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003742",
    "name": "LAKESIDE ESTATES SUBDIVISION",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 52,
    "exceedance": "",
    "latitude": 42.00332498,
    "longitude": -85.03408887,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003742&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040292",
    "name": "LAKESIDE MOBILE HOME COMMUNITY",
    "population": 168,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": 43.13202387,
    "longitude": -85.37074973,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040292&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003747",
    "name": "LAKETOWN TOWNSHIP",
    "population": 3200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.73630994,
    "longitude": -86.14279861,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003747&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003750",
    "name": "LAKEVIEW",
    "population": 1007,
    "y2021": 8,
    "y2022": 3,
    "y2023": 1,
    "y2024": 4,
    "y2025": 3,
    "leadLines": 20,
    "gpcl": 88,
    "unknown": 0,
    "totalToReplace": 108,
    "totalReplaced": 19,
    "percentReplaced": 14.960629921259844,
    "nonLead": 345,
    "totalLines": 453,
    "exceedance": "",
    "latitude": 43.43834018,
    "longitude": -85.27468006,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003750&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003755",
    "name": "LAKEVIEW APARTMENTS",
    "population": 64,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 8,
    "exceedance": "",
    "latitude": 44.96941477,
    "longitude": -84.68299001,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003755&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006443",
    "name": "LAKEVIEW APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.65915523,
    "longitude": -83.4456833,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006443&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005445",
    "name": "LAKEVIEW CHALET CONDOMINIUMS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "2019",
    "latitude": 42.66070932,
    "longitude": -83.44879203,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005445&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040451",
    "name": "LAKEVIEW ESTATES",
    "population": 380,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 137,
    "totalLines": 137,
    "exceedance": "",
    "latitude": 42.93164364,
    "longitude": -84.00136087,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040451&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040431",
    "name": "LAKEVIEW TRAILER PARK",
    "population": 70,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 27,
    "totalLines": 27,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003757",
    "name": "LAKEWOOD BEACH COMMUNITY SERVICES CO.",
    "population": 52,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 31,
    "totalLines": 31,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006935",
    "name": "LAKEWOOD TERRACE ASSOCIATION",
    "population": 36,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 22,
    "totalLines": 22,
    "exceedance": "",
    "latitude": 44.95874825,
    "longitude": -85.2415032,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006935&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001663",
    "name": "LANDINGS AT CRANES COVE",
    "population": 120,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 110,
    "totalLines": 110,
    "exceedance": "",
    "latitude": 42.84202,
    "longitude": -83.73423368,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001663&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003760",
    "name": "LANSING BOARD OF WATER & LIGHT",
    "population": 166000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 57339,
    "totalLines": 57339,
    "exceedance": "",
    "latitude": 42.70960199,
    "longitude": -84.55542973,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003760&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003770",
    "name": "LANSING TOWNSHIP",
    "population": 5500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2244,
    "totalLines": 2244,
    "exceedance": "",
    "latitude": 42.7535182,
    "longitude": -84.60786034,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003770&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002195",
    "name": "LANTERN BAY TREATMENT CENTER",
    "population": 52,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003780",
    "name": "LAPEER, CITY OF",
    "population": 8841,
    "y2021": 1,
    "y2022": 1,
    "y2023": 111,
    "y2024": 21,
    "y2025": 4,
    "leadLines": 1,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 1,
    "totalReplaced": 138,
    "percentReplaced": 99.28057553956835,
    "nonLead": 3558,
    "totalLines": 3559,
    "exceedance": "2019",
    "latitude": 43.04988225,
    "longitude": -83.32512259,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003780&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003794",
    "name": "LARKIN TOWNSHIP",
    "population": 2878,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1310,
    "totalLines": 1310,
    "exceedance": "",
    "latitude": 43.68813801,
    "longitude": -84.20819023,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003794&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003800",
    "name": "LATHRUP VILLAGE",
    "population": 4075,
    "y2021": 16,
    "y2022": 5,
    "y2023": 3,
    "y2024": 6,
    "y2025": 2,
    "leadLines": 1,
    "gpcl": 0,
    "unknown": 25,
    "totalToReplace": 26,
    "totalReplaced": 32,
    "percentReplaced": 55.172413793103445,
    "nonLead": 1765,
    "totalLines": 1791,
    "exceedance": "",
    "latitude": 42.49200741,
    "longitude": -83.22722338,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003800&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003810",
    "name": "LAURIUM",
    "population": 1947,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 474,
    "totalToReplace": 474,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 614,
    "totalLines": 1088,
    "exceedance": "",
    "latitude": 47.2513648,
    "longitude": -88.43183298,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003810&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003820",
    "name": "LAWRENCE",
    "population": 1045,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 2,
    "percentReplaced": 100,
    "nonLead": 391,
    "totalLines": 391,
    "exceedance": "2020",
    "latitude": 42.2141924,
    "longitude": -86.05540188,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003820&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0003830",
    "name": "LAWTON",
    "population": 1900,
    "y2021": 4,
    "y2022": 4,
    "y2023": 4,
    "y2024": 34,
    "y2025": 17,
    "leadLines": 201,
    "gpcl": 81,
    "unknown": 192,
    "totalToReplace": 474,
    "totalReplaced": 63,
    "percentReplaced": 11.731843575418994,
    "nonLead": 51,
    "totalLines": 525,
    "exceedance": "",
    "latitude": 42.16579432,
    "longitude": -85.84365167,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003830&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040308",
    "name": "LEE VILLA MOBILE HOME PARK",
    "population": 283,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 113,
    "totalLines": 113,
    "exceedance": "",
    "latitude": 41.96670169,
    "longitude": -83.96152141,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040308&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003829",
    "name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040311",
    "name": "LEFFINGWELL ESTATES",
    "population": 210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 41.84416971,
    "longitude": -84.35822993,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040311&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040279",
    "name": "LEISURE VILLAGE",
    "population": 365,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 259,
    "totalLines": 259,
    "exceedance": "",
    "latitude": 43.06032627,
    "longitude": -85.55309492,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040279&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003836",
    "name": "LENOX TOWNSHIP",
    "population": 3000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 184,
    "totalLines": 184,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003837",
    "name": "LEONI TOWNSHIP",
    "population": 2408,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 757,
    "totalLines": 757,
    "exceedance": "",
    "latitude": 42.23245716,
    "longitude": -84.33603259,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003837&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003840",
    "name": "LESLIE, CITY OF",
    "population": 1872,
    "y2021": 11,
    "y2022": 0,
    "y2023": 21,
    "y2024": 21,
    "y2025": 12,
    "leadLines": 81,
    "gpcl": 1,
    "unknown": 0,
    "totalToReplace": 82,
    "totalReplaced": 65,
    "percentReplaced": 44.21768707482993,
    "nonLead": 693,
    "totalLines": 775,
    "exceedance": "2022",
    "latitude": 42.45046163,
    "longitude": -84.43008281,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003840&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003850",
    "name": "LEXINGTON, VILLAGE OF",
    "population": 1178,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 823,
    "totalLines": 823,
    "exceedance": "",
    "latitude": 43.26717936,
    "longitude": -82.53646913,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003850&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040227",
    "name": "LILLY BANK LANE",
    "population": 10,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040001",
    "name": "LINCOLN ESTATES",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": 44.66518386,
    "longitude": -83.40606657,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040001&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0063865",
    "name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "population": 39,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.84354067,
    "longitude": -83.40543819,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0063865&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003868",
    "name": "LINCOLN MANOR",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 44.68343206,
    "longitude": -83.4128058,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003868&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003870",
    "name": "LINCOLN PARK",
    "population": 38144,
    "y2021": 75,
    "y2022": 108,
    "y2023": 79,
    "y2024": 7,
    "y2025": 1481,
    "leadLines": 2647,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 2647,
    "totalReplaced": 1750,
    "percentReplaced": 39.799863543324996,
    "nonLead": 12684,
    "totalLines": 15331,
    "exceedance": "",
    "latitude": 42.24323348,
    "longitude": -83.18122206,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003870&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040586",
    "name": "LINCOLN PINES",
    "population": 390,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 162,
    "totalLines": 162,
    "exceedance": "",
    "latitude": 43.00830451,
    "longitude": -85.70011994,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040586&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040098",
    "name": "LINDEN MOBILE HOME PARK",
    "population": 92,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 57,
    "totalLines": 57,
    "exceedance": "",
    "latitude": 41.76295631,
    "longitude": -85.95257016,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040098&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040145",
    "name": "LINDEN PLACE MOBILE HOME PARK",
    "population": 236,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 162,
    "totalLines": 162,
    "exceedance": "",
    "latitude": 42.96643387,
    "longitude": -83.77888213,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040145&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003890",
    "name": "LINDEN, CITY OF",
    "population": 4150,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1310,
    "totalLines": 1310,
    "exceedance": "",
    "latitude": 42.81803584,
    "longitude": -83.78316317,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003890&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003910",
    "name": "LINWOOD METROPOLITAN DISTRICT",
    "population": 909,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 383,
    "totalLines": 383,
    "exceedance": "",
    "latitude": 43.7324694,
    "longitude": -83.96337568,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003910&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003920",
    "name": "LITCHFIELD",
    "population": 1310,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 574,
    "totalLines": 574,
    "exceedance": "",
    "latitude": 42.04073136,
    "longitude": -84.75768666,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003920&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003927",
    "name": "LITTLE TRAVERSE TOWNSHIP",
    "population": 1102,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 421,
    "totalLines": 421,
    "exceedance": "",
    "latitude": 45.42666261,
    "longitude": -84.92459794,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003927&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003929",
    "name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "population": 4152,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1047,
    "totalLines": 1047,
    "exceedance": "",
    "latitude": 42.47886545,
    "longitude": -83.78007447,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003929&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003930",
    "name": "LIVONIA",
    "population": 96942,
    "y2021": 20,
    "y2022": 20,
    "y2023": 16,
    "y2024": 32,
    "y2025": 214,
    "leadLines": 134,
    "gpcl": 31,
    "unknown": 29973,
    "totalToReplace": 30138,
    "totalReplaced": 302,
    "percentReplaced": 0.9921156373193166,
    "nonLead": 8069,
    "totalLines": 38207,
    "exceedance": "2024",
    "latitude": 42.39697131,
    "longitude": -83.37020576,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003930&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003940",
    "name": "LOCH ALPINE SANITARY AUTHORITY",
    "population": 1506,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 98,
    "totalToReplace": 98,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 437,
    "totalLines": 535,
    "exceedance": "2023",
    "latitude": 42.3385113,
    "longitude": -83.82603375,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003940&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003943",
    "name": "LOCKPORT TOWNSHIP",
    "population": 1778,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 277,
    "totalLines": 277,
    "exceedance": "",
    "latitude": 41.97642767,
    "longitude": -85.61996348,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003943&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040209",
    "name": "LONG LAKE MOBILE HOME ESTATES",
    "population": 68,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 27,
    "totalLines": 27,
    "exceedance": "",
    "latitude": 43.10706493,
    "longitude": -85.12897505,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040209&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003947",
    "name": "LONG LAKE VILLAGE SUBDIVISION",
    "population": 273,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 95,
    "totalLines": 95,
    "exceedance": "",
    "latitude": 42.87361313,
    "longitude": -83.41276449,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003947&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003946",
    "name": "LOOKING GLASS TERRACES APTS.",
    "population": 31,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 42.89219066,
    "longitude": -84.3466914,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003946&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040151",
    "name": "LOON LAKE MOBILE HOME PARK",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10,
    "totalLines": 10,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003950",
    "name": "LOWELL",
    "population": 4150,
    "y2021": 3,
    "y2022": 3,
    "y2023": 29,
    "y2024": 32,
    "y2025": 36,
    "leadLines": 11,
    "gpcl": 69,
    "unknown": 509,
    "totalToReplace": 589,
    "totalReplaced": 103,
    "percentReplaced": 14.884393063583815,
    "nonLead": 805,
    "totalLines": 1394,
    "exceedance": "",
    "latitude": 42.93685885,
    "longitude": -85.35064088,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003950&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003955",
    "name": "LOWELL TOWNSHIP",
    "population": 1958,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 928,
    "totalLines": 928,
    "exceedance": "",
    "latitude": 42.88531277,
    "longitude": -85.37190856,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003955&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003960",
    "name": "LUDINGTON",
    "population": 8184,
    "y2021": 95,
    "y2022": 65,
    "y2023": 68,
    "y2024": 49,
    "y2025": 37,
    "leadLines": 1,
    "gpcl": 1301,
    "unknown": 1556,
    "totalToReplace": 2858,
    "totalReplaced": 314,
    "percentReplaced": 9.899117276166457,
    "nonLead": 1095,
    "totalLines": 3953,
    "exceedance": "",
    "latitude": 43.95553567,
    "longitude": -86.43670166,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003960&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003966",
    "name": "LYNX GOLF VIEW",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003968",
    "name": "LYON TOWNSHIP",
    "population": 9390,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 3,
    "gpcl": 0,
    "unknown": 67,
    "totalToReplace": 70,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4598,
    "totalLines": 4668,
    "exceedance": "",
    "latitude": 42.4849164,
    "longitude": -83.59358297,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003968&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003967",
    "name": "LYONS",
    "population": 789,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 318,
    "totalLines": 318,
    "exceedance": "",
    "latitude": 42.98158078,
    "longitude": -84.94277249,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003967&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001692",
    "name": "MACK. CO. HOUSINGCURTIS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 46.20499418,
    "longitude": -85.74888388,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001692&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0002145",
    "name": "MACK. CO. HOUSINGENGADINE",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 46.1239117,
    "longitude": -85.51125721,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002145&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0003970",
    "name": "MACKINAC ISLAND",
    "population": 583,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 8,
    "totalToReplace": 8,
    "totalReplaced": 1,
    "percentReplaced": 11.11111111111111,
    "nonLead": 106,
    "totalLines": 114,
    "exceedance": "",
    "latitude": 45.86011547,
    "longitude": -84.63188855,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003970&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003980",
    "name": "MACKINAW CITY, VILLAGE OF",
    "population": 897,
    "y2021": 0,
    "y2022": 1,
    "y2023": 5,
    "y2024": 5,
    "y2025": 5,
    "leadLines": 31,
    "gpcl": 46,
    "unknown": 0,
    "totalToReplace": 77,
    "totalReplaced": 16,
    "percentReplaced": 17.20430107526882,
    "nonLead": 487,
    "totalLines": 564,
    "exceedance": "",
    "latitude": 45.77814983,
    "longitude": -84.73207385,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003980&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003990",
    "name": "MACOMB TOWNSHIP",
    "population": 90000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 31034,
    "totalLines": 31034,
    "exceedance": "",
    "latitude": 42.66733754,
    "longitude": -82.92339132,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003990&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004000",
    "name": "MADISON HEIGHTS",
    "population": 29694,
    "y2021": 8,
    "y2022": 7,
    "y2023": 7,
    "y2024": 6,
    "y2025": 21,
    "leadLines": 232,
    "gpcl": 0,
    "unknown": 15,
    "totalToReplace": 247,
    "totalReplaced": 49,
    "percentReplaced": 16.554054054054053,
    "nonLead": 11202,
    "totalLines": 11449,
    "exceedance": "2025",
    "latitude": 42.50889271,
    "longitude": -83.10372348,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004000&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004006",
    "name": "MADISON TOWNSHIP",
    "population": 3480,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1258,
    "totalLines": 1258,
    "exceedance": "",
    "latitude": 41.87480114,
    "longitude": -84.04006971,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004006&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001545",
    "name": "MAIN STREET APARTMENTS",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": 42.7847578,
    "longitude": -83.01069517,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001545&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0062955",
    "name": "MAJESTIC CARE OF FLUSHING",
    "population": 150,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005180",
    "name": "MAN NOR FARMS SUBDIVISION",
    "population": 193,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 1,
    "unknown": 42,
    "totalToReplace": 43,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 11,
    "totalLines": 54,
    "exceedance": "",
    "latitude": 41.86966675,
    "longitude": -83.9652744,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005180&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004010",
    "name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "population": 3900,
    "y2021": 27,
    "y2022": 9,
    "y2023": 8,
    "y2024": 14,
    "y2025": 21,
    "leadLines": 0,
    "gpcl": 334,
    "unknown": 0,
    "totalToReplace": 334,
    "totalReplaced": 79,
    "percentReplaced": 19.128329297820823,
    "nonLead": 1155,
    "totalLines": 1489,
    "exceedance": "",
    "latitude": 44.89514997,
    "longitude": -85.07020047,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004010&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006568",
    "name": "MANCELONA AREA WSA  THE CHIEF",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 23,
    "totalLines": 23,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004020",
    "name": "MANCHESTER",
    "population": 2150,
    "y2021": 12,
    "y2022": 13,
    "y2023": 20,
    "y2024": 57,
    "y2025": 0,
    "leadLines": 38,
    "gpcl": 19,
    "unknown": 1,
    "totalToReplace": 58,
    "totalReplaced": 102,
    "percentReplaced": 63.74999999999999,
    "nonLead": 759,
    "totalLines": 817,
    "exceedance": "2021",
    "latitude": 42.14936361,
    "longitude": -84.03553306,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004020&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040332",
    "name": "MANISTEE FOREST PINES ESTATES",
    "population": 174,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004030",
    "name": "MANISTEE, CITY OF",
    "population": 6200,
    "y2021": 3,
    "y2022": 4,
    "y2023": 19,
    "y2024": 23,
    "y2025": 27,
    "leadLines": 257,
    "gpcl": 541,
    "unknown": 0,
    "totalToReplace": 798,
    "totalReplaced": 76,
    "percentReplaced": 8.695652173913043,
    "nonLead": 2412,
    "totalLines": 3210,
    "exceedance": "2021",
    "latitude": 44.24892935,
    "longitude": -86.3126597,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004030&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004040",
    "name": "MANISTIQUE",
    "population": 3197,
    "y2021": 12,
    "y2022": 4,
    "y2023": 6,
    "y2024": 7,
    "y2025": 5,
    "leadLines": 0,
    "gpcl": 81,
    "unknown": 685,
    "totalToReplace": 766,
    "totalReplaced": 34,
    "percentReplaced": 4.25,
    "nonLead": 696,
    "totalLines": 1462,
    "exceedance": "",
    "latitude": 45.95111113,
    "longitude": -86.26088794,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004040&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004042",
    "name": "MANITOU LAKE APARTMENTS",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.79316652,
    "longitude": -83.26992582,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004042&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004050",
    "name": "MANTON, CITY OF",
    "population": 1287,
    "y2021": 0,
    "y2022": 1,
    "y2023": 5,
    "y2024": 3,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 102,
    "unknown": 247,
    "totalToReplace": 349,
    "totalReplaced": 13,
    "percentReplaced": 3.591160220994475,
    "nonLead": 189,
    "totalLines": 538,
    "exceedance": "",
    "latitude": 44.40919838,
    "longitude": -85.3979619,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004050&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004053",
    "name": "MAPLE GROVE APARTMENTS",
    "population": 28,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": 44.31815228,
    "longitude": -84.65350855,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004053&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040020",
    "name": "MAPLE GROVE ESTATES",
    "population": 115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 46,
    "totalLines": 46,
    "exceedance": "",
    "latitude": 42.73134029,
    "longitude": -85.71080555,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040020&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040361",
    "name": "MAPLE ISLAND ESTATES",
    "population": 320,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 90,
    "totalLines": 90,
    "exceedance": "",
    "latitude": 43.26235982,
    "longitude": -86.06491727,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040361&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040123",
    "name": "MAPLE KNOLL",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "2018",
    "latitude": 42.58625941,
    "longitude": -84.8049764,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040123&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040216",
    "name": "MAPLE LEAF VILLAGE",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004060",
    "name": "MAPLE RAPIDS, VILLAGE OF",
    "population": 643,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 247,
    "unknown": 0,
    "totalToReplace": 247,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 313,
    "exceedance": "",
    "latitude": 43.10306806,
    "longitude": -84.68920923,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004060&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004063",
    "name": "MAPLE RIDGE TOWNSHIP",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 110,
    "totalLines": 110,
    "exceedance": "",
    "latitude": 46.06903315,
    "longitude": -87.16667883,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004063&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0064067",
    "name": "MAPLE VALLEY NURSING HOME",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.85136837,
    "longitude": -85.8366196,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0064067&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040217",
    "name": "MAPLEVIEW ESTATES",
    "population": 93,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 37,
    "totalLines": 37,
    "exceedance": "",
    "latitude": 43.63408944,
    "longitude": -84.631026,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040217&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040219",
    "name": "MAPLEVIEW ESTATES EAST",
    "population": 220,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 99,
    "totalLines": 99,
    "exceedance": "",
    "latitude": 43.61974648,
    "longitude": -84.61822317,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040219&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0064070",
    "name": "MAPLEVIEW NURSING HOME",
    "population": 45,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 43.22862301,
    "longitude": -84.68205701,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0064070&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004419",
    "name": "MAPLEWOOD AND STONE MANORS",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": 44.4140031,
    "longitude": -83.84963173,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004419&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004069",
    "name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 8,
    "exceedance": "",
    "latitude": 45.02482372,
    "longitude": -85.33034902,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004069&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040071",
    "name": "MARBLE LAKE RESORT & MARINA",
    "population": 72,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 41.91330251,
    "longitude": -84.89695065,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040071&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004070",
    "name": "MARCELLUS",
    "population": 1198,
    "y2021": 0,
    "y2022": 0,
    "y2023": 126,
    "y2024": 223,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 349,
    "percentReplaced": 100,
    "nonLead": 479,
    "totalLines": 479,
    "exceedance": "",
    "latitude": 42.02510451,
    "longitude": -85.81310169,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004070&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0004080",
    "name": "MARENISCO TOWNSHIP",
    "population": 430,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 182,
    "totalLines": 182,
    "exceedance": "",
    "latitude": 46.35992672,
    "longitude": -89.6994077,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004080&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004090",
    "name": "MARINE CITY",
    "population": 4652,
    "y2021": 26,
    "y2022": 20,
    "y2023": 0,
    "y2024": 6,
    "y2025": 92,
    "leadLines": 38,
    "gpcl": 23,
    "unknown": 4,
    "totalToReplace": 65,
    "totalReplaced": 144,
    "percentReplaced": 68.89952153110048,
    "nonLead": 1837,
    "totalLines": 1902,
    "exceedance": "",
    "latitude": 42.72348146,
    "longitude": -82.50095539,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004090&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004100",
    "name": "MARION, VILLAGE OF",
    "population": 800,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 5,
    "y2025": 2,
    "leadLines": 4,
    "gpcl": 26,
    "unknown": 0,
    "totalToReplace": 30,
    "totalReplaced": 8,
    "percentReplaced": 21.052631578947366,
    "nonLead": 402,
    "totalLines": 432,
    "exceedance": "",
    "latitude": 44.10312869,
    "longitude": -85.14808533,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004100&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004110",
    "name": "MARLETTE, CITY OF",
    "population": 1875,
    "y2021": 5,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 30,
    "gpcl": 5,
    "unknown": 753,
    "totalToReplace": 788,
    "totalReplaced": 5,
    "percentReplaced": 0.6305170239596469,
    "nonLead": 143,
    "totalLines": 931,
    "exceedance": "",
    "latitude": 43.32789857,
    "longitude": -83.08016198,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004110&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040100",
    "name": "MARLIN VILLAGE MOBILE HOME PARK",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 38,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 41.84573682,
    "longitude": -86.14638352,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040100&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004120",
    "name": "MARQUETTE",
    "population": 20629,
    "y2021": 106,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 543,
    "totalToReplace": 543,
    "totalReplaced": 106,
    "percentReplaced": 16.33281972265023,
    "nonLead": 5660,
    "totalLines": 6203,
    "exceedance": "2025",
    "latitude": 46.54414589,
    "longitude": -87.40781033,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004120&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004025",
    "name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004140",
    "name": "MARQUETTE TOWNSHIP",
    "population": 2700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 231,
    "totalLines": 231,
    "exceedance": "",
    "latitude": 46.55592776,
    "longitude": -87.45538164,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004140&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004150",
    "name": "MARSHALL",
    "population": 7088,
    "y2021": 6,
    "y2022": 25,
    "y2023": 4,
    "y2024": 1,
    "y2025": 15,
    "leadLines": 53,
    "gpcl": 30,
    "unknown": 177,
    "totalToReplace": 260,
    "totalReplaced": 51,
    "percentReplaced": 16.39871382636656,
    "nonLead": 2549,
    "totalLines": 2809,
    "exceedance": "",
    "latitude": 42.27420626,
    "longitude": -84.98306272,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004150&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004155",
    "name": "MARTIN",
    "population": 785,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 191,
    "totalLines": 191,
    "exceedance": "",
    "latitude": 42.52305331,
    "longitude": -85.62901166,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004155&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004160",
    "name": "MARYSVILLE, CITY OF",
    "population": 9959,
    "y2021": 12,
    "y2022": 0,
    "y2023": 4,
    "y2024": 5,
    "y2025": 17,
    "leadLines": 6,
    "gpcl": 0,
    "unknown": 992,
    "totalToReplace": 998,
    "totalReplaced": 38,
    "percentReplaced": 3.667953667953668,
    "nonLead": 2914,
    "totalLines": 3912,
    "exceedance": "",
    "latitude": 42.91088899,
    "longitude": -82.48266638,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004160&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040197",
    "name": "MASON MANOR",
    "population": 630,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 267,
    "totalLines": 267,
    "exceedance": "",
    "latitude": 42.51786769,
    "longitude": -84.44022744,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040197&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040200",
    "name": "MASON MOBILE, LLC",
    "population": 88,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.61247986,
    "longitude": -84.40201447,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040200&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004170",
    "name": "MASON, CITY OF",
    "population": 8252,
    "y2021": 5,
    "y2022": 27,
    "y2023": 13,
    "y2024": 28,
    "y2025": 42,
    "leadLines": 415,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 415,
    "totalReplaced": 115,
    "percentReplaced": 21.69811320754717,
    "nonLead": 2102,
    "totalLines": 2517,
    "exceedance": "",
    "latitude": 42.58059893,
    "longitude": -84.44274564,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004170&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004173",
    "name": "MASONVILLE TOWNSHIP",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 45.92441141,
    "longitude": -86.96784432,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004173&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004152",
    "name": "MATHIAS TOWNSHIP",
    "population": 175,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 46.19474541,
    "longitude": -86.95179196,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004152&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004177",
    "name": "MATTAWAN",
    "population": 2037,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 710,
    "totalLines": 710,
    "exceedance": "",
    "latitude": 42.22896241,
    "longitude": -85.79699115,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004177&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004180",
    "name": "MAYVILLE, VILLAGE OF",
    "population": 950,
    "y2021": 9,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 9,
    "totalToReplace": 9,
    "totalReplaced": 9,
    "percentReplaced": 50,
    "nonLead": 409,
    "totalLines": 418,
    "exceedance": "",
    "latitude": 43.33586342,
    "longitude": -83.35417928,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004180&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004190",
    "name": "MCBAIN, CITY OF",
    "population": 640,
    "y2021": 66,
    "y2022": 60,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 126,
    "percentReplaced": 100,
    "nonLead": 256,
    "totalLines": 256,
    "exceedance": "",
    "latitude": 44.19453809,
    "longitude": -85.21182993,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004190&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0002200",
    "name": "MCMILLAN TOWNSHIP",
    "population": 391,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 28,
    "totalToReplace": 28,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 129,
    "totalLines": 157,
    "exceedance": "",
    "latitude": 46.53452611,
    "longitude": -89.25976188,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002200&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006375",
    "name": "MCTI",
    "population": 460,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.55472234,
    "longitude": -85.52367675,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006375&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006377",
    "name": "MCTI FAMILY HOUSING",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.50385419,
    "longitude": -85.51725845,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006377&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040612",
    "name": "MEADOW LAKE ESTATES MHC",
    "population": 1060,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 416,
    "totalLines": 416,
    "exceedance": "",
    "latitude": 42.69554115,
    "longitude": -83.56263232,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040612&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040061",
    "name": "MEADOW STREAMS ESTATES",
    "population": 293,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 161,
    "totalLines": 161,
    "exceedance": "",
    "latitude": 42.06190519,
    "longitude": -86.3970581,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040061&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060675",
    "name": "MEADOW WOODS N/R CENTER",
    "population": 78,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "2021",
    "latitude": 42.42306953,
    "longitude": -85.93539165,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0060675&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0064213",
    "name": "MEADOWBROOK MED CARE FACILITY",
    "population": 154,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040172",
    "name": "MEADOWLANE MOBILE HOME PARK",
    "population": 650,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 483,
    "totalLines": 483,
    "exceedance": "",
    "latitude": 44.69903602,
    "longitude": -85.66229236,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040172&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0062841",
    "name": "MEDILODGE OF STERLING",
    "population": 39,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 0,
    "exceedance": "2025",
    "latitude": 44.03350757,
    "longitude": -84.02401849,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0062841&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004215",
    "name": "MELROSECHANDLER WATER, LLC",
    "population": 261,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 84,
    "totalLines": 84,
    "exceedance": "2018",
    "latitude": 45.24922114,
    "longitude": -84.8595562,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004215&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004220",
    "name": "MELVINDALE",
    "population": 12851,
    "y2021": 53,
    "y2022": 244,
    "y2023": 407,
    "y2024": 39,
    "y2025": 489,
    "leadLines": 8,
    "gpcl": 1,
    "unknown": 2750,
    "totalToReplace": 2759,
    "totalReplaced": 1232,
    "percentReplaced": 30.869456276622397,
    "nonLead": 1135,
    "totalLines": 3894,
    "exceedance": "2019",
    "latitude": 42.27994146,
    "longitude": -83.17823645,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004220&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040470",
    "name": "MEMORY LANE MOBILE HOME PARK",
    "population": 340,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 200,
    "totalLines": 200,
    "exceedance": "",
    "latitude": 41.79350708,
    "longitude": -85.46430148,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040470&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004230",
    "name": "MEMPHIS, CITY OF",
    "population": 1084,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 441,
    "totalLines": 441,
    "exceedance": "",
    "latitude": 42.8951107,
    "longitude": -82.76936384,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004230&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004240",
    "name": "MENDON",
    "population": 920,
    "y2021": 0,
    "y2022": 0,
    "y2023": 4,
    "y2024": 16,
    "y2025": 3,
    "leadLines": 96,
    "gpcl": 18,
    "unknown": 0,
    "totalToReplace": 114,
    "totalReplaced": 23,
    "percentReplaced": 16.78832116788321,
    "nonLead": 240,
    "totalLines": 357,
    "exceedance": "",
    "latitude": 42.0082855,
    "longitude": -85.45327264,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004240&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004250",
    "name": "MENOMINEE",
    "population": 8583,
    "y2021": 35,
    "y2022": 73,
    "y2023": 89,
    "y2024": 74,
    "y2025": 12,
    "leadLines": 190,
    "gpcl": 470,
    "unknown": 200,
    "totalToReplace": 860,
    "totalReplaced": 283,
    "percentReplaced": 24.759405074365702,
    "nonLead": 3281,
    "totalLines": 4141,
    "exceedance": "",
    "latitude": 45.12262876,
    "longitude": -87.61885731,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004250&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004260",
    "name": "MERIDIAN TOWNSHIP",
    "population": 25600,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 13072,
    "totalLines": 13072,
    "exceedance": "",
    "latitude": 42.72701466,
    "longitude": -84.42037695,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004260&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004276",
    "name": "MERRILL, VILLAGE OF",
    "population": 695,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 380,
    "totalLines": 380,
    "exceedance": "",
    "latitude": 43.40743482,
    "longitude": -84.33505284,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004276&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004280",
    "name": "MERRITT TOWNSHIP",
    "population": 1474,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 578,
    "totalLines": 578,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004310",
    "name": "MESICK, VILLAGE OF",
    "population": 397,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 47,
    "unknown": 0,
    "totalToReplace": 47,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 136,
    "totalLines": 183,
    "exceedance": "",
    "latitude": 44.40191007,
    "longitude": -85.71426808,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004310&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004312",
    "name": "METAMORA, VILLAGE OF",
    "population": 565,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 233,
    "totalLines": 233,
    "exceedance": "",
    "latitude": 42.94101957,
    "longitude": -83.28796825,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004312&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004098",
    "name": "MHOG SEWER & WATER AUTHORITY",
    "population": 17046,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6073,
    "totalLines": 6073,
    "exceedance": "",
    "latitude": 42.61479867,
    "longitude": -83.96423575,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004098&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004320",
    "name": "MICHIANA",
    "population": 182,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 390,
    "totalLines": 390,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040472",
    "name": "MICHIANA MOBILE HOME PARK",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 41.9182995,
    "longitude": -85.44938666,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040472&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040226",
    "name": "MICHIGAN AVENUE ESTATES",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.25417693,
    "longitude": -84.46612893,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040226&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004340",
    "name": "MICHIGAN STATE UNIVERSITY",
    "population": 12793,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 339,
    "totalLines": 339,
    "exceedance": "2023",
    "latitude": 42.69915974,
    "longitude": -84.46203894,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004340&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004360",
    "name": "MIDDLEVILLE",
    "population": 3309,
    "y2021": 10,
    "y2022": 2,
    "y2023": 6,
    "y2024": 30,
    "y2025": 24,
    "leadLines": 73,
    "gpcl": 123,
    "unknown": 0,
    "totalToReplace": 196,
    "totalReplaced": 72,
    "percentReplaced": 26.865671641791046,
    "nonLead": 1103,
    "totalLines": 1299,
    "exceedance": "",
    "latitude": 42.71372212,
    "longitude": -85.46928917,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004360&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004377",
    "name": "MIDLAND CHARTER TOWNSHIP",
    "population": 1348,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 639,
    "totalLines": 639,
    "exceedance": "",
    "latitude": 43.5764146,
    "longitude": -84.20874264,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004377&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004375",
    "name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "population": 11000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4971,
    "totalLines": 4971,
    "exceedance": "",
    "latitude": 43.68974163,
    "longitude": -84.38015069,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004375&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004370",
    "name": "MIDLAND, CITY OF",
    "population": 42547,
    "y2021": 0,
    "y2022": 0,
    "y2023": 2,
    "y2024": 0,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 76,
    "unknown": 1070,
    "totalToReplace": 1146,
    "totalReplaced": 6,
    "percentReplaced": 0.5208333333333333,
    "nonLead": 15296,
    "totalLines": 16442,
    "exceedance": "",
    "latitude": 43.64111918,
    "longitude": -84.23583097,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004370&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007015",
    "name": "MIDTOWN FLATS, LLC",
    "population": 218,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.23546308,
    "longitude": -83.58507289,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007015&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004380",
    "name": "MILAN",
    "population": 7363,
    "y2021": 7,
    "y2022": 14,
    "y2023": 12,
    "y2024": 9,
    "y2025": 16,
    "leadLines": 4,
    "gpcl": 24,
    "unknown": 1565,
    "totalToReplace": 1593,
    "totalReplaced": 58,
    "percentReplaced": 3.513022410660206,
    "nonLead": 1265,
    "totalLines": 2858,
    "exceedance": "",
    "latitude": 42.08451,
    "longitude": -83.68051523,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004380&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004390",
    "name": "MILFORD, VILLAGE OF",
    "population": 6366,
    "y2021": 6,
    "y2022": 3,
    "y2023": 24,
    "y2024": 31,
    "y2025": 17,
    "leadLines": 1,
    "gpcl": 83,
    "unknown": 0,
    "totalToReplace": 84,
    "totalReplaced": 81,
    "percentReplaced": 49.09090909090909,
    "nonLead": 2402,
    "totalLines": 2486,
    "exceedance": "",
    "latitude": 42.59119795,
    "longitude": -83.58188861,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004390&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006631",
    "name": "MILL STREET 1 LDHA",
    "population": 74,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5,
    "totalLines": 5,
    "exceedance": "",
    "latitude": 45.5523611,
    "longitude": -84.78317779,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006631&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004397",
    "name": "MILLERSBURG, VILLAGE OF",
    "population": 206,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 104,
    "totalLines": 104,
    "exceedance": "",
    "latitude": 45.34532019,
    "longitude": -84.06886404,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004397&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004400",
    "name": "MILLINGTON, VILLAGE OF",
    "population": 1072,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 250,
    "totalToReplace": 250,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 228,
    "totalLines": 478,
    "exceedance": "",
    "latitude": 43.2805661,
    "longitude": -83.52798129,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004400&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004403",
    "name": "MILLPOINTE OF HARTLAND",
    "population": 724,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 206,
    "totalLines": 206,
    "exceedance": "",
    "latitude": 42.6245594,
    "longitude": -83.76063767,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004403&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004404",
    "name": "MILLS TOWNSHIP",
    "population": 450,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 219,
    "totalLines": 219,
    "exceedance": "2021",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004410",
    "name": "MINDEN CITY, VILLAGE OF",
    "population": 197,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 107,
    "totalLines": 107,
    "exceedance": "",
    "latitude": 43.67468831,
    "longitude": -82.77680017,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004410&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0062658",
    "name": "MISSION POINT HEALTHCARE",
    "population": 86,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 43.0048939,
    "longitude": -85.81342968,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0062658&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004428",
    "name": "MISTY COVE SENIOR APARTMENTS",
    "population": 66,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.64239141,
    "longitude": -84.63980311,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004428&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040571",
    "name": "MISTY MEADOWS MOBILE HOME PARK",
    "population": 45,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 27,
    "totalLines": 27,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040606",
    "name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "population": 122,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 61,
    "exceedance": "",
    "latitude": 42.40612606,
    "longitude": -86.19865189,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040606&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004440",
    "name": "MONITOR TOWNSHIP",
    "population": 5217,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2238,
    "totalLines": 2238,
    "exceedance": "",
    "latitude": 43.58519601,
    "longitude": -83.91977498,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004440&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004450",
    "name": "MONROE",
    "population": 48664,
    "y2021": 120,
    "y2022": 82,
    "y2023": 85,
    "y2024": 52,
    "y2025": 74,
    "leadLines": 731,
    "gpcl": 392,
    "unknown": 0,
    "totalToReplace": 1123,
    "totalReplaced": 413,
    "percentReplaced": 26.888020833333332,
    "nonLead": 14222,
    "totalLines": 15345,
    "exceedance": "",
    "latitude": 41.96852287,
    "longitude": -83.4794457,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004450&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004455",
    "name": "MONROE SOUTH COUNTY",
    "population": 33816,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12277,
    "totalLines": 12277,
    "exceedance": "",
    "latitude": 41.75538159,
    "longitude": -83.58181733,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004455&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004470",
    "name": "MONTAGUE",
    "population": 2479,
    "y2021": 24,
    "y2022": 77,
    "y2023": 46,
    "y2024": 18,
    "y2025": 24,
    "leadLines": 71,
    "gpcl": 184,
    "unknown": 0,
    "totalToReplace": 255,
    "totalReplaced": 189,
    "percentReplaced": 42.567567567567565,
    "nonLead": 874,
    "totalLines": 1129,
    "exceedance": "",
    "latitude": 43.41551718,
    "longitude": -86.36489523,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004470&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040152",
    "name": "MONTROSE TRAILER PARK",
    "population": 105,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004480",
    "name": "MONTROSE, CITY OF",
    "population": 1657,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 7,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 7,
    "percentReplaced": 100,
    "nonLead": 668,
    "totalLines": 668,
    "exceedance": "",
    "latitude": 43.17644419,
    "longitude": -83.89265596,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004480&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0040452",
    "name": "MOON LAKE ESTATES",
    "population": 31,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 102,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004490",
    "name": "MORENCI",
    "population": 2220,
    "y2021": 2,
    "y2022": 0,
    "y2023": 0,
    "y2024": 65,
    "y2025": 0,
    "leadLines": 63,
    "gpcl": 29,
    "unknown": 667,
    "totalToReplace": 759,
    "totalReplaced": 67,
    "percentReplaced": 8.111380145278451,
    "nonLead": 179,
    "totalLines": 938,
    "exceedance": "",
    "latitude": 41.72106476,
    "longitude": -84.21519707,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004490&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040643",
    "name": "MORRICE MEADOWS",
    "population": 258,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 103,
    "totalLines": 103,
    "exceedance": "",
    "latitude": 42.83761684,
    "longitude": -84.17511762,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040643&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040247",
    "name": "MORROW CROSSING MHC",
    "population": 150,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 60,
    "totalLines": 60,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004510",
    "name": "MOUNT CLEMENS, CITY OF",
    "population": 16314,
    "y2021": 11,
    "y2022": 25,
    "y2023": 13,
    "y2024": 35,
    "y2025": 55,
    "leadLines": 779,
    "gpcl": 66,
    "unknown": 1817,
    "totalToReplace": 2662,
    "totalReplaced": 139,
    "percentReplaced": 4.9625133880756875,
    "nonLead": 3356,
    "totalLines": 6018,
    "exceedance": "",
    "latitude": 42.59772316,
    "longitude": -82.87947478,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004510&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004520",
    "name": "MOUNT MORRIS, CITY OF",
    "population": 3086,
    "y2021": 4,
    "y2022": 5,
    "y2023": 6,
    "y2024": 6,
    "y2025": 12,
    "leadLines": 63,
    "gpcl": 59,
    "unknown": 149,
    "totalToReplace": 271,
    "totalReplaced": 33,
    "percentReplaced": 10.855263157894738,
    "nonLead": 876,
    "totalLines": 1147,
    "exceedance": "",
    "latitude": 43.12032476,
    "longitude": -83.69653627,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004520&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004530",
    "name": "MOUNT PLEASANT",
    "population": 21688,
    "y2021": 1,
    "y2022": 1,
    "y2023": 0,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 2,
    "gpcl": 20,
    "unknown": 4807,
    "totalToReplace": 4829,
    "totalReplaced": 3,
    "percentReplaced": 0.06208609271523179,
    "nonLead": 710,
    "totalLines": 5539,
    "exceedance": "",
    "latitude": 43.59243135,
    "longitude": -84.77462573,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004530&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004550",
    "name": "MUIR",
    "population": 604,
    "y2021": 1,
    "y2022": 182,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 4,
    "unknown": 0,
    "totalToReplace": 4,
    "totalReplaced": 184,
    "percentReplaced": 97.87234042553192,
    "nonLead": 278,
    "totalLines": 282,
    "exceedance": "",
    "latitude": 42.99886603,
    "longitude": -84.93647555,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004550&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004560",
    "name": "MUNISING",
    "population": 2783,
    "y2021": 10,
    "y2022": 0,
    "y2023": 4,
    "y2024": 8,
    "y2025": 7,
    "leadLines": 0,
    "gpcl": 84,
    "unknown": 322,
    "totalToReplace": 406,
    "totalReplaced": 29,
    "percentReplaced": 6.666666666666667,
    "nonLead": 677,
    "totalLines": 1083,
    "exceedance": "",
    "latitude": 46.41576251,
    "longitude": -86.65006598,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004560&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004561",
    "name": "MUNISING INDUSTRIAL PARK",
    "population": 465,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10,
    "totalLines": 10,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004577",
    "name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "population": 5133,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1982,
    "totalLines": 1982,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004570",
    "name": "MUSKEGON",
    "population": 37213,
    "y2021": 336,
    "y2022": 180,
    "y2023": 446,
    "y2024": 609,
    "y2025": 713,
    "leadLines": 7631,
    "gpcl": 2736,
    "unknown": 0,
    "totalToReplace": 10367,
    "totalReplaced": 2284,
    "percentReplaced": 18.053908781914473,
    "nonLead": 4096,
    "totalLines": 14463,
    "exceedance": "",
    "latitude": 43.22650578,
    "longitude": -86.23004483,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004570&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004590",
    "name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "population": 7135,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 22,
    "gpcl": 1,
    "unknown": 0,
    "totalToReplace": 23,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3060,
    "totalLines": 3083,
    "exceedance": "",
    "latitude": 43.28418188,
    "longitude": -86.21887478,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004590&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004580",
    "name": "MUSKEGON HEIGHTS",
    "population": 9917,
    "y2021": 27,
    "y2022": 46,
    "y2023": 249,
    "y2024": 371,
    "y2025": 1223,
    "leadLines": 3940,
    "gpcl": 95,
    "unknown": 0,
    "totalToReplace": 4035,
    "totalReplaced": 1916,
    "percentReplaced": 32.196269534532014,
    "nonLead": 1119,
    "totalLines": 5154,
    "exceedance": "",
    "latitude": 43.20668062,
    "longitude": -86.26150838,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004580&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040241",
    "name": "MY PLACE AT CATTAIL ESTATES",
    "population": 58,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040140",
    "name": "MY PLACE AT HERITAGE ESTATES",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.95485673,
    "longitude": -83.65512151,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040140&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040240",
    "name": "MY PLACE AT PLEASANT LAKE",
    "population": 145,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.38075466,
    "longitude": -84.32250264,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040240&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040091",
    "name": "MY PLACE AT TWIN VALLEY",
    "population": 88,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.18772124,
    "longitude": -84.97395365,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040091&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0004595",
    "name": "MYSTIC RIDGE L.L.C.",
    "population": 225,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 78,
    "totalLines": 78,
    "exceedance": "",
    "latitude": 42.43210241,
    "longitude": -83.83827419,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004595&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004596",
    "name": "MYSTIC VIEW APARTMENTS",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 41,
    "totalLines": 41,
    "exceedance": "",
    "latitude": 42.48314614,
    "longitude": -86.08947822,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004596&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004600",
    "name": "NAHMA TOWNSHIP",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 68,
    "totalLines": 68,
    "exceedance": "",
    "latitude": 45.8708802,
    "longitude": -86.68684996,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004600&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004605",
    "name": "NAPOLEON TOWNSHIP",
    "population": 444,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 151,
    "totalLines": 151,
    "exceedance": "",
    "latitude": 42.16384055,
    "longitude": -84.24643238,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004605&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004620",
    "name": "NASHVILLE",
    "population": 1628,
    "y2021": 0,
    "y2022": 99,
    "y2023": 163,
    "y2024": 0,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 50,
    "unknown": 0,
    "totalToReplace": 50,
    "totalReplaced": 266,
    "percentReplaced": 84.17721518987342,
    "nonLead": 556,
    "totalLines": 606,
    "exceedance": "",
    "latitude": 42.60146124,
    "longitude": -85.09260045,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004620&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004647",
    "name": "NAZARENE CAMP",
    "population": 648,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 338,
    "totalLines": 338,
    "exceedance": "2024",
    "latitude": 42.1580799,
    "longitude": -85.47146123,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004647&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004650",
    "name": "NEGAUNEE",
    "population": 4568,
    "y2021": 0,
    "y2022": 0,
    "y2023": 4,
    "y2024": 5,
    "y2025": 8,
    "leadLines": 0,
    "gpcl": 16,
    "unknown": 700,
    "totalToReplace": 716,
    "totalReplaced": 17,
    "percentReplaced": 2.3192360163710775,
    "nonLead": 1140,
    "totalLines": 1856,
    "exceedance": "",
    "latitude": 46.50291763,
    "longitude": -87.60169826,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004650&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004655",
    "name": "NEGAUNEE TOWNSHIP",
    "population": 961,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 484,
    "totalLines": 484,
    "exceedance": "",
    "latitude": 46.53943286,
    "longitude": -87.52219491,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004655&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004653",
    "name": "NEGAUNEE/ISHPEMING WATER AUTHORITY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0040637",
    "name": "NESEN'S COUNTRYSIDE ACRES",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 77,
    "totalLines": 77,
    "exceedance": "",
    "latitude": 43.4026146,
    "longitude": -84.61852565,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040637&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004670",
    "name": "NEW BALTIMORE, CITY OF",
    "population": 12720,
    "y2021": 3,
    "y2022": 2,
    "y2023": 0,
    "y2024": 2,
    "y2025": 11,
    "leadLines": 6,
    "gpcl": 13,
    "unknown": 0,
    "totalToReplace": 19,
    "totalReplaced": 18,
    "percentReplaced": 48.64864864864865,
    "nonLead": 3993,
    "totalLines": 4012,
    "exceedance": "",
    "latitude": 42.69056222,
    "longitude": -82.73906261,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004670&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004680",
    "name": "NEW BUFFALO",
    "population": 1900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1768,
    "totalLines": 1768,
    "exceedance": "",
    "latitude": 41.77085358,
    "longitude": -86.78821041,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004680&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004685",
    "name": "NEW BUFFALO TOWNSHIP",
    "population": 2845,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 4,
    "unknown": 0,
    "totalToReplace": 4,
    "totalReplaced": 4,
    "percentReplaced": 50,
    "nonLead": 1383,
    "totalLines": 1387,
    "exceedance": "",
    "latitude": 41.79973263,
    "longitude": -86.73643707,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004685&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004690",
    "name": "NEW HAVEN, VILLAGE OF",
    "population": 5600,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1648,
    "totalLines": 1648,
    "exceedance": "",
    "latitude": 42.72942429,
    "longitude": -82.79514976,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004690&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004700",
    "name": "NEW LOTHROP, VILLAGE OF",
    "population": 610,
    "y2021": 0,
    "y2022": 4,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 2,
    "unknown": 0,
    "totalToReplace": 2,
    "totalReplaced": 4,
    "percentReplaced": 66.66666666666666,
    "nonLead": 257,
    "totalLines": 259,
    "exceedance": "",
    "latitude": 43.11869394,
    "longitude": -83.97169951,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004700&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004710",
    "name": "NEWAYGO",
    "population": 2571,
    "y2021": 6,
    "y2022": 0,
    "y2023": 8,
    "y2024": 0,
    "y2025": 73,
    "leadLines": 5,
    "gpcl": 173,
    "unknown": 120,
    "totalToReplace": 298,
    "totalReplaced": 87,
    "percentReplaced": 22.597402597402596,
    "nonLead": 321,
    "totalLines": 619,
    "exceedance": "",
    "latitude": 43.4086658,
    "longitude": -85.8054929,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004710&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004730",
    "name": "NEWBERRY CORRECTIONAL FACILITY",
    "population": 1108,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 31,
    "totalLines": 31,
    "exceedance": "",
    "latitude": 46.3298798,
    "longitude": -85.50519966,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004730&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004720",
    "name": "NEWBERRY WATER & LIGHT",
    "population": 2000,
    "y2021": 5,
    "y2022": 5,
    "y2023": 4,
    "y2024": 2,
    "y2025": 8,
    "leadLines": 90,
    "gpcl": 715,
    "unknown": 0,
    "totalToReplace": 805,
    "totalReplaced": 24,
    "percentReplaced": 2.8950542822677927,
    "nonLead": 56,
    "totalLines": 861,
    "exceedance": "",
    "latitude": 46.34728333,
    "longitude": -85.51153849,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004720&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004740",
    "name": "NILES",
    "population": 14215,
    "y2021": 14,
    "y2022": 17,
    "y2023": 33,
    "y2024": 26,
    "y2025": 41,
    "leadLines": 414,
    "gpcl": 8,
    "unknown": 969,
    "totalToReplace": 1391,
    "totalReplaced": 131,
    "percentReplaced": 8.607095926412615,
    "nonLead": 4254,
    "totalLines": 5645,
    "exceedance": "",
    "latitude": 41.81569412,
    "longitude": -86.24615895,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004740&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004750",
    "name": "NILES TOWNSHIP",
    "population": 2270,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 689,
    "totalLines": 689,
    "exceedance": "",
    "latitude": 41.8196973,
    "longitude": -86.25530081,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004750&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004753",
    "name": "NINE MILE POINTE",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10,
    "totalLines": 10,
    "exceedance": "",
    "latitude": 45.36118678,
    "longitude": -85.17965837,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004753&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040616",
    "name": "NORTH BAY HARBOR CLUB",
    "population": 235,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 42.77440613,
    "longitude": -83.81912712,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040616&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004770",
    "name": "NORTH BRANCH, VILLAGE OF",
    "population": 1021,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 51,
    "totalToReplace": 51,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 351,
    "totalLines": 402,
    "exceedance": "",
    "latitude": 43.22865262,
    "longitude": -83.19192735,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004770&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040154",
    "name": "NORTH DORT MANOR LTD",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.13350664,
    "longitude": -83.68073715,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040154&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040155",
    "name": "NORTH MORRIS ESTATES",
    "population": 313,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 596,
    "totalToReplace": 596,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 596,
    "exceedance": "",
    "latitude": 43.13990993,
    "longitude": -83.690692,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040155&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004780",
    "name": "NORTH MUSKEGON",
    "population": 3786,
    "y2021": 42,
    "y2022": 54,
    "y2023": 22,
    "y2024": 16,
    "y2025": 42,
    "leadLines": 692,
    "gpcl": 461,
    "unknown": 0,
    "totalToReplace": 1153,
    "totalReplaced": 176,
    "percentReplaced": 13.243039879608729,
    "nonLead": 479,
    "totalLines": 1632,
    "exceedance": "",
    "latitude": 43.2677339,
    "longitude": -86.26201662,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004780&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040432",
    "name": "NORTH SHORE TRAILER PARK",
    "population": 68,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 32,
    "exceedance": "",
    "latitude": 44.37663551,
    "longitude": -84.73201952,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040432&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060238",
    "name": "NORTH WOODS NURSING CENTER",
    "population": 71,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 43.857976,
    "longitude": -84.91202011,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0060238&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040039",
    "name": "NORTHERN COUNTRY ESTATES",
    "population": 53,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 41,
    "totalLines": 41,
    "exceedance": "",
    "latitude": 44.11469067,
    "longitude": -84.11252646,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040039&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040212",
    "name": "NORTHERN PINES",
    "population": 13,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "2023",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040594",
    "name": "NORTHFIELD ESTATES",
    "population": 1620,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 643,
    "totalLines": 643,
    "exceedance": "",
    "latitude": 42.3432443,
    "longitude": -84.23490431,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040594&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004820",
    "name": "NORTHPORT COTTAGE OWNERS",
    "population": 240,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 94,
    "totalLines": 94,
    "exceedance": "",
    "latitude": 45.13992657,
    "longitude": -85.56264319,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004820&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004810",
    "name": "NORTHPORT, VILLAGE OF",
    "population": 526,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 2,
    "unknown": 38,
    "totalToReplace": 40,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 325,
    "totalLines": 365,
    "exceedance": "",
    "latitude": 45.12601042,
    "longitude": -85.6172549,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004810&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004830",
    "name": "NORTHVILLE",
    "population": 6119,
    "y2021": 5,
    "y2022": 5,
    "y2023": 17,
    "y2024": 3,
    "y2025": 9,
    "leadLines": 3,
    "gpcl": 193,
    "unknown": 276,
    "totalToReplace": 472,
    "totalReplaced": 39,
    "percentReplaced": 7.632093933463796,
    "nonLead": 2087,
    "totalLines": 2559,
    "exceedance": "",
    "latitude": 42.40972263,
    "longitude": -83.48681585,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004830&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040657",
    "name": "NORTHVILLE CROSSING",
    "population": 1890,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 756,
    "totalLines": 756,
    "exceedance": "",
    "latitude": 42.42974332,
    "longitude": -83.60908956,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040657&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004845",
    "name": "NORTHVILLE TOWNSHIP",
    "population": 32103,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8975,
    "totalLines": 8975,
    "exceedance": "",
    "latitude": 42.43063292,
    "longitude": -83.49254751,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004845&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004847",
    "name": "NORTHWEST OTTAWA CO WATER SYST",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.06037163,
    "longitude": -86.23625865,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004847&sys=SDWIS",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0040453",
    "name": "NORTHWOODS COMMUNITY",
    "population": 238,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 97,
    "totalLines": 97,
    "exceedance": "",
    "latitude": 43.02803242,
    "longitude": -84.14559517,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040453&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004850",
    "name": "NORTON SHORES",
    "population": 23994,
    "y2021": 27,
    "y2022": 4,
    "y2023": 20,
    "y2024": 6,
    "y2025": 7,
    "leadLines": 60,
    "gpcl": 134,
    "unknown": 0,
    "totalToReplace": 194,
    "totalReplaced": 64,
    "percentReplaced": 24.8062015503876,
    "nonLead": 8646,
    "totalLines": 8840,
    "exceedance": "",
    "latitude": 43.16211496,
    "longitude": -86.25394212,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004850&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004860",
    "name": "NORWAY",
    "population": 3314,
    "y2021": 8,
    "y2022": 6,
    "y2023": 6,
    "y2024": 5,
    "y2025": 7,
    "leadLines": 2,
    "gpcl": 271,
    "unknown": 1220,
    "totalToReplace": 1493,
    "totalReplaced": 32,
    "percentReplaced": 2.098360655737705,
    "nonLead": 33,
    "totalLines": 1526,
    "exceedance": "",
    "latitude": 45.78940332,
    "longitude": -87.89989713,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004860&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040414",
    "name": "NOTTINGHAM FOREST MHP",
    "population": 185,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 45.02607512,
    "longitude": -84.70729056,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040414&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004870",
    "name": "NOVI, CITY OF",
    "population": 48000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 4742,
    "totalToReplace": 4742,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10334,
    "totalLines": 15076,
    "exceedance": "",
    "latitude": 42.47832515,
    "longitude": -83.47671391,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004870&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040655",
    "name": "NP CREEK VALLEY NORTH",
    "population": 170,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 63,
    "totalLines": 63,
    "exceedance": "",
    "latitude": 42.46111553,
    "longitude": -85.26159839,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040655&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040079",
    "name": "NP CREEK VALLEY SOUTH",
    "population": 245,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 134,
    "totalLines": 134,
    "exceedance": "",
    "latitude": 42.36012429,
    "longitude": -85.2312815,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040079&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004873",
    "name": "OAK HAVEN",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 19,
    "totalLines": 19,
    "exceedance": "",
    "latitude": 42.40453935,
    "longitude": -86.07248805,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004873&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040391",
    "name": "OAK HILL ESTATES MHC",
    "population": 1260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 468,
    "totalLines": 468,
    "exceedance": "",
    "latitude": 42.82408276,
    "longitude": -83.44754652,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040391&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004876",
    "name": "OAK LANE APARTMENTS",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.6223894,
    "longitude": -85.76035976,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004876&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004874",
    "name": "OAK LEAF MANOR",
    "population": 36,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 44.88304655,
    "longitude": -84.30883808,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004874&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004880",
    "name": "OAK PARK",
    "population": 29654,
    "y2021": 1,
    "y2022": 1,
    "y2023": 1,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 1243,
    "totalToReplace": 1243,
    "totalReplaced": 4,
    "percentReplaced": 0.32076984763432237,
    "nonLead": 9601,
    "totalLines": 10844,
    "exceedance": "2019",
    "latitude": 42.46493525,
    "longitude": -83.18231682,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004880&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0001002",
    "name": "OAK POINTE",
    "population": 1900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 879,
    "totalLines": 879,
    "exceedance": "",
    "latitude": 42.5401387,
    "longitude": -83.85830715,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001002&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040266",
    "name": "OAKFIELD MOBILE HOME PARK",
    "population": 55,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 22,
    "totalLines": 22,
    "exceedance": "",
    "latitude": 43.17574177,
    "longitude": -85.3677991,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040266&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005573",
    "name": "OAKLAND HUNT SUBDIVISION",
    "population": 610,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 262,
    "totalLines": 262,
    "exceedance": "",
    "latitude": 42.74964316,
    "longitude": -83.15370213,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005573&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040678",
    "name": "OAKS OF ROCKFORD",
    "population": 860,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 428,
    "totalLines": 428,
    "exceedance": "",
    "latitude": 43.17969339,
    "longitude": -85.52140179,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040678&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040222",
    "name": "OAKVIEW MOBILE ESTATES",
    "population": 102,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 48,
    "totalLines": 48,
    "exceedance": "",
    "latitude": 43.65368666,
    "longitude": -84.81447647,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040222&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004920",
    "name": "OCEANA ACRES",
    "population": 208,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 9,
    "totalLines": 9,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004935",
    "name": "OGEMAW TOWNSHIP",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 30,
    "totalLines": 30,
    "exceedance": "",
    "latitude": 44.36138004,
    "longitude": -84.42063258,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004935&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004960",
    "name": "OLD FARM COLONY WATER ASSOCIATION",
    "population": 246,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 14,
    "totalToReplace": 14,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 68,
    "totalLines": 82,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040156",
    "name": "OLD ORCHARD ESTATES",
    "population": 296,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 200,
    "totalLines": 200,
    "exceedance": "",
    "latitude": 43.01515045,
    "longitude": -83.49953974,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040156&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004989",
    "name": "OLIVE/BLENDON TWPS",
    "population": 544,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 86,
    "totalToReplace": 86,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 95,
    "totalLines": 181,
    "exceedance": "",
    "latitude": 42.95892757,
    "longitude": -86.10647623,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004989&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004990",
    "name": "OLIVET, CITY OF",
    "population": 1758,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 3,
    "unknown": 0,
    "totalToReplace": 3,
    "totalReplaced": 2,
    "percentReplaced": 40,
    "nonLead": 375,
    "totalLines": 378,
    "exceedance": "",
    "latitude": 42.44400502,
    "longitude": -84.92461832,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004990&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005005",
    "name": "OMER, CITY OF",
    "population": 279,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 181,
    "totalLines": 181,
    "exceedance": "",
    "latitude": 44.04458392,
    "longitude": -83.85873283,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005005&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005010",
    "name": "ONAWAY, CITY OF",
    "population": 880,
    "y2021": 5,
    "y2022": 10,
    "y2023": 0,
    "y2024": 116,
    "y2025": 106,
    "leadLines": 177,
    "gpcl": 65,
    "unknown": 0,
    "totalToReplace": 242,
    "totalReplaced": 237,
    "percentReplaced": 49.478079331941544,
    "nonLead": 240,
    "totalLines": 482,
    "exceedance": "",
    "latitude": 45.35502712,
    "longitude": -84.22434047,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005010&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005020",
    "name": "ONSTED",
    "population": 907,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 107,
    "y2025": 0,
    "leadLines": 6,
    "gpcl": 0,
    "unknown": 134,
    "totalToReplace": 140,
    "totalReplaced": 107,
    "percentReplaced": 43.31983805668016,
    "nonLead": 218,
    "totalLines": 358,
    "exceedance": "",
    "latitude": 42.00421873,
    "longitude": -84.18661583,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005020&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040067",
    "name": "ONTARIO PLACE",
    "population": 248,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 154,
    "totalLines": 154,
    "exceedance": "",
    "latitude": 41.76666203,
    "longitude": -86.22991918,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040067&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005030",
    "name": "ONTONAGON",
    "population": 2607,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1431,
    "totalLines": 1431,
    "exceedance": "",
    "latitude": 46.87452607,
    "longitude": -89.29907689,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005030&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040647",
    "name": "ORCHARD COVE",
    "population": 255,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 120,
    "totalLines": 120,
    "exceedance": "",
    "latitude": 43.16282492,
    "longitude": -83.52948638,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040647&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040503",
    "name": "ORCHARD GROVE",
    "population": 725,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 290,
    "totalLines": 290,
    "exceedance": "",
    "latitude": 42.24563933,
    "longitude": -83.79644531,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040503&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005031",
    "name": "ORCHARD LAKE VILLAGE",
    "population": 2194,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 911,
    "totalLines": 911,
    "exceedance": "",
    "latitude": 42.58623873,
    "longitude": -83.37631811,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005031&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005039",
    "name": "ORCHARD PLACE MANOR APARTMENTS",
    "population": 120,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.00117068,
    "longitude": -84.20235713,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005039&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040399",
    "name": "ORION LAKE ESTATES MHC",
    "population": 1058,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 92,
    "totalLines": 92,
    "exceedance": "",
    "latitude": 42.71743351,
    "longitude": -83.24738961,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040399&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005035",
    "name": "ORION TOWNSHIP",
    "population": 33000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 2474,
    "totalToReplace": 2474,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 5148,
    "totalLines": 7622,
    "exceedance": "",
    "latitude": 42.75959435,
    "longitude": -83.27516329,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005035&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005034",
    "name": "ORONOKO TOWNSHIP",
    "population": 1610,
    "y2021": 2,
    "y2022": 3,
    "y2023": 9,
    "y2024": 6,
    "y2025": 5,
    "leadLines": 400,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 400,
    "totalReplaced": 25,
    "percentReplaced": 5.88235294117647,
    "nonLead": 210,
    "totalLines": 610,
    "exceedance": "",
    "latitude": 41.92706385,
    "longitude": -86.35423314,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005034&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005037",
    "name": "OSBORN LAKE ESTATES",
    "population": 92,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 45,
    "totalLines": 45,
    "exceedance": "",
    "latitude": 42.58178767,
    "longitude": -83.76911428,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005037&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001840",
    "name": "OSCEOLA TOWNSHIP",
    "population": 1391,
    "y2021": 8,
    "y2022": 3,
    "y2023": 3,
    "y2024": 3,
    "y2025": 12,
    "leadLines": 71,
    "gpcl": 11,
    "unknown": 146,
    "totalToReplace": 228,
    "totalReplaced": 29,
    "percentReplaced": 11.284046692607005,
    "nonLead": 193,
    "totalLines": 421,
    "exceedance": "",
    "latitude": 47.13977807,
    "longitude": -88.50615464,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001840&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005040",
    "name": "OSCODA TOWNSHIP",
    "population": 6997,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 6,
    "unknown": 0,
    "totalToReplace": 6,
    "totalReplaced": 1,
    "percentReplaced": 14.285714285714285,
    "nonLead": 3706,
    "totalLines": 3712,
    "exceedance": "",
    "latitude": 44.45024393,
    "longitude": -83.3368673,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005040&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005050",
    "name": "OTISVILLE, VILLAGE OF",
    "population": 864,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.17014205,
    "longitude": -83.52691994,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005050&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005060",
    "name": "OTSEGO",
    "population": 3956,
    "y2021": 8,
    "y2022": 11,
    "y2023": 21,
    "y2024": 36,
    "y2025": 43,
    "leadLines": 41,
    "gpcl": 1065,
    "unknown": 0,
    "totalToReplace": 1106,
    "totalReplaced": 119,
    "percentReplaced": 9.714285714285714,
    "nonLead": 460,
    "totalLines": 1566,
    "exceedance": "",
    "latitude": 42.45527024,
    "longitude": -85.69378409,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005060&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005065",
    "name": "OTSEGO TOWNSHIP",
    "population": 1133,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 228,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.44197563,
    "longitude": -85.67086793,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005065&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005100",
    "name": "OVID, CITY OF",
    "population": 1612,
    "y2021": 0,
    "y2022": 0,
    "y2023": 3,
    "y2024": 174,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 45,
    "unknown": 9,
    "totalToReplace": 54,
    "totalReplaced": 181,
    "percentReplaced": 77.02127659574468,
    "nonLead": 607,
    "totalLines": 661,
    "exceedance": "",
    "latitude": 42.9708903,
    "longitude": -84.37441132,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005100&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005110",
    "name": "OWENDALE, VILLAGE OF",
    "population": 241,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 1,
    "percentReplaced": 100,
    "nonLead": 110,
    "totalLines": 110,
    "exceedance": "",
    "latitude": 43.73023021,
    "longitude": -83.26755419,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005110&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005120",
    "name": "OWOSSO, CITY OF",
    "population": 16353,
    "y2021": 85,
    "y2022": 236,
    "y2023": 362,
    "y2024": 276,
    "y2025": 260,
    "leadLines": 1950,
    "gpcl": 1809,
    "unknown": 13,
    "totalToReplace": 3772,
    "totalReplaced": 1219,
    "percentReplaced": 24.42396313364055,
    "nonLead": 2873,
    "totalLines": 6645,
    "exceedance": "2020",
    "latitude": 42.99955752,
    "longitude": -84.17368724,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005120&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005138",
    "name": "OXFORD TOWNSHIP",
    "population": 10090,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3215,
    "totalLines": 3215,
    "exceedance": "",
    "latitude": 42.8212591,
    "longitude": -83.27149232,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005138&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005136",
    "name": "OXFORD VILLAGE CONDOMINIUMS",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.81688081,
    "longitude": -83.3248214,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005136&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005130",
    "name": "OXFORD, VILLAGE OF",
    "population": 3540,
    "y2021": 16,
    "y2022": 32,
    "y2023": 50,
    "y2024": 47,
    "y2025": 9,
    "leadLines": 0,
    "gpcl": 57,
    "unknown": 69,
    "totalToReplace": 126,
    "totalReplaced": 154,
    "percentReplaced": 55.00000000000001,
    "nonLead": 1189,
    "totalLines": 1315,
    "exceedance": "",
    "latitude": 42.82306818,
    "longitude": -83.25700266,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005130&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005150",
    "name": "OYSTER POINTE CONDOMINIUMS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 15,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040310",
    "name": "PARK VIEW COURT",
    "population": 63,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 25,
    "totalLines": 25,
    "exceedance": "",
    "latitude": 41.93060817,
    "longitude": -84.00601599,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040310&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040340",
    "name": "PARKS PLACE ESTATES",
    "population": 72,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 29,
    "exceedance": "",
    "latitude": 43.70536967,
    "longitude": -85.18973642,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040340&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040441",
    "name": "PARKWOOD",
    "population": 58,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 62,
    "unknown": 0,
    "totalToReplace": 62,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 111,
    "exceedance": "",
    "latitude": 43.25939095,
    "longitude": -83.95494879,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040441&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040284",
    "name": "PARKWOOD GREEN",
    "population": 270,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.13313697,
    "longitude": -85.68489618,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040284&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005205",
    "name": "PARMA TOWNSHIPAMBERTON VILL.",
    "population": 378,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 109,
    "totalLines": 109,
    "exceedance": "",
    "latitude": 42.25335416,
    "longitude": -84.71419732,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005205&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005204",
    "name": "PARMA, VILLAGE OF",
    "population": 768,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 247,
    "totalLines": 247,
    "exceedance": "",
    "latitude": 42.25722108,
    "longitude": -84.59668666,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005204&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005210",
    "name": "PAW PAW",
    "population": 3362,
    "y2021": 3,
    "y2022": 432,
    "y2023": 68,
    "y2024": 19,
    "y2025": 12,
    "leadLines": 0,
    "gpcl": 56,
    "unknown": 208,
    "totalToReplace": 264,
    "totalReplaced": 534,
    "percentReplaced": 66.9172932330827,
    "nonLead": 31,
    "totalLines": 295,
    "exceedance": "",
    "latitude": 42.22018317,
    "longitude": -85.88935081,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005210&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005209",
    "name": "PAW PAW APTS  WEST MAPLE LAKE",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.23230953,
    "longitude": -85.89462223,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005209&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040062",
    "name": "PAW PAW LAKE MH PARK",
    "population": 122,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 49,
    "exceedance": "",
    "latitude": 42.20943522,
    "longitude": -86.2643459,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040062&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005220",
    "name": "PECK, VILLAGE OF",
    "population": 632,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 267,
    "totalLines": 267,
    "exceedance": "",
    "latitude": 43.25952983,
    "longitude": -82.81628772,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005220&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005233",
    "name": "PENINSULA TOWNSHIP",
    "population": 1790,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 581,
    "totalLines": 581,
    "exceedance": "",
    "latitude": 44.78687768,
    "longitude": -85.58352371,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005233&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004760",
    "name": "PENNFIELD TOWNSHIP",
    "population": 3916,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 2,
    "unknown": 0,
    "totalToReplace": 2,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 663,
    "totalLines": 665,
    "exceedance": "",
    "latitude": 42.36871061,
    "longitude": -85.13852036,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004760&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005232",
    "name": "PENNFIELD TWPCONVIS/VERONA",
    "population": 1,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 2,
    "unknown": 0,
    "totalToReplace": 2,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 310,
    "totalLines": 312,
    "exceedance": "",
    "latitude": 42.38125661,
    "longitude": -85.17740092,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005232&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005235",
    "name": "PENNY LAKE ESTATES SUBDIVISION",
    "population": 390,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 122,
    "totalLines": 122,
    "exceedance": "",
    "latitude": 42.54090592,
    "longitude": -83.49601811,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005235&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005240",
    "name": "PENTLAND TOWNSHIP",
    "population": 450,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 64,
    "totalToReplace": 64,
    "totalReplaced": 2,
    "percentReplaced": 3.0303030303030303,
    "nonLead": 168,
    "totalLines": 232,
    "exceedance": "",
    "latitude": 46.31195691,
    "longitude": -85.49512428,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005240&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005260",
    "name": "PENTWATER",
    "population": 857,
    "y2021": 0,
    "y2022": 1,
    "y2023": 16,
    "y2024": 0,
    "y2025": 155,
    "leadLines": 112,
    "gpcl": 114,
    "unknown": 133,
    "totalToReplace": 359,
    "totalReplaced": 172,
    "percentReplaced": 32.39171374764595,
    "nonLead": 457,
    "totalLines": 816,
    "exceedance": "",
    "latitude": 43.77448223,
    "longitude": -86.42540141,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005260&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005267",
    "name": "PERE MARQUETTE TWP  CUSTOMER",
    "population": 339,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 5,
    "unknown": 0,
    "totalToReplace": 5,
    "totalReplaced": 1,
    "percentReplaced": 16.666666666666664,
    "nonLead": 121,
    "totalLines": 126,
    "exceedance": "",
    "latitude": 43.91226707,
    "longitude": -86.41221265,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005267&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005268",
    "name": "PERE MARQUETTE TWP  WELLS",
    "population": 455,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 312,
    "totalLines": 312,
    "exceedance": "",
    "latitude": 43.95338281,
    "longitude": -86.40729244,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005268&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005270",
    "name": "PERRINTON, VILLAGE OF",
    "population": 439,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 3,
    "unknown": 38,
    "totalToReplace": 41,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 139,
    "totalLines": 180,
    "exceedance": "",
    "latitude": 43.18190476,
    "longitude": -84.68232793,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005270&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005280",
    "name": "PERRY, CITY OF",
    "population": 2065,
    "y2021": 2,
    "y2022": 1,
    "y2023": 6,
    "y2024": 6,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 137,
    "unknown": 8,
    "totalToReplace": 145,
    "totalReplaced": 19,
    "percentReplaced": 11.585365853658537,
    "nonLead": 682,
    "totalLines": 827,
    "exceedance": "",
    "latitude": 42.82862132,
    "longitude": -84.21765901,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005280&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005290",
    "name": "PETERSBURG",
    "population": 1115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 550,
    "totalLines": 550,
    "exceedance": "",
    "latitude": 41.89953139,
    "longitude": -83.71285113,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005290&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005305",
    "name": "PETOSKEY PARK APARTMENTS",
    "population": 70,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.37180125,
    "longitude": -84.92401814,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005305&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005300",
    "name": "PETOSKEY, CITY OF",
    "population": 8979,
    "y2021": 5,
    "y2022": 10,
    "y2023": 23,
    "y2024": 5,
    "y2025": 10,
    "leadLines": 5,
    "gpcl": 159,
    "unknown": 840,
    "totalToReplace": 1004,
    "totalReplaced": 53,
    "percentReplaced": 5.014191106906338,
    "nonLead": 2451,
    "totalLines": 3455,
    "exceedance": "",
    "latitude": 45.36557983,
    "longitude": -84.98421784,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005300&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005310",
    "name": "PEWAMO",
    "population": 476,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 113,
    "unknown": 0,
    "totalToReplace": 113,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 87,
    "totalLines": 200,
    "exceedance": "",
    "latitude": 43.00126498,
    "longitude": -84.85005373,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005310&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005315",
    "name": "PHEASANT RUN MANOR APARTMENTS",
    "population": 360,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 15,
    "exceedance": "",
    "latitude": 42.84298112,
    "longitude": -83.69901872,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005315&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040494",
    "name": "PHELPS MOBILE HOME VILLA",
    "population": 87,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 35,
    "totalLines": 35,
    "exceedance": "",
    "latitude": 42.09641044,
    "longitude": -86.09600901,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040494&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040086",
    "name": "PHOENIX MOBILE HOME COURT",
    "population": 82,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 42.26309609,
    "longitude": -85.07429849,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040086&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005320",
    "name": "PIGEON, VILLAGE OF",
    "population": 1208,
    "y2021": 5,
    "y2022": 1,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 2,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 2,
    "totalReplaced": 6,
    "percentReplaced": 75,
    "nonLead": 590,
    "totalLines": 592,
    "exceedance": "",
    "latitude": 43.83082188,
    "longitude": -83.27097068,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005320&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005322",
    "name": "PINCKNEY, VILLAGE OF",
    "population": 2515,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 775,
    "totalLines": 775,
    "exceedance": "",
    "latitude": 42.46070374,
    "longitude": -83.93424638,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005322&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005335",
    "name": "PINCONNING TOWNSHIP",
    "population": 1479,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 612,
    "totalLines": 612,
    "exceedance": "",
    "latitude": 43.63428958,
    "longitude": -83.85843427,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005335&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005330",
    "name": "PINCONNING, CITY OF",
    "population": 1204,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 2,
    "gpcl": 0,
    "unknown": 429,
    "totalToReplace": 431,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 208,
    "totalLines": 639,
    "exceedance": "",
    "latitude": 43.85991751,
    "longitude": -83.96322743,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005330&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040525",
    "name": "PINE ACRES MOBILE HOME PARK",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 33,
    "totalLines": 33,
    "exceedance": "",
    "latitude": 46.49498621,
    "longitude": -87.35531247,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040525&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040481",
    "name": "PINE CREST MOBILE HOME PARK",
    "population": 208,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040609",
    "name": "PINE HAVEN ESTATES MHC",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.00128724,
    "longitude": -84.87772214,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040609&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040577",
    "name": "PINE ISLAND LAKE REC PARK",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 30,
    "totalLines": 30,
    "exceedance": "",
    "latitude": 43.36443534,
    "longitude": -86.15843271,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040577&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002000",
    "name": "PINE KNOLL APARTMENTS, LLC",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040670",
    "name": "PINE LAKES MANUFACTURED HOMES",
    "population": 230,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 184,
    "totalLines": 184,
    "exceedance": "",
    "latitude": 43.04205346,
    "longitude": -83.23493562,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040670&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040603",
    "name": "PINE RIDGE COMMUNITY, INC.",
    "population": 122,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 42.66890375,
    "longitude": -85.99921111,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040603&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040601",
    "name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "population": 490,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 83,
    "totalLines": 83,
    "exceedance": "",
    "latitude": 42.7958394,
    "longitude": -83.85080715,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040601&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040672",
    "name": "PINE RIVER RIDGE",
    "population": 425,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 215,
    "totalLines": 215,
    "exceedance": "",
    "latitude": 43.09333909,
    "longitude": -83.28483614,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040672&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040446",
    "name": "PINE TERRACE ESTATES",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 59,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.34935246,
    "longitude": -83.09461095,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040446&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040210",
    "name": "PINE VIEW MOBILE HOME PARK",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": 43.08658033,
    "longitude": -85.250909,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040210&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005345",
    "name": "PINECREST APARTMENTS",
    "population": 57,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 42.80955519,
    "longitude": -83.26099326,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005345&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005353",
    "name": "PINEHURST APARTMENTS",
    "population": 55,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005351",
    "name": "PINEVIEW HOMES",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10,
    "totalLines": 10,
    "exceedance": "",
    "latitude": 43.911483,
    "longitude": -85.25032885,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005351&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040464",
    "name": "PINEWOOD ON THE LAKE MHP",
    "population": 950,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 359,
    "totalLines": 359,
    "exceedance": "",
    "latitude": 42.83973505,
    "longitude": -82.6491076,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040464&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005355",
    "name": "PIRATES COVE CONDOMINIUMS",
    "population": 38,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 19,
    "totalLines": 19,
    "exceedance": "",
    "latitude": 44.36184308,
    "longitude": -86.19261823,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005355&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005360",
    "name": "PITTSFIELD TOWNSHIP",
    "population": 24500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7785,
    "totalLines": 7785,
    "exceedance": "",
    "latitude": 42.21715112,
    "longitude": -83.72091804,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005360&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005370",
    "name": "PLAINFIELD TOWNSHIP",
    "population": 42271,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12460,
    "totalLines": 12460,
    "exceedance": "",
    "latitude": 43.05300654,
    "longitude": -85.64518601,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005370&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005380",
    "name": "PLAINWELL",
    "population": 3998,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1421,
    "totalLines": 1421,
    "exceedance": "",
    "latitude": 42.44226227,
    "longitude": -85.64189983,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005380&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060695",
    "name": "PLAINWELL PINES H C F",
    "population": 58,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040167",
    "name": "PLEASANT BEACH MOBILE HOME RESORT",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 116,
    "totalLines": 116,
    "exceedance": "",
    "latitude": 43.84372716,
    "longitude": -84.33660677,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040167&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040504",
    "name": "PLEASANT LAKE PARK LLC",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005390",
    "name": "PLEASANT RIDGE",
    "population": 2872,
    "y2021": 33,
    "y2022": 3,
    "y2023": 1,
    "y2024": 72,
    "y2025": 63,
    "leadLines": 646,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 646,
    "totalReplaced": 172,
    "percentReplaced": 21.026894865525673,
    "nonLead": 503,
    "totalLines": 1149,
    "exceedance": "",
    "latitude": 42.4712194,
    "longitude": -83.14449109,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005390&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005397",
    "name": "PLUM CREEK SUB",
    "population": 102,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 45,
    "totalLines": 45,
    "exceedance": "",
    "latitude": 42.75990965,
    "longitude": -83.19417699,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005397&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005400",
    "name": "PLYMOUTH",
    "population": 9132,
    "y2021": 9,
    "y2022": 1,
    "y2023": 8,
    "y2024": 26,
    "y2025": 8,
    "leadLines": 173,
    "gpcl": 109,
    "unknown": 414,
    "totalToReplace": 696,
    "totalReplaced": 52,
    "percentReplaced": 6.951871657754011,
    "nonLead": 2920,
    "totalLines": 3616,
    "exceedance": "",
    "latitude": 42.36293958,
    "longitude": -83.52708101,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005400&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005420",
    "name": "PLYMOUTH TOWNSHIP",
    "population": 27524,
    "y2021": 3,
    "y2022": 3,
    "y2023": 1,
    "y2024": 16,
    "y2025": 1,
    "leadLines": 5,
    "gpcl": 6,
    "unknown": 0,
    "totalToReplace": 11,
    "totalReplaced": 24,
    "percentReplaced": 68.57142857142857,
    "nonLead": 10105,
    "totalLines": 10116,
    "exceedance": "",
    "latitude": 42.36804257,
    "longitude": -83.46569016,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005420&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005425",
    "name": "POINT NIPIGON RESORT",
    "population": 173,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 69,
    "totalLines": 69,
    "exceedance": "",
    "latitude": 45.69185997,
    "longitude": -84.54391191,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005425&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005430",
    "name": "POINTE AUX BARQUES TOWNSHIP",
    "population": 178,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 44.06188467,
    "longitude": -82.95692196,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005430&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005427",
    "name": "POLKTON TOWNSHIP",
    "population": 135,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 33,
    "totalToReplace": 33,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 48,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005440",
    "name": "PONTIAC",
    "population": 63600,
    "y2021": 146,
    "y2022": 133,
    "y2023": 258,
    "y2024": 314,
    "y2025": 533,
    "leadLines": 101,
    "gpcl": 1036,
    "unknown": 9609,
    "totalToReplace": 10746,
    "totalReplaced": 1384,
    "percentReplaced": 11.409727947238252,
    "nonLead": 8759,
    "totalLines": 19505,
    "exceedance": "",
    "latitude": 42.64931975,
    "longitude": -83.28889453,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005440&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005460",
    "name": "PORT AUSTIN AREA SEWER & WATER",
    "population": 1004,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 736,
    "totalLines": 736,
    "exceedance": "",
    "latitude": 44.04395025,
    "longitude": -82.99466503,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005460&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005475",
    "name": "PORT HOPEGORERUBICON U. A.",
    "population": 1058,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 612,
    "totalLines": 612,
    "exceedance": "",
    "latitude": 43.93975372,
    "longitude": -82.71446387,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005475&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005490",
    "name": "PORT HURON TOWNSHIP",
    "population": 10654,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 2,
    "leadLines": 1,
    "gpcl": 11,
    "unknown": 380,
    "totalToReplace": 392,
    "totalReplaced": 4,
    "percentReplaced": 1.0101010101010102,
    "nonLead": 744,
    "totalLines": 1136,
    "exceedance": "",
    "latitude": 42.98395858,
    "longitude": -82.49386054,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005490&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005480",
    "name": "PORT HURON, CITY OF",
    "population": 33800,
    "y2021": 4,
    "y2022": 7,
    "y2023": 61,
    "y2024": 22,
    "y2025": 40,
    "leadLines": 339,
    "gpcl": 311,
    "unknown": 9323,
    "totalToReplace": 9973,
    "totalReplaced": 134,
    "percentReplaced": 1.3258137924210944,
    "nonLead": 2387,
    "totalLines": 12360,
    "exceedance": "",
    "latitude": 42.98758234,
    "longitude": -82.45040432,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005480&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040491",
    "name": "PORT OF CALL  WEST",
    "population": 105,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 61,
    "exceedance": "",
    "latitude": 42.34748304,
    "longitude": -86.21035961,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040491&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005500",
    "name": "PORT SANILAC, VILLAGE OF",
    "population": 623,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 448,
    "totalLines": 448,
    "exceedance": "",
    "latitude": 43.43871574,
    "longitude": -82.54587274,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005500&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006026",
    "name": "PORT SHELDON TOWNSHIP",
    "population": 407,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 147,
    "totalToReplace": 147,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 88,
    "totalLines": 235,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005520",
    "name": "PORTAGE",
    "population": 46292,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14801,
    "totalLines": 14801,
    "exceedance": "",
    "latitude": 42.20852852,
    "longitude": -85.59569359,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005520&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005527",
    "name": "PORTAGE POINT INN",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 51,
    "totalLines": 51,
    "exceedance": "",
    "latitude": 44.3727406,
    "longitude": -86.25645854,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005527&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040253",
    "name": "PORTAGE TERRACE",
    "population": 202,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 82,
    "totalLines": 82,
    "exceedance": "",
    "latitude": 42.11144849,
    "longitude": -85.63314486,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040253&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003330",
    "name": "PORTAGE TOWNSHIP",
    "population": 1214,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 269,
    "totalToReplace": 269,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 274,
    "totalLines": 543,
    "exceedance": "",
    "latitude": 47.09300868,
    "longitude": -88.59548469,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003330&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005530",
    "name": "PORTLAND",
    "population": 3883,
    "y2021": 0,
    "y2022": 1,
    "y2023": 0,
    "y2024": 103,
    "y2025": 13,
    "leadLines": 0,
    "gpcl": 359,
    "unknown": 268,
    "totalToReplace": 627,
    "totalReplaced": 117,
    "percentReplaced": 15.725806451612904,
    "nonLead": 1081,
    "totalLines": 1708,
    "exceedance": "",
    "latitude": 42.87307951,
    "longitude": -84.90560197,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005530&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005540",
    "name": "PORTSMOUTH TOWNSHIP",
    "population": 535,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 225,
    "totalLines": 225,
    "exceedance": "",
    "latitude": 43.55890756,
    "longitude": -83.89580783,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005540&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005543",
    "name": "POSEN, VILLAGE OF",
    "population": 234,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 120,
    "totalLines": 120,
    "exceedance": "",
    "latitude": 45.26393042,
    "longitude": -83.70039042,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005543&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005550",
    "name": "POTTERVILLE, CITY OF",
    "population": 2617,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 737,
    "totalLines": 737,
    "exceedance": "",
    "latitude": 42.63035488,
    "longitude": -84.74339438,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005550&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000700",
    "name": "POWELL TOWNSHIP",
    "population": 300,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 27,
    "totalToReplace": 27,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 88,
    "totalLines": 115,
    "exceedance": "",
    "latitude": 46.81972348,
    "longitude": -87.73134256,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000700&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005563",
    "name": "POWERSSPALDING WATER AUTHORITY",
    "population": 459,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 169,
    "totalLines": 169,
    "exceedance": "",
    "latitude": 45.69498388,
    "longitude": -87.51309906,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005563&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005566",
    "name": "PRAIRIE VILLAGE APARTMENTS",
    "population": 38,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002619",
    "name": "PRENTIS ESTATES APARTMENTS",
    "population": 500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.58244027,
    "longitude": -83.87406754,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002619&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005570",
    "name": "PRESCOTTHIDDEN CREEK MANOR",
    "population": 38,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 44.22776385,
    "longitude": -84.04230527,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005570&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005575",
    "name": "PRESQUE ISLE HARBOR WATER CO.",
    "population": 845,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 29,
    "totalToReplace": 29,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 309,
    "totalLines": 338,
    "exceedance": "",
    "latitude": 45.29628548,
    "longitude": -83.49642958,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005575&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040490",
    "name": "PROSPECT MANOR MHC",
    "population": 94,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 52,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040456",
    "name": "QUIET COVE TRAILER PARK",
    "population": 70,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 44,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.80986662,
    "longitude": -84.32473434,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040456&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005580",
    "name": "QUINCY",
    "population": 1544,
    "y2021": 0,
    "y2022": 0,
    "y2023": 32,
    "y2024": 0,
    "y2025": 4,
    "leadLines": 0,
    "gpcl": 50,
    "unknown": 18,
    "totalToReplace": 68,
    "totalReplaced": 36,
    "percentReplaced": 34.61538461538461,
    "nonLead": 697,
    "totalLines": 766,
    "exceedance": "",
    "latitude": 41.94238531,
    "longitude": -84.88351236,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005580&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005590",
    "name": "QUINNESEC",
    "population": 1200,
    "y2021": 3,
    "y2022": 0,
    "y2023": 19,
    "y2024": 5,
    "y2025": 2,
    "leadLines": 101,
    "gpcl": 79,
    "unknown": 0,
    "totalToReplace": 180,
    "totalReplaced": 29,
    "percentReplaced": 13.875598086124402,
    "nonLead": 330,
    "totalLines": 510,
    "exceedance": "",
    "latitude": 45.80152914,
    "longitude": -87.99569932,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005590&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040021",
    "name": "RABBIT RIVER ESTATES",
    "population": 255,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 100,
    "totalLines": 100,
    "exceedance": "",
    "latitude": 42.67199771,
    "longitude": -85.62085403,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040021&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005607",
    "name": "RAPID RIVER MEADOWS",
    "population": 46,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 44.85715397,
    "longitude": -85.1093853,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005607&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005610",
    "name": "RAVENNA",
    "population": 1219,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 574,
    "totalLines": 574,
    "exceedance": "",
    "latitude": 43.18866977,
    "longitude": -85.94199476,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005610&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005620",
    "name": "READING",
    "population": 1078,
    "y2021": 0,
    "y2022": 0,
    "y2023": 4,
    "y2024": 0,
    "y2025": 66,
    "leadLines": 0,
    "gpcl": 46,
    "unknown": 0,
    "totalToReplace": 46,
    "totalReplaced": 70,
    "percentReplaced": 60.3448275862069,
    "nonLead": 481,
    "totalLines": 527,
    "exceedance": "",
    "latitude": 41.84031923,
    "longitude": -84.7447699,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005620&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005640",
    "name": "REDFORD TOWNSHIP",
    "population": 49504,
    "y2021": 0,
    "y2022": 12,
    "y2023": 109,
    "y2024": 30,
    "y2025": 102,
    "leadLines": 94,
    "gpcl": 0,
    "unknown": 4922,
    "totalToReplace": 5016,
    "totalReplaced": 253,
    "percentReplaced": 4.801670146137787,
    "nonLead": 15310,
    "totalLines": 20326,
    "exceedance": "2024",
    "latitude": 42.39419966,
    "longitude": -83.29256899,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005640&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005650",
    "name": "REED CITY, CITY OF",
    "population": 2425,
    "y2021": 24,
    "y2022": 34,
    "y2023": 54,
    "y2024": 100,
    "y2025": 214,
    "leadLines": 66,
    "gpcl": 192,
    "unknown": 0,
    "totalToReplace": 258,
    "totalReplaced": 426,
    "percentReplaced": 62.28070175438597,
    "nonLead": 672,
    "totalLines": 930,
    "exceedance": "",
    "latitude": 43.87214106,
    "longitude": -85.5102875,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005650&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0067101",
    "name": "REGENCY AT WHITMORE LAKE",
    "population": 190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 125,
    "totalLines": 125,
    "exceedance": "",
    "latitude": 42.39919225,
    "longitude": -83.75612463,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0067101&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005655",
    "name": "REMUS APARTMENT COMPANY",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 43.55223833,
    "longitude": -85.10782727,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005655&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005660",
    "name": "REPUBLIC TOWNSHIP",
    "population": 700,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 4,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 5,
    "unknown": 69,
    "totalToReplace": 74,
    "totalReplaced": 4,
    "percentReplaced": 5.128205128205128,
    "nonLead": 250,
    "totalLines": 324,
    "exceedance": "",
    "latitude": 46.37992565,
    "longitude": -87.97596504,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005660&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000048",
    "name": "RICHLYN MANOR",
    "population": 192,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 95,
    "totalLines": 95,
    "exceedance": "",
    "latitude": 41.91830304,
    "longitude": -84.06798104,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000048&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005160",
    "name": "RICHMOND TOWNSHIP",
    "population": 489,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 210,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 46.43999879,
    "longitude": -87.59182043,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005160&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0005670",
    "name": "RICHMOND, CITY OF",
    "population": 5733,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 81,
    "unknown": 323,
    "totalToReplace": 404,
    "totalReplaced": 1,
    "percentReplaced": 0.24691358024691357,
    "nonLead": 2204,
    "totalLines": 2608,
    "exceedance": "",
    "latitude": 42.8085788,
    "longitude": -82.75356279,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005670&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000838",
    "name": "RIDGE VALLEY OF MILFORD",
    "population": 220,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 138,
    "totalLines": 138,
    "exceedance": "",
    "latitude": 42.55537667,
    "longitude": -83.37539452,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000838&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005673",
    "name": "RIDGEWAY",
    "population": 31,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040671",
    "name": "RIDGEWOOD MOBILE HOME PARK INC",
    "population": 1030,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 455,
    "totalLines": 455,
    "exceedance": "",
    "latitude": 42.60417745,
    "longitude": -83.65123817,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040671&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005675",
    "name": "RIGA TOWNSHIP",
    "population": 266,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 132,
    "totalLines": 132,
    "exceedance": "",
    "latitude": 41.79118236,
    "longitude": -83.75269261,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005675&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040663",
    "name": "RIVER RIDGE  SALINE",
    "population": 720,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 288,
    "totalLines": 288,
    "exceedance": "",
    "latitude": 42.16140897,
    "longitude": -83.90097652,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040663&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005690",
    "name": "RIVER ROUGE",
    "population": 7224,
    "y2021": 0,
    "y2022": 0,
    "y2023": 97,
    "y2024": 139,
    "y2025": 241,
    "leadLines": 155,
    "gpcl": 0,
    "unknown": 2481,
    "totalToReplace": 2636,
    "totalReplaced": 477,
    "percentReplaced": 15.322839704465146,
    "nonLead": 371,
    "totalLines": 3007,
    "exceedance": "2025",
    "latitude": 42.26759926,
    "longitude": -83.13998586,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005690&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005692",
    "name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "population": 37,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 16,
    "totalLines": 16,
    "exceedance": "",
    "latitude": 41.81450021,
    "longitude": -85.99745271,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005692&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004095",
    "name": "RIVERFRONT CONDOS OF NILES",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 41.91264651,
    "longitude": -86.20838706,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004095&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040515",
    "name": "RIVERSBEND MOBILE HOME PARK",
    "population": 180,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 51,
    "totalLines": 51,
    "exceedance": "",
    "latitude": 45.85664224,
    "longitude": -88.084549,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040515&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040030",
    "name": "RIVERSIDE ESTATES",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 43,
    "totalLines": 43,
    "exceedance": "",
    "latitude": 42.62410023,
    "longitude": -86.15442073,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040030&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040065",
    "name": "RIVERSIDE ESTATES",
    "population": 218,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 87,
    "totalLines": 87,
    "exceedance": "",
    "latitude": 41.85461564,
    "longitude": -86.36748108,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040065&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005710",
    "name": "RIVERVIEW",
    "population": 12486,
    "y2021": 7,
    "y2022": 8,
    "y2023": 7,
    "y2024": 23,
    "y2025": 20,
    "leadLines": 84,
    "gpcl": 1,
    "unknown": 38,
    "totalToReplace": 123,
    "totalReplaced": 65,
    "percentReplaced": 34.57446808510639,
    "nonLead": 3716,
    "totalLines": 3839,
    "exceedance": "2024",
    "latitude": 42.17139423,
    "longitude": -83.19108868,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005710&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040191",
    "name": "RIVERVIEW ESTATES",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 36,
    "totalLines": 36,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040288",
    "name": "RIVERVIEW MOBILE VILLAGE",
    "population": 392,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 142,
    "totalLines": 142,
    "exceedance": "",
    "latitude": 43.18958626,
    "longitude": -85.68316827,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040288&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005712",
    "name": "RIVERWALK DEVELOPMENT",
    "population": 137,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 65,
    "totalLines": 65,
    "exceedance": "",
    "latitude": 42.67166224,
    "longitude": -85.99099351,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005712&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005720",
    "name": "ROCHESTER",
    "population": 7130,
    "y2021": 18,
    "y2022": 10,
    "y2023": 6,
    "y2024": 7,
    "y2025": 5,
    "leadLines": 0,
    "gpcl": 9,
    "unknown": 4,
    "totalToReplace": 13,
    "totalReplaced": 46,
    "percentReplaced": 77.96610169491525,
    "nonLead": 2468,
    "totalLines": 2481,
    "exceedance": "",
    "latitude": 42.68289274,
    "longitude": -83.13388892,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005720&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005723",
    "name": "ROCHESTER EAST",
    "population": 5500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1747,
    "totalLines": 1747,
    "exceedance": "",
    "latitude": 42.69017268,
    "longitude": -83.10693761,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005723&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000325",
    "name": "ROCHESTER HILLS",
    "population": 74000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 23882,
    "totalLines": 23882,
    "exceedance": "",
    "latitude": 42.66462887,
    "longitude": -83.15770665,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000325&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005730",
    "name": "ROCKFORD",
    "population": 7160,
    "y2021": 0,
    "y2022": 0,
    "y2023": 42,
    "y2024": 47,
    "y2025": 67,
    "leadLines": 44,
    "gpcl": 357,
    "unknown": 0,
    "totalToReplace": 401,
    "totalReplaced": 156,
    "percentReplaced": 28.007181328545784,
    "nonLead": 2174,
    "totalLines": 2575,
    "exceedance": "",
    "latitude": 43.12375207,
    "longitude": -85.55772765,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005730&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005740",
    "name": "ROCKLAND TOWNSHIP",
    "population": 350,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 15,
    "gpcl": 45,
    "unknown": 3,
    "totalToReplace": 63,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 76,
    "totalLines": 142,
    "exceedance": "",
    "latitude": 46.73919203,
    "longitude": -89.18146916,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005740&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005750",
    "name": "ROCKWOOD",
    "population": 3289,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 86,
    "totalToReplace": 86,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 997,
    "totalLines": 1083,
    "exceedance": "",
    "latitude": 42.07067616,
    "longitude": -83.24661634,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005750&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005770",
    "name": "ROGERS CITY, CITY OF",
    "population": 2827,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1495,
    "totalLines": 1495,
    "exceedance": "",
    "latitude": 45.41912452,
    "longitude": -83.81887124,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005770&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005775",
    "name": "ROLLING MEADOWS WATER ASSN.",
    "population": 76,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 31,
    "totalLines": 31,
    "exceedance": "",
    "latitude": 44.7623124,
    "longitude": -85.7035664,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005775&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005780",
    "name": "ROMEO, VILLAGE OF",
    "population": 3750,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 551,
    "totalToReplace": 551,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1024,
    "totalLines": 1575,
    "exceedance": "",
    "latitude": 42.80642834,
    "longitude": -83.01411142,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005780&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005785",
    "name": "ROMULUS",
    "population": 23989,
    "y2021": 3,
    "y2022": 11,
    "y2023": 8,
    "y2024": 11,
    "y2025": 14,
    "leadLines": 43,
    "gpcl": 14,
    "unknown": 5533,
    "totalToReplace": 5590,
    "totalReplaced": 47,
    "percentReplaced": 0.8337768316480398,
    "nonLead": 2853,
    "totalLines": 8443,
    "exceedance": "2017",
    "latitude": 42.22539532,
    "longitude": -83.36991421,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005785&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005800",
    "name": "ROOSEVELT PARK",
    "population": 3831,
    "y2021": 7,
    "y2022": 5,
    "y2023": 39,
    "y2024": 23,
    "y2025": 35,
    "leadLines": 224,
    "gpcl": 107,
    "unknown": 0,
    "totalToReplace": 331,
    "totalReplaced": 109,
    "percentReplaced": 24.772727272727273,
    "nonLead": 1080,
    "totalLines": 1411,
    "exceedance": "",
    "latitude": 43.19815556,
    "longitude": -86.27335155,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005800&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005810",
    "name": "ROSCOMMON, VILLAGE OF",
    "population": 1075,
    "y2021": 3,
    "y2022": 5,
    "y2023": 4,
    "y2024": 7,
    "y2025": 5,
    "leadLines": 0,
    "gpcl": 57,
    "unknown": 393,
    "totalToReplace": 450,
    "totalReplaced": 24,
    "percentReplaced": 5.063291139240507,
    "nonLead": 27,
    "totalLines": 477,
    "exceedance": "",
    "latitude": 44.49373756,
    "longitude": -84.59218732,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005810&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005815",
    "name": "ROSE CITY, CITY OF",
    "population": 180,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 66,
    "exceedance": "",
    "latitude": 44.42113452,
    "longitude": -84.11615741,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005815&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005816",
    "name": "ROSE HILL CENTER",
    "population": 70,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005823",
    "name": "ROSEBUSH ESTATES APARTMENTS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "2025",
    "latitude": 43.69673545,
    "longitude": -84.76870046,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005823&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005824",
    "name": "ROSEBUSH MANOR",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 43.69866492,
    "longitude": -84.76946877,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005824&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005821",
    "name": "ROSEVILLE APARTMENTS",
    "population": 32,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 43.59094226,
    "longitude": -85.25682205,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005821&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005820",
    "name": "ROSEVILLE, CITY OF",
    "population": 47299,
    "y2021": 3,
    "y2022": 3,
    "y2023": 4,
    "y2024": 8,
    "y2025": 28,
    "leadLines": 108,
    "gpcl": 127,
    "unknown": 983,
    "totalToReplace": 1218,
    "totalReplaced": 46,
    "percentReplaced": 3.6392405063291138,
    "nonLead": 17285,
    "totalLines": 18503,
    "exceedance": "",
    "latitude": 42.51169859,
    "longitude": -82.93503697,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005820&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040307",
    "name": "ROUND LAKE ESTATES",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 108,
    "totalLines": 108,
    "exceedance": "",
    "latitude": 41.9635542,
    "longitude": -84.28118972,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040307&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040255",
    "name": "ROYAL ESTATES",
    "population": 380,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 183,
    "totalLines": 183,
    "exceedance": "",
    "latitude": 42.38326479,
    "longitude": -85.67608881,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040255&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005840",
    "name": "ROYAL OAK TOWNSHIP",
    "population": 1864,
    "y2021": 2,
    "y2022": 1,
    "y2023": 16,
    "y2024": 9,
    "y2025": 5,
    "leadLines": 7,
    "gpcl": 3,
    "unknown": 97,
    "totalToReplace": 107,
    "totalReplaced": 33,
    "percentReplaced": 23.57142857142857,
    "nonLead": 659,
    "totalLines": 766,
    "exceedance": "2020",
    "latitude": 42.44997409,
    "longitude": -83.16220964,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005840&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005830",
    "name": "ROYAL OAK, CITY OF",
    "population": 57236,
    "y2021": 225,
    "y2022": 192,
    "y2023": 266,
    "y2024": 267,
    "y2025": 221,
    "leadLines": 879,
    "gpcl": 723,
    "unknown": 766,
    "totalToReplace": 2368,
    "totalReplaced": 1171,
    "percentReplaced": 33.08844306301215,
    "nonLead": 21247,
    "totalLines": 23615,
    "exceedance": "2019",
    "latitude": 42.50894068,
    "longitude": -83.15439366,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005830&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005841",
    "name": "ROYAL VIEW RETIREMENT VILLAGE",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 43.56429288,
    "longitude": -85.27102816,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005841&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005844",
    "name": "RUDYARD TOWNSHIP",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 192,
    "totalLines": 192,
    "exceedance": "",
    "latitude": 46.23030095,
    "longitude": -84.59633097,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005844&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040345",
    "name": "RUMBAUGH ESTATES LLC",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 7,
    "totalToReplace": 7,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 51,
    "totalLines": 58,
    "exceedance": "",
    "latitude": 43.65171548,
    "longitude": -84.17463055,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040345&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040495",
    "name": "RUSH LAKE MHP/CAMPGROUND",
    "population": 41,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 42.24153121,
    "longitude": -86.2100781,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040495&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040104",
    "name": "RUSTIC ACRES PARK",
    "population": 108,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 69,
    "totalLines": 69,
    "exceedance": "",
    "latitude": 41.7774415,
    "longitude": -85.82259102,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040104&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005849",
    "name": "SADDLE RIDGE CONDO ASSOC.",
    "population": 156,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 230,
    "totalLines": 230,
    "exceedance": "",
    "latitude": 43.1687394,
    "longitude": -85.61309312,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005849&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005860",
    "name": "SAGINAW CHARTER TOWNSHIP",
    "population": 40840,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15271,
    "totalLines": 15271,
    "exceedance": "",
    "latitude": 43.44749798,
    "longitude": -84.00878496,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005860&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005850",
    "name": "SAGINAW, CITY OF",
    "population": 44058,
    "y2021": 713,
    "y2022": 1143,
    "y2023": 931,
    "y2024": 1133,
    "y2025": 1020,
    "leadLines": 6317,
    "gpcl": 0,
    "unknown": 736,
    "totalToReplace": 7053,
    "totalReplaced": 4940,
    "percentReplaced": 41.19069457183357,
    "nonLead": 19769,
    "totalLines": 26822,
    "exceedance": "",
    "latitude": 43.41990829,
    "longitude": -83.96700714,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005850&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005880",
    "name": "SAGINAWMIDLAND WATER SUPPLY",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0005900",
    "name": "SALINE",
    "population": 9158,
    "y2021": 0,
    "y2022": 0,
    "y2023": 1,
    "y2024": 1,
    "y2025": 0,
    "leadLines": 43,
    "gpcl": 0,
    "unknown": 1468,
    "totalToReplace": 1511,
    "totalReplaced": 2,
    "percentReplaced": 0.13218770654329146,
    "nonLead": 1629,
    "totalLines": 3140,
    "exceedance": "",
    "latitude": 42.17956743,
    "longitude": -83.77193186,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005900&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005901",
    "name": "SALINE VALLEY FARMS",
    "population": 375,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 156,
    "totalLines": 156,
    "exceedance": "",
    "latitude": 42.1303033,
    "longitude": -83.76860241,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005901&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005903",
    "name": "SAND BEACH TOWNSHIP",
    "population": 475,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 207,
    "totalLines": 207,
    "exceedance": "",
    "latitude": 43.75894474,
    "longitude": -82.77001504,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005903&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005907",
    "name": "SAND LAKE",
    "population": 360,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 227,
    "totalLines": 227,
    "exceedance": "",
    "latitude": 43.29106748,
    "longitude": -85.51469546,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005907&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040592",
    "name": "SANDHILL ESTATES",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 43.06136234,
    "longitude": -83.18128541,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040592&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005905",
    "name": "SANDHILL MANOR",
    "population": 148,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 12,
    "exceedance": "",
    "latitude": 44.2954474,
    "longitude": -84.69817928,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005905&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040447",
    "name": "SANDPIPER ESTATES",
    "population": 215,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 93,
    "totalLines": 93,
    "exceedance": "",
    "latitude": 43.23639558,
    "longitude": -82.52664961,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040447&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005920",
    "name": "SANDUSKY, CITY OF",
    "population": 2679,
    "y2021": 0,
    "y2022": 0,
    "y2023": 2,
    "y2024": 4,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 6,
    "percentReplaced": 100,
    "nonLead": 1043,
    "totalLines": 1043,
    "exceedance": "",
    "latitude": 43.42087205,
    "longitude": -82.83149463,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005920&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0005911",
    "name": "SANDY PINES",
    "population": 157,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 54,
    "totalLines": 54,
    "exceedance": "2022",
    "latitude": 42.68859808,
    "longitude": -85.80860689,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005911&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005925",
    "name": "SANILAC TOWNSHIP",
    "population": 674,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 523,
    "totalLines": 523,
    "exceedance": "",
    "latitude": 43.41760536,
    "longitude": -82.57042298,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005925&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040013",
    "name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "population": 138,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 55,
    "totalLines": 55,
    "exceedance": "",
    "latitude": 42.69834596,
    "longitude": -85.83663201,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040013&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005930",
    "name": "SARANAC",
    "population": 1343,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 143,
    "totalToReplace": 143,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 343,
    "totalLines": 486,
    "exceedance": "",
    "latitude": 42.92752027,
    "longitude": -85.20768911,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005930&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040575",
    "name": "SASHABAW MEADOWS MHP",
    "population": 1278,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 100,
    "totalLines": 100,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005950",
    "name": "SAULT STE MARIE",
    "population": 14689,
    "y2021": 3,
    "y2022": 2,
    "y2023": 7,
    "y2024": 14,
    "y2025": 10,
    "leadLines": 199,
    "gpcl": 186,
    "unknown": 0,
    "totalToReplace": 385,
    "totalReplaced": 36,
    "percentReplaced": 8.551068883610451,
    "nonLead": 4880,
    "totalLines": 5265,
    "exceedance": "",
    "latitude": 46.47862042,
    "longitude": -84.37694434,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005950&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005970",
    "name": "SCHOOLCRAFT",
    "population": 1587,
    "y2021": 1,
    "y2022": 5,
    "y2023": 3,
    "y2024": 21,
    "y2025": 37,
    "leadLines": 121,
    "gpcl": 194,
    "unknown": 0,
    "totalToReplace": 315,
    "totalReplaced": 67,
    "percentReplaced": 17.539267015706805,
    "nonLead": 331,
    "totalLines": 646,
    "exceedance": "",
    "latitude": 42.11619101,
    "longitude": -85.63475781,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005970&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005977",
    "name": "SCIO TOWNSHIP",
    "population": 8500,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2675,
    "totalLines": 2675,
    "exceedance": "",
    "latitude": 42.28475508,
    "longitude": -83.83490106,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005977&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005980",
    "name": "SCOTTVILLE, CITY OF",
    "population": 1536,
    "y2021": 0,
    "y2022": 8,
    "y2023": 10,
    "y2024": 3,
    "y2025": 40,
    "leadLines": 28,
    "gpcl": 84,
    "unknown": 9,
    "totalToReplace": 121,
    "totalReplaced": 61,
    "percentReplaced": 33.51648351648351,
    "nonLead": 466,
    "totalLines": 587,
    "exceedance": "",
    "latitude": 43.95516439,
    "longitude": -86.27866383,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005980&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0005990",
    "name": "SEBEWAING LIGHT & WATER",
    "population": 1721,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 980,
    "totalLines": 980,
    "exceedance": "",
    "latitude": 43.7328757,
    "longitude": -83.44272519,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005990&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040168",
    "name": "SECORD LAKE MHP",
    "population": 43,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 48,
    "totalLines": 48,
    "exceedance": "",
    "latitude": 44.06271658,
    "longitude": -84.34490597,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040168&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040024",
    "name": "SELKIRK LAKE MOBILE HOME PARK",
    "population": 62,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005991",
    "name": "SENEY TOWNSHIP",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 91,
    "totalLines": 91,
    "exceedance": "",
    "latitude": 46.50295992,
    "longitude": -85.94501983,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005991&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003857",
    "name": "SERENE GARDENS OF DEWITT",
    "population": 39,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.86431288,
    "longitude": -84.48500336,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003857&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040025",
    "name": "SHADY ACRES COMMUNITY, LLC",
    "population": 147,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 59,
    "totalLines": 59,
    "exceedance": "",
    "latitude": 42.63494573,
    "longitude": -85.96467444,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040025&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040496",
    "name": "SHADY BROOK MOBILE HOME PARK",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 13,
    "totalLines": 13,
    "exceedance": "",
    "latitude": 42.27130032,
    "longitude": -85.86540979,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040496&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040026",
    "name": "SHANGRAILA VILLAGE",
    "population": 165,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 66,
    "totalLines": 66,
    "exceedance": "",
    "latitude": 42.6867903,
    "longitude": -86.15371933,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040026&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005995",
    "name": "SHANTY CREEK  WATARS ASSOCIATION",
    "population": 1250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 44.95450964,
    "longitude": -85.19402343,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005995&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0001073",
    "name": "SHAWONO CENTER  DHS",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.77760584,
    "longitude": -84.75391271,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001073&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006000",
    "name": "SHELBY",
    "population": 1964,
    "y2021": 2,
    "y2022": 2,
    "y2023": 235,
    "y2024": 76,
    "y2025": 0,
    "leadLines": 57,
    "gpcl": 289,
    "unknown": 0,
    "totalToReplace": 346,
    "totalReplaced": 315,
    "percentReplaced": 47.655068078668684,
    "nonLead": 454,
    "totalLines": 800,
    "exceedance": "",
    "latitude": 43.6106813,
    "longitude": -86.36446663,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006000&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006010",
    "name": "SHELBY TOWNSHIP",
    "population": 72000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24808,
    "totalLines": 24808,
    "exceedance": "",
    "latitude": 42.67089007,
    "longitude": -83.03320633,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006010&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006025",
    "name": "SHELDON DUNES",
    "population": 176,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 60,
    "totalToReplace": 60,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 32,
    "totalLines": 92,
    "exceedance": "",
    "latitude": 42.94388398,
    "longitude": -86.21278135,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006025&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006030",
    "name": "SHEPHERD, VILLAGE OF",
    "population": 1515,
    "y2021": 4,
    "y2022": 0,
    "y2023": 3,
    "y2024": 264,
    "y2025": 118,
    "leadLines": 0,
    "gpcl": 32,
    "unknown": 0,
    "totalToReplace": 32,
    "totalReplaced": 389,
    "percentReplaced": 92.39904988123516,
    "nonLead": 560,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.52264675,
    "longitude": -84.69167769,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006030&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0006040",
    "name": "SHERIDAN",
    "population": 649,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 3,
    "leadLines": 0,
    "gpcl": 29,
    "unknown": 0,
    "totalToReplace": 29,
    "totalReplaced": 4,
    "percentReplaced": 12.121212121212121,
    "nonLead": 251,
    "totalLines": 280,
    "exceedance": "",
    "latitude": 43.21113369,
    "longitude": -85.07289686,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006040&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040351",
    "name": "SHERIDAN ESTATES",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 43.20848188,
    "longitude": -85.06314528,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040351&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040242",
    "name": "SHERMAN OAKS",
    "population": 915,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 366,
    "totalLines": 366,
    "exceedance": "",
    "latitude": 42.33617117,
    "longitude": -84.41930206,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040242&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002590",
    "name": "SHERMAN TOWNSHIP",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 60,
    "totalToReplace": 60,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 60,
    "exceedance": "",
    "latitude": 47.23732519,
    "longitude": -88.22278301,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002590&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006042",
    "name": "SHERWOOD SHORES CONDOMINIUMS",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 37,
    "totalLines": 37,
    "exceedance": "2019",
    "latitude": 42.21211024,
    "longitude": -86.25077789,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006042&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006070",
    "name": "SHOREWOOD HILLS SUBDIVISION",
    "population": 256,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 13,
    "totalToReplace": 13,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 59,
    "totalLines": 72,
    "exceedance": "2025",
    "latitude": 42.58763925,
    "longitude": -83.32489786,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006070&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040519",
    "name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "population": 260,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 104,
    "totalLines": 104,
    "exceedance": "",
    "latitude": 46.4904106,
    "longitude": -87.35725866,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040519&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040322",
    "name": "SILVER LAKE MOBILE HOME PARK",
    "population": 68,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 42.47069576,
    "longitude": -83.72649805,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040322&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040175",
    "name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "population": 98,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 49,
    "exceedance": "",
    "latitude": 44.70603326,
    "longitude": -85.68149435,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040175&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006071",
    "name": "SILVER LAKE WATER AUTHORITY, INC.",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 123,
    "totalLines": 123,
    "exceedance": "",
    "latitude": 43.08917402,
    "longitude": -85.4675118,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006071&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040176",
    "name": "SILVER SHORES MOBILE HOME PARK",
    "population": 360,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 210,
    "totalLines": 210,
    "exceedance": "",
    "latitude": 44.67308317,
    "longitude": -85.68536443,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040176&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006073",
    "name": "SIMSWHITNEY UTILITIES AUTH.",
    "population": 5815,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1744,
    "totalLines": 1744,
    "exceedance": "2018",
    "latitude": 44.12362237,
    "longitude": -83.57691363,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006073&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006074",
    "name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 42.33525821,
    "longitude": -83.67315658,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006074&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006075",
    "name": "SKANDIAWEST BRANCH WATER DEPT",
    "population": 275,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 81,
    "totalLines": 81,
    "exceedance": "",
    "latitude": 46.37205494,
    "longitude": -87.22967475,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006075&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006079",
    "name": "SODUS TOWNSHIP",
    "population": 1,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 27,
    "totalLines": 27,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040184",
    "name": "SOMERSET CENTRE ESTATES",
    "population": 368,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 147,
    "totalLines": 147,
    "exceedance": "",
    "latitude": 42.05757446,
    "longitude": -84.39532296,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040184&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040076",
    "name": "SOMERSET MOBILE HOME PARK",
    "population": 64,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 56,
    "totalLines": 56,
    "exceedance": "",
    "latitude": 41.96941282,
    "longitude": -85.05861159,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040076&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006081",
    "name": "SOMMERSET WATER WORKS, INC.",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": 45.21807313,
    "longitude": -85.06952771,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006081&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006080",
    "name": "SOUTH BLOOMFIELD HIGHLANDS",
    "population": 621,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 2,
    "totalToReplace": 2,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 207,
    "totalLines": 209,
    "exceedance": "",
    "latitude": 42.5985937,
    "longitude": -83.25971812,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006080&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006101",
    "name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "population": 9133,
    "y2021": 59,
    "y2022": 101,
    "y2023": 45,
    "y2024": 69,
    "y2025": 677,
    "leadLines": 31,
    "gpcl": 203,
    "unknown": 1860,
    "totalToReplace": 2094,
    "totalReplaced": 951,
    "percentReplaced": 31.231527093596057,
    "nonLead": 2981,
    "totalLines": 5075,
    "exceedance": "",
    "latitude": 42.40061451,
    "longitude": -86.26570449,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006101&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006110",
    "name": "SOUTH LYON, CITY OF",
    "population": 11055,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 2,
    "gpcl": 38,
    "unknown": 457,
    "totalToReplace": 497,
    "totalReplaced": 2,
    "percentReplaced": 0.4008016032064128,
    "nonLead": 3233,
    "totalLines": 3730,
    "exceedance": "",
    "latitude": 42.46880223,
    "longitude": -83.65184481,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006110&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006115",
    "name": "SOUTH POINTE I APARTMENTS",
    "population": 32,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.39063098,
    "longitude": -84.62671339,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006115&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006116",
    "name": "SOUTH POINTE II APARTMENTS",
    "population": 48,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.37623753,
    "longitude": -84.62828193,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006116&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006117",
    "name": "SOUTH POINTE III APARTMENTS",
    "population": 32,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 45.27219092,
    "longitude": -84.60575489,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006117&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006120",
    "name": "SOUTH RANGE",
    "population": 745,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 349,
    "totalLines": 349,
    "exceedance": "",
    "latitude": 47.07190378,
    "longitude": -88.64400612,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006120&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006130",
    "name": "SOUTH ROCKWOOD",
    "population": 1587,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 561,
    "totalLines": 561,
    "exceedance": "",
    "latitude": 42.0612613,
    "longitude": -83.25338048,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006130&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004890",
    "name": "SOUTH SHORE WATER SYSTEM",
    "population": 488,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 68,
    "unknown": 61,
    "totalToReplace": 129,
    "totalReplaced": 1,
    "percentReplaced": 0.7692307692307693,
    "nonLead": 115,
    "totalLines": 244,
    "exceedance": "",
    "latitude": 42.06621297,
    "longitude": -84.18093182,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004890&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004877",
    "name": "SOUTHEAST OAKLAND TOWNSHIP",
    "population": 1859,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 797,
    "totalLines": 797,
    "exceedance": "",
    "latitude": 42.72985367,
    "longitude": -83.13818906,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004877&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006150",
    "name": "SOUTHEASTERN OAKLAND CO W AUTH",
    "population": 0,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No service lines; wholesale only",
    "statusExplanation": "No service lines; wholesale only"
  },
  {
    "pwsid": "MI0006160",
    "name": "SOUTHFIELD",
    "population": 71739,
    "y2021": 1,
    "y2022": 1,
    "y2023": 1,
    "y2024": 14,
    "y2025": 0,
    "leadLines": 1,
    "gpcl": 1,
    "unknown": 1570,
    "totalToReplace": 1572,
    "totalReplaced": 17,
    "percentReplaced": 1.0698552548772813,
    "nonLead": 18532,
    "totalLines": 20104,
    "exceedance": "",
    "latitude": 42.47841025,
    "longitude": -83.25732149,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006160&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006170",
    "name": "SOUTHGATE",
    "population": 30047,
    "y2021": 30,
    "y2022": 5,
    "y2023": 17,
    "y2024": 35,
    "y2025": 29,
    "leadLines": 192,
    "gpcl": 9735,
    "unknown": 663,
    "totalToReplace": 10590,
    "totalReplaced": 116,
    "percentReplaced": 1.0835045768727816,
    "nonLead": 16,
    "totalLines": 10606,
    "exceedance": "",
    "latitude": 42.20188594,
    "longitude": -83.20732678,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006170&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040060",
    "name": "SOUTHTOWN MHP",
    "population": 160,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 68,
    "totalLines": 68,
    "exceedance": "",
    "latitude": 41.87436119,
    "longitude": -86.28350479,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040060&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003726",
    "name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "population": 26780,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 2,
    "gpcl": 18,
    "unknown": 7864,
    "totalToReplace": 7884,
    "totalReplaced": 2,
    "percentReplaced": 0.025361399949277198,
    "nonLead": 5581,
    "totalLines": 13465,
    "exceedance": "",
    "latitude": 42.02130877,
    "longitude": -86.49694879,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003726&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004878",
    "name": "SOUTHWEST OAKLAND TOWNSHIP",
    "population": 4909,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2066,
    "totalLines": 2066,
    "exceedance": "",
    "latitude": 42.72767439,
    "longitude": -83.19635283,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004878&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006200",
    "name": "SPARTA",
    "population": 4140,
    "y2021": 5,
    "y2022": 21,
    "y2023": 16,
    "y2024": 18,
    "y2025": 24,
    "leadLines": 0,
    "gpcl": 56,
    "unknown": 49,
    "totalToReplace": 105,
    "totalReplaced": 84,
    "percentReplaced": 44.44444444444444,
    "nonLead": 1530,
    "totalLines": 1635,
    "exceedance": "",
    "latitude": 43.15624526,
    "longitude": -85.71006947,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006200&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006210",
    "name": "SPAULDING TOWNSHIP",
    "population": 2153,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 780,
    "totalLines": 780,
    "exceedance": "",
    "latitude": 43.34848297,
    "longitude": -83.94235169,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006210&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006230",
    "name": "SPRING LAKE",
    "population": 2512,
    "y2021": 4,
    "y2022": 7,
    "y2023": 17,
    "y2024": 52,
    "y2025": 90,
    "leadLines": 0,
    "gpcl": 1110,
    "unknown": 0,
    "totalToReplace": 1110,
    "totalReplaced": 170,
    "percentReplaced": 13.28125,
    "nonLead": 137,
    "totalLines": 1247,
    "exceedance": "",
    "latitude": 43.06029019,
    "longitude": -86.17653586,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006230&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006232",
    "name": "SPRING LAKE CLUB CONDOMINIUMS",
    "population": 87,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": 45.39256113,
    "longitude": -84.90527989,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006232&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006235",
    "name": "SPRING LAKE TOWNSHIP",
    "population": 9393,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4441,
    "totalLines": 4441,
    "exceedance": "",
    "latitude": 43.09152539,
    "longitude": -86.17865634,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006235&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040230",
    "name": "SPRING VALLEY ESTATES",
    "population": 117,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 33,
    "totalToReplace": 33,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 61,
    "totalLines": 94,
    "exceedance": "",
    "latitude": 42.10203061,
    "longitude": -84.55229821,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040230&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040327",
    "name": "SPRINGBROOK ESTATES MHC",
    "population": 990,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 80,
    "totalLines": 80,
    "exceedance": "",
    "latitude": 42.82170407,
    "longitude": -83.01466755,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040327&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006240",
    "name": "SPRINGFIELD",
    "population": 3833,
    "y2021": 2,
    "y2022": 0,
    "y2023": 15,
    "y2024": 0,
    "y2025": 13,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 1,
    "totalToReplace": 1,
    "totalReplaced": 30,
    "percentReplaced": 96.7741935483871,
    "nonLead": 1693,
    "totalLines": 1694,
    "exceedance": "",
    "latitude": 42.32582574,
    "longitude": -85.23794099,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006240&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006250",
    "name": "SPRINGPORT",
    "population": 800,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 271,
    "totalLines": 271,
    "exceedance": "",
    "latitude": 42.37834329,
    "longitude": -84.69648074,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006250&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040397",
    "name": "SPRINGROVE MHC",
    "population": 1060,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 424,
    "totalLines": 424,
    "exceedance": "",
    "latitude": 42.78016352,
    "longitude": -83.50116709,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040397&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003749",
    "name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "population": 3200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 17,
    "totalLines": 17,
    "exceedance": "",
    "latitude": 42.52123771,
    "longitude": -83.51706296,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003749&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006370",
    "name": "SPSM",
    "population": 7166,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 63,
    "totalLines": 63,
    "exceedance": "",
    "latitude": 42.33808801,
    "longitude": -84.37677569,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006370&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006290",
    "name": "ST IGNACE",
    "population": 2987,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 84,
    "gpcl": 242,
    "unknown": 0,
    "totalToReplace": 326,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1193,
    "totalLines": 1519,
    "exceedance": "",
    "latitude": 45.8746626,
    "longitude": -84.72880364,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006290&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006310",
    "name": "ST JOSEPH",
    "population": 8789,
    "y2021": 130,
    "y2022": 199,
    "y2023": 222,
    "y2024": 170,
    "y2025": 27,
    "leadLines": 1566,
    "gpcl": 259,
    "unknown": 361,
    "totalToReplace": 2186,
    "totalReplaced": 748,
    "percentReplaced": 25.49420586230402,
    "nonLead": 1750,
    "totalLines": 3936,
    "exceedance": "",
    "latitude": 42.10171007,
    "longitude": -86.4819405,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006310&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006260",
    "name": "ST. CHARLES, VILLAGE OF",
    "population": 2054,
    "y2021": 0,
    "y2022": 3,
    "y2023": 50,
    "y2024": 20,
    "y2025": 6,
    "leadLines": 0,
    "gpcl": 19,
    "unknown": 408,
    "totalToReplace": 427,
    "totalReplaced": 79,
    "percentReplaced": 15.612648221343871,
    "nonLead": 524,
    "totalLines": 951,
    "exceedance": "",
    "latitude": 43.30009279,
    "longitude": -84.15219885,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006260&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006280",
    "name": "ST. CLAIR SHORES, CITY OF",
    "population": 59715,
    "y2021": 322,
    "y2022": 29,
    "y2023": 14,
    "y2024": 7,
    "y2025": 8,
    "leadLines": 12,
    "gpcl": 0,
    "unknown": 791,
    "totalToReplace": 803,
    "totalReplaced": 380,
    "percentReplaced": 32.12172442941674,
    "nonLead": 27206,
    "totalLines": 28009,
    "exceedance": "2021",
    "latitude": 42.49259785,
    "longitude": -82.89595281,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006280&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006282",
    "name": "ST. CLAIR TOWNSHIP",
    "population": 3270,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 291,
    "totalToReplace": 291,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 731,
    "totalLines": 1022,
    "exceedance": "",
    "latitude": 42.84486449,
    "longitude": -82.55779297,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006282&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006284",
    "name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "population": 5847,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 6,
    "leadLines": 0,
    "gpcl": 20,
    "unknown": 452,
    "totalToReplace": 472,
    "totalReplaced": 7,
    "percentReplaced": 1.4613778705636742,
    "nonLead": 1364,
    "totalLines": 1836,
    "exceedance": "",
    "latitude": 42.75361559,
    "longitude": -82.4909246,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006284&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006270",
    "name": "ST. CLAIR, CITY OF",
    "population": 5485,
    "y2021": 0,
    "y2022": 0,
    "y2023": 7,
    "y2024": 14,
    "y2025": 18,
    "leadLines": 0,
    "gpcl": 73,
    "unknown": 1376,
    "totalToReplace": 1449,
    "totalReplaced": 39,
    "percentReplaced": 2.620967741935484,
    "nonLead": 955,
    "totalLines": 2404,
    "exceedance": "",
    "latitude": 42.82512717,
    "longitude": -82.49424139,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006270&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006300",
    "name": "ST. JOHNS, CITY OF",
    "population": 7896,
    "y2021": 3,
    "y2022": 3,
    "y2023": 4,
    "y2024": 4,
    "y2025": 6,
    "leadLines": 894,
    "gpcl": 6,
    "unknown": 1262,
    "totalToReplace": 2162,
    "totalReplaced": 20,
    "percentReplaced": 0.916590284142988,
    "nonLead": 790,
    "totalLines": 2952,
    "exceedance": "",
    "latitude": 43.00033291,
    "longitude": -84.55590906,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006300&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006325",
    "name": "ST. LOUIS CENTER",
    "population": 56,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 13,
    "totalLines": 13,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006320",
    "name": "ST. LOUIS, CITY OF",
    "population": 6976,
    "y2021": 8,
    "y2022": 5,
    "y2023": 13,
    "y2024": 19,
    "y2025": 97,
    "leadLines": 4,
    "gpcl": 381,
    "unknown": 108,
    "totalToReplace": 493,
    "totalReplaced": 142,
    "percentReplaced": 22.362204724409448,
    "nonLead": 965,
    "totalLines": 1458,
    "exceedance": "",
    "latitude": 43.40690745,
    "longitude": -84.60802482,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006320&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0003350",
    "name": "STAMBAUGH TOWNSHIPINDIAN LAKE",
    "population": 290,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 104,
    "totalToReplace": 104,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 156,
    "exceedance": "",
    "latitude": 46.04358715,
    "longitude": -88.51153439,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003350&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006090",
    "name": "STAMBAUGH TOWNSHIPWEST BRULE",
    "population": 580,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 260,
    "totalToReplace": 260,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 206,
    "totalLines": 466,
    "exceedance": "",
    "latitude": 46.02779725,
    "longitude": -88.69551149,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006090&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0002940",
    "name": "STAMBAUGH TWP  HAGERMAN LAKE",
    "population": 230,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 100,
    "totalToReplace": 100,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 77,
    "totalLines": 177,
    "exceedance": "",
    "latitude": 46.04523482,
    "longitude": -88.73415157,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002940&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006350",
    "name": "STANDISH, CITY OF",
    "population": 1509,
    "y2021": 3,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 11,
    "unknown": 0,
    "totalToReplace": 11,
    "totalReplaced": 5,
    "percentReplaced": 31.25,
    "nonLead": 697,
    "totalLines": 708,
    "exceedance": "",
    "latitude": 43.9814769,
    "longitude": -83.9623959,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006350&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006360",
    "name": "STANTON",
    "population": 1417,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 4,
    "y2025": 37,
    "leadLines": 3,
    "gpcl": 288,
    "unknown": 0,
    "totalToReplace": 291,
    "totalReplaced": 41,
    "percentReplaced": 12.349397590361445,
    "nonLead": 212,
    "totalLines": 503,
    "exceedance": "",
    "latitude": 43.29214521,
    "longitude": -85.08574221,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006360&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040323",
    "name": "STARLIGHT MOBILE HOME PARK",
    "population": 79,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 48,
    "totalLines": 48,
    "exceedance": "",
    "latitude": 42.49752226,
    "longitude": -83.75403579,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040323&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006380",
    "name": "STEPHENSON",
    "population": 862,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 419,
    "totalLines": 419,
    "exceedance": "",
    "latitude": 45.41483263,
    "longitude": -87.61039903,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006380&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006385",
    "name": "STERLING HEIGHTS, CITY OF",
    "population": 127000,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 1995,
    "totalToReplace": 1995,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 37900,
    "totalLines": 39895,
    "exceedance": "",
    "latitude": 42.5810279,
    "longitude": -83.03043236,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006385&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006420",
    "name": "STOCKBRIDGE, VILLAGE OF",
    "population": 1202,
    "y2021": 1,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 354,
    "gpcl": 4,
    "unknown": 0,
    "totalToReplace": 358,
    "totalReplaced": 1,
    "percentReplaced": 0.2785515320334262,
    "nonLead": 168,
    "totalLines": 526,
    "exceedance": "",
    "latitude": 42.4637483,
    "longitude": -84.19295581,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006420&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040443",
    "name": "STODDARD MOBILE HOME COURT",
    "population": 285,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 125,
    "totalLines": 125,
    "exceedance": "",
    "latitude": 43.1737539,
    "longitude": -84.16994895,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040443&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006423",
    "name": "STONE RIDGE",
    "population": 367,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 137,
    "totalLines": 137,
    "exceedance": "",
    "latitude": 42.43334695,
    "longitude": -83.73776841,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006423&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040199",
    "name": "STONEGATE MOBILE HOME COMMUNITY",
    "population": 647,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 308,
    "totalLines": 308,
    "exceedance": "",
    "latitude": 42.65908707,
    "longitude": -84.59431776,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040199&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006428",
    "name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 49,
    "totalLines": 49,
    "exceedance": "",
    "latitude": 45.58691989,
    "longitude": -84.78410938,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006428&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006440",
    "name": "STURGIS",
    "population": 11920,
    "y2021": 69,
    "y2022": 30,
    "y2023": 45,
    "y2024": 51,
    "y2025": 110,
    "leadLines": 1341,
    "gpcl": 176,
    "unknown": 75,
    "totalToReplace": 1592,
    "totalReplaced": 305,
    "percentReplaced": 16.078017923036374,
    "nonLead": 2410,
    "totalLines": 4002,
    "exceedance": "",
    "latitude": 41.7978741,
    "longitude": -85.41630606,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006440&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040177",
    "name": "SUBURBAN ESTATES MHP",
    "population": 150,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 78,
    "totalLines": 78,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006446",
    "name": "SUGAR LOAF TOWNHOUSES",
    "population": 150,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 72,
    "totalLines": 72,
    "exceedance": "",
    "latitude": 44.92022866,
    "longitude": -85.81432662,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006446&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040256",
    "name": "SUGARLOAF MOBILE HOME PARK",
    "population": 142,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 58,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.12458555,
    "longitude": -85.63089203,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040256&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0006575",
    "name": "SUGARTREE APARTMENTS",
    "population": 375,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7,
    "totalLines": 7,
    "exceedance": "2025",
    "latitude": 43.13787782,
    "longitude": -83.69098598,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006575&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040187",
    "name": "SUMMER WOOD ESTATES",
    "population": 170,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 71,
    "totalLines": 71,
    "exceedance": "",
    "latitude": 43.81209951,
    "longitude": -83.00509155,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040187&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006448",
    "name": "SUMMERSET MEADOWS",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 74,
    "totalLines": 74,
    "exceedance": "",
    "latitude": 43.08527201,
    "longitude": -85.48234956,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006448&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006450",
    "name": "SUMMIT TOWNSHIP",
    "population": 25355,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7870,
    "totalLines": 7870,
    "exceedance": "",
    "latitude": 42.22542781,
    "longitude": -84.44149083,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006450&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006460",
    "name": "SUMPTER TOWNSHIP",
    "population": 9576,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3401,
    "totalLines": 3401,
    "exceedance": "",
    "latitude": 42.14109529,
    "longitude": -83.49021844,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006460&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006465",
    "name": "SUN MEADOWS APARTMENTS",
    "population": 98,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 8,
    "exceedance": "",
    "latitude": 42.09123183,
    "longitude": -85.64253143,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006465&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006470",
    "name": "SUNFIELD, VILLAGE OF",
    "population": 680,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 250,
    "totalLines": 250,
    "exceedance": "",
    "latitude": 42.75941284,
    "longitude": -84.99511999,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006470&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006480",
    "name": "SUNNYDALE GARDENS WATER ASSOCIATION",
    "population": 190,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": 42.63293797,
    "longitude": -83.16702486,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006480&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040466",
    "name": "SUNRISE MHP",
    "population": 120,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 48,
    "totalLines": 48,
    "exceedance": "",
    "latitude": 43.13195887,
    "longitude": -82.66027311,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040466&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006484",
    "name": "SUNSET BEACH ASSOCIATION",
    "population": 29,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 18,
    "totalLines": 18,
    "exceedance": "",
    "latitude": 45.48501824,
    "longitude": -84.59362232,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006484&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040416",
    "name": "SUNSET ESTATES GAYLORD",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 20,
    "totalLines": 20,
    "exceedance": "",
    "latitude": 45.12634345,
    "longitude": -84.66872231,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040416&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040313",
    "name": "SUNSET MHP",
    "population": 53,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040449",
    "name": "SUNSET MOBILE HOME PARK",
    "population": 263,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 105,
    "totalLines": 105,
    "exceedance": "",
    "latitude": 43.45023479,
    "longitude": -82.94005872,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040449&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040662",
    "name": "SUNSET RIDGE MHC",
    "population": 360,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 455,
    "totalLines": 455,
    "exceedance": "",
    "latitude": 42.86787515,
    "longitude": -84.93513645,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040662&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040653",
    "name": "SUNSET SHORES",
    "population": 200,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 80,
    "totalLines": 80,
    "exceedance": "",
    "latitude": 43.57977765,
    "longitude": -85.2937455,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040653&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006485",
    "name": "SUNSET TORCH ASSOCIATION",
    "population": 84,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 49,
    "totalToReplace": 49,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 49,
    "exceedance": "",
    "latitude": 44.9407369,
    "longitude": -85.28427685,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006485&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0000880",
    "name": "SUPERIOR TOWNSHIP",
    "population": 767,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 319,
    "totalLines": 319,
    "exceedance": "",
    "latitude": 46.42167838,
    "longitude": -84.5786873,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0000880&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006490",
    "name": "SUPERIOR TOWNSHIP",
    "population": 6830,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2632,
    "totalLines": 2632,
    "exceedance": "",
    "latitude": 42.28194417,
    "longitude": -83.62102474,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006490&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006500",
    "name": "SUTTONS BAY, VILLAGE OF",
    "population": 874,
    "y2021": 0,
    "y2022": 4,
    "y2023": 1,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 102,
    "gpcl": 53,
    "unknown": 0,
    "totalToReplace": 155,
    "totalReplaced": 5,
    "percentReplaced": 3.125,
    "nonLead": 119,
    "totalLines": 274,
    "exceedance": "",
    "latitude": 44.9794259,
    "longitude": -85.64905745,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006500&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006502",
    "name": "SWAN CREEK TOWNSHIP",
    "population": 2023,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1008,
    "totalLines": 1008,
    "exceedance": "",
    "latitude": 43.36553818,
    "longitude": -84.14272139,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006502&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040027",
    "name": "SWAN LAKE MOBILE ESTATES",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.46330483,
    "longitude": -85.96686688,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040027&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040164",
    "name": "SWARTZ CREEK MEADOWS",
    "population": 400,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 168,
    "totalLines": 168,
    "exceedance": "",
    "latitude": 42.97225387,
    "longitude": -83.92287511,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040164&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006505",
    "name": "SWARTZ CREEK, CITY OF",
    "population": 5800,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2226,
    "totalLines": 2226,
    "exceedance": "",
    "latitude": 42.9618406,
    "longitude": -83.82892817,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006505&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040474",
    "name": "SWEET LAKE MOBILE HOME PARK",
    "population": 80,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 53,
    "totalLines": 53,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006508",
    "name": "SWIFT LAKE FARMS",
    "population": 60,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": 42.08132759,
    "longitude": -85.87373742,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006508&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040314",
    "name": "SYLVAN GLEN ESTATES",
    "population": 1015,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 476,
    "totalLines": 476,
    "exceedance": "",
    "latitude": 42.57849888,
    "longitude": -83.825993,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040314&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006530",
    "name": "SYLVAN LAKE",
    "population": 2155,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 467,
    "totalToReplace": 467,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 369,
    "totalLines": 836,
    "exceedance": "",
    "latitude": 42.61432786,
    "longitude": -83.33297701,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006530&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006531",
    "name": "SYLVAN TOWNSHIP",
    "population": 263,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 154,
    "totalLines": 154,
    "exceedance": "",
    "latitude": 42.29276929,
    "longitude": -84.06037661,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006531&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007085",
    "name": "T.J. WHITE PINE MANOR APARTMENTS",
    "population": 32,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 43.75137743,
    "longitude": -85.14607109,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007085&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006532",
    "name": "TALL OAKS CONDOMINUMS",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 43.98879691,
    "longitude": -86.42947062,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006532&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040426",
    "name": "TALLMADGE MEADOWS",
    "population": 268,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 109,
    "totalLines": 109,
    "exceedance": "",
    "latitude": 43.00690094,
    "longitude": -85.7548781,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040426&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040337",
    "name": "TAMARAC VILLAGE",
    "population": 873,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 328,
    "totalLines": 328,
    "exceedance": "",
    "latitude": 44.0091157,
    "longitude": -86.46364849,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040337&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006537",
    "name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 8,
    "totalLines": 8,
    "exceedance": "",
    "latitude": 45.38703972,
    "longitude": -84.912176,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006537&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006540",
    "name": "TAWAS CITY, CITY OF",
    "population": 1827,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 241,
    "totalToReplace": 241,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 768,
    "totalLines": 1009,
    "exceedance": "",
    "latitude": 44.27164043,
    "longitude": -83.52018685,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006540&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006545",
    "name": "TAYLOR",
    "population": 63409,
    "y2021": 7,
    "y2022": 5,
    "y2023": 28,
    "y2024": 15,
    "y2025": 27,
    "leadLines": 124,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 124,
    "totalReplaced": 82,
    "percentReplaced": 39.80582524271845,
    "nonLead": 19381,
    "totalLines": 19505,
    "exceedance": "2025",
    "latitude": 42.22645174,
    "longitude": -83.26903385,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006545&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006552",
    "name": "TAYMOUTH TOWNSHIP",
    "population": 2033,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 766,
    "totalLines": 766,
    "exceedance": "",
    "latitude": 43.238108,
    "longitude": -83.90969286,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006552&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006560",
    "name": "TECUMSEH",
    "population": 8521,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 8,
    "leadLines": 2,
    "gpcl": 0,
    "unknown": 29,
    "totalToReplace": 31,
    "totalReplaced": 10,
    "percentReplaced": 24.390243902439025,
    "nonLead": 3204,
    "totalLines": 3235,
    "exceedance": "",
    "latitude": 42.00653329,
    "longitude": -83.94804736,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006560&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006562",
    "name": "TEKONSHA",
    "population": 722,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 324,
    "totalLines": 324,
    "exceedance": "",
    "latitude": 42.09481799,
    "longitude": -84.98843239,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006562&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006571",
    "name": "THE BLUFFS AT GULL LAKE",
    "population": 180,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060937",
    "name": "THE LAURELS OF FULTON",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003831",
    "name": "THE LEELANAU SCHOOL",
    "population": 82,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 15,
    "totalLines": 15,
    "exceedance": "",
    "latitude": 44.89714111,
    "longitude": -85.99615976,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003831&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006569",
    "name": "THE LIGHTHOUSETRAVERSE CITY LLC",
    "population": 55,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005229",
    "name": "THE PENINSULA DEVELOPMENT LLC",
    "population": 270,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 117,
    "totalLines": 117,
    "exceedance": "",
    "latitude": 42.55273447,
    "longitude": -83.75739871,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005229&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040640",
    "name": "THE PINES",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 42,
    "totalLines": 42,
    "exceedance": "",
    "latitude": 43.49102233,
    "longitude": -85.44090729,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040640&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0066695",
    "name": "THE PINES OF GOODRICH",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": 42.91861986,
    "longitude": -83.501789,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0066695&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0066700",
    "name": "THE PORCHES",
    "population": 25,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006574",
    "name": "THE SHORES ON CROOKED LAKE",
    "population": 57,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 45.42467753,
    "longitude": -84.8441107,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006574&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0064934",
    "name": "THE VILLA AT ROSE CITY",
    "population": 102,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": 44.34244491,
    "longitude": -83.93312964,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0064934&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006580",
    "name": "THOMAS TOWNSHIP",
    "population": 11931,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4595,
    "totalLines": 4595,
    "exceedance": "",
    "latitude": 43.42389828,
    "longitude": -84.07901184,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006580&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006590",
    "name": "THOMPSONVILLE, VILLAGE OF",
    "population": 438,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 1,
    "unknown": 170,
    "totalToReplace": 171,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 85,
    "totalLines": 256,
    "exceedance": "",
    "latitude": 44.52005348,
    "longitude": -85.9416212,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006590&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006592",
    "name": "THORN CREEK CONDOMINIUMS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 22,
    "totalLines": 22,
    "exceedance": "",
    "latitude": 44.78298717,
    "longitude": -85.65342973,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006592&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040047",
    "name": "THORNAPPLE LAKE ESTATES",
    "population": 538,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 215,
    "totalLines": 215,
    "exceedance": "",
    "latitude": 42.6284382,
    "longitude": -85.17894663,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040047&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060425",
    "name": "THORNAPPLE MANOR",
    "population": 328,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006594",
    "name": "THORNTON FARMS",
    "population": 1188,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 402,
    "totalLines": 402,
    "exceedance": "",
    "latitude": 42.28663897,
    "longitude": -83.90262804,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006594&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040497",
    "name": "THREE MILE LAKE TRAILER PARK",
    "population": 112,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 28,
    "totalLines": 28,
    "exceedance": "",
    "latitude": 42.16744957,
    "longitude": -85.97613419,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040497&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006600",
    "name": "THREE OAKS",
    "population": 1622,
    "y2021": 1,
    "y2022": 1,
    "y2023": 1,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 2,
    "gpcl": 14,
    "unknown": 744,
    "totalToReplace": 760,
    "totalReplaced": 3,
    "percentReplaced": 0.39318479685452157,
    "nonLead": 71,
    "totalLines": 831,
    "exceedance": "",
    "latitude": 41.79888956,
    "longitude": -86.61244077,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006600&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006610",
    "name": "THREE RIVERS",
    "population": 7905,
    "y2021": 0,
    "y2022": 1,
    "y2023": 2,
    "y2024": 4,
    "y2025": 30,
    "leadLines": 1420,
    "gpcl": 83,
    "unknown": 39,
    "totalToReplace": 1542,
    "totalReplaced": 37,
    "percentReplaced": 2.3432552248258394,
    "nonLead": 1153,
    "totalLines": 2695,
    "exceedance": "2024",
    "latitude": 41.94500753,
    "longitude": -85.62827844,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006610&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0004640",
    "name": "TILDEN TOWNSHIP",
    "population": 375,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 111,
    "totalToReplace": 111,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29,
    "totalLines": 140,
    "exceedance": "",
    "latitude": 46.42550416,
    "longitude": -87.73015129,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004640&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006624",
    "name": "TILLICUM FARMS",
    "population": 216,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 75,
    "totalLines": 75,
    "exceedance": "",
    "latitude": 43.09436563,
    "longitude": -85.45934549,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006624&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040574",
    "name": "TIMBER COUNTRY MOBILE HOME PARK",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 35,
    "totalLines": 35,
    "exceedance": "",
    "latitude": 43.32698777,
    "longitude": -84.82471025,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040574&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040363",
    "name": "TIMBERLINE ESTATES",
    "population": 755,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 267,
    "totalLines": 267,
    "exceedance": "",
    "latitude": 43.30482969,
    "longitude": -86.18349128,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040363&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0002470",
    "name": "TITTABAWASSEE TOWNSHIP",
    "population": 9227,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2846,
    "totalLines": 2846,
    "exceedance": "",
    "latitude": 43.49380255,
    "longitude": -84.11458068,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0002470&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040007",
    "name": "TOPAZ MOBILE HOME PARK",
    "population": 115,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 43,
    "totalLines": 43,
    "exceedance": "",
    "latitude": 42.65360995,
    "longitude": -85.76030698,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040007&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003270",
    "name": "TORCH LAKE TOWNSHIP",
    "population": 946,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 40,
    "unknown": 158,
    "totalToReplace": 198,
    "totalReplaced": 2,
    "percentReplaced": 1,
    "nonLead": 91,
    "totalLines": 289,
    "exceedance": "",
    "latitude": 47.24370702,
    "longitude": -88.454385,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003270&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040110",
    "name": "TOWN AND COUNTRY MHP",
    "population": 85,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 40,
    "exceedance": "",
    "latitude": 45.56217519,
    "longitude": -84.45245581,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040110&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040131",
    "name": "TRADEWINDS MOBILE HOME PARK",
    "population": 54,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 29,
    "exceedance": "",
    "latitude": 43.18772009,
    "longitude": -83.720482,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040131&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0006640",
    "name": "TRAVERSE CITY",
    "population": 14532,
    "y2021": 21,
    "y2022": 26,
    "y2023": 125,
    "y2024": 217,
    "y2025": 223,
    "leadLines": 2,
    "gpcl": 350,
    "unknown": 1239,
    "totalToReplace": 1591,
    "totalReplaced": 612,
    "percentReplaced": 27.780299591466186,
    "nonLead": 5323,
    "totalLines": 6914,
    "exceedance": "",
    "latitude": 44.7555275,
    "longitude": -85.6030966,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006640&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006647",
    "name": "TREETOPS RESORT (TREETOPS NORTH)",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 11,
    "totalLines": 11,
    "exceedance": "",
    "latitude": 45.03662111,
    "longitude": -84.5877077,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006647&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006650",
    "name": "TRENTON",
    "population": 18544,
    "y2021": 10,
    "y2022": 14,
    "y2023": 9,
    "y2024": 3,
    "y2025": 20,
    "leadLines": 155,
    "gpcl": 4,
    "unknown": 0,
    "totalToReplace": 159,
    "totalReplaced": 56,
    "percentReplaced": 26.046511627906977,
    "nonLead": 6730,
    "totalLines": 6885,
    "exceedance": "",
    "latitude": 42.13807779,
    "longitude": -83.18377766,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006650&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006682",
    "name": "TROUT CREEK CONDOMINIUMS",
    "population": 492,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 3,
    "totalToReplace": 3,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 40,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 45.48009426,
    "longitude": -84.91146428,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006682&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0006690",
    "name": "TROY",
    "population": 85854,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 29334,
    "totalLines": 29334,
    "exceedance": "",
    "latitude": 42.58178945,
    "longitude": -83.14602466,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006690&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006693",
    "name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 25,
    "totalLines": 25,
    "exceedance": "",
    "latitude": 43.56572432,
    "longitude": -85.33042542,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006693&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006696",
    "name": "TWIN LAKES SUBDIVISION",
    "population": 598,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 187,
    "totalLines": 187,
    "exceedance": "",
    "latitude": 42.76432226,
    "longitude": -83.125305,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006696&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040090",
    "name": "TWIN PINES MOBILE HOME PARK",
    "population": 182,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 73,
    "totalLines": 73,
    "exceedance": "",
    "latitude": 42.26954445,
    "longitude": -84.71908862,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040090&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040410",
    "name": "TWIN PINES MOBILE HOME PARK",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 36,
    "totalLines": 36,
    "exceedance": "",
    "latitude": 44.25114283,
    "longitude": -84.06456904,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040410&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040658",
    "name": "TYRONE WOODS",
    "population": 733,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 403,
    "totalLines": 403,
    "exceedance": "",
    "latitude": 42.72066219,
    "longitude": -83.78211423,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040658&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006710",
    "name": "UBLY, VILLAGE OF",
    "population": 858,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 14,
    "unknown": 325,
    "totalToReplace": 339,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 87,
    "totalLines": 426,
    "exceedance": "",
    "latitude": 43.70961033,
    "longitude": -82.93466738,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006710&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006720",
    "name": "UNION CITY",
    "population": 1630,
    "y2021": 0,
    "y2022": 5,
    "y2023": 4,
    "y2024": 11,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 20,
    "percentReplaced": 100,
    "nonLead": 700,
    "totalLines": 700,
    "exceedance": "",
    "latitude": 42.06589318,
    "longitude": -85.14161821,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006720&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0006725",
    "name": "UNION TOWNSHIP",
    "population": 12927,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 371,
    "totalToReplace": 371,
    "totalReplaced": 1,
    "percentReplaced": 0.2688172043010753,
    "nonLead": 1639,
    "totalLines": 2010,
    "exceedance": "",
    "latitude": 43.60878663,
    "longitude": -84.74285125,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006725&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006730",
    "name": "UNIONVILLE, VILLAGE OF",
    "population": 508,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 267,
    "totalLines": 267,
    "exceedance": "",
    "latitude": 43.65477714,
    "longitude": -83.46582438,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006730&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040325",
    "name": "UNIVERSITY MOBILE ESTATES #2",
    "population": 148,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 69,
    "totalLines": 69,
    "exceedance": "",
    "latitude": 42.43167743,
    "longitude": -83.76275631,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040325&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004800",
    "name": "UPPER MICHIGAN WATER COMPANY",
    "population": 5535,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 8,
    "leadLines": 8,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 8,
    "totalReplaced": 8,
    "percentReplaced": 50,
    "nonLead": 2750,
    "totalLines": 2758,
    "exceedance": "",
    "latitude": 47.23843958,
    "longitude": -88.44940295,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004800&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006760",
    "name": "UTICA, CITY OF",
    "population": 5059,
    "y2021": 11,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 94,
    "leadLines": 6,
    "gpcl": 99,
    "unknown": 1312,
    "totalToReplace": 1417,
    "totalReplaced": 105,
    "percentReplaced": 6.898817345597898,
    "nonLead": 779,
    "totalLines": 2196,
    "exceedance": "",
    "latitude": 42.6283709,
    "longitude": -83.02942375,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006760&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006792",
    "name": "V F W NATIONAL HOME",
    "population": 150,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 52,
    "exceedance": "",
    "latitude": 42.45612725,
    "longitude": -84.57117808,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006792&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006763",
    "name": "VALLEY SIDE APARTMENTS",
    "population": 45,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3,
    "totalLines": 3,
    "exceedance": "",
    "latitude": 44.36404474,
    "longitude": -86.19946957,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006763&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006765",
    "name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 44.48901498,
    "longitude": -86.23449142,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006765&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006770",
    "name": "VAN BUREN TOWNSHIP",
    "population": 27359,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 24,
    "totalToReplace": 24,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7778,
    "totalLines": 7802,
    "exceedance": "",
    "latitude": 42.21094033,
    "longitude": -83.46163074,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006770&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006780",
    "name": "VASSAR, CITY OF",
    "population": 2697,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 4,
    "y2025": 4,
    "leadLines": 58,
    "gpcl": 1001,
    "unknown": 0,
    "totalToReplace": 1059,
    "totalReplaced": 8,
    "percentReplaced": 0.7497656982193065,
    "nonLead": 0,
    "totalLines": 1059,
    "exceedance": "",
    "latitude": 43.37239403,
    "longitude": -83.58000588,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006780&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006790",
    "name": "VERMONTVILLE, VILLAGE OF",
    "population": 780,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 352,
    "totalLines": 352,
    "exceedance": "",
    "latitude": 42.62537575,
    "longitude": -85.02338266,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006790&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006072",
    "name": "VICINIA GARDENS",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006800",
    "name": "VICKSBURG",
    "population": 2906,
    "y2021": 59,
    "y2022": 13,
    "y2023": 1,
    "y2024": 8,
    "y2025": 58,
    "leadLines": 272,
    "gpcl": 74,
    "unknown": 0,
    "totalToReplace": 346,
    "totalReplaced": 139,
    "percentReplaced": 28.659793814432987,
    "nonLead": 1192,
    "totalLines": 1538,
    "exceedance": "",
    "latitude": 42.12364974,
    "longitude": -85.54064704,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006800&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040498",
    "name": "VIKING RIVER MOBILE HOME PARK",
    "population": 55,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 17,
    "totalLines": 17,
    "exceedance": "",
    "latitude": 42.22282415,
    "longitude": -86.16283373,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040498&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0060792",
    "name": "VILLA AT GREEN LAKE ESTATES",
    "population": 86,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006803",
    "name": "VILLA NOUVA ASSOCIATION",
    "population": 72,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": 45.23980719,
    "longitude": -85.17723344,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006803&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007099",
    "name": "VILLAGE AT EAGLE GARDENS",
    "population": 193,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 77,
    "totalLines": 77,
    "exceedance": "",
    "latitude": 42.41765463,
    "longitude": -83.75265162,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007099&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040028",
    "name": "VILLAGE EAST ESTATES",
    "population": 235,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 75,
    "totalToReplace": 75,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 19,
    "totalLines": 94,
    "exceedance": "",
    "latitude": 42.50878007,
    "longitude": -85.82271938,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040028&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006830",
    "name": "WAKEFIELD",
    "population": 1808,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 14,
    "y2025": 0,
    "leadLines": 17,
    "gpcl": 2,
    "unknown": 3,
    "totalToReplace": 22,
    "totalReplaced": 14,
    "percentReplaced": 38.88888888888889,
    "nonLead": 962,
    "totalLines": 984,
    "exceedance": "",
    "latitude": 46.47130681,
    "longitude": -89.93970073,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006830&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006850",
    "name": "WALDRON",
    "population": 538,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 59,
    "totalToReplace": 59,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 194,
    "totalLines": 253,
    "exceedance": "",
    "latitude": 41.72418358,
    "longitude": -84.41884517,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006850&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006875",
    "name": "WALLED LAKE, CITY OF",
    "population": 5452,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2307,
    "totalLines": 2307,
    "exceedance": "",
    "latitude": 42.5394366,
    "longitude": -83.47836177,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006875&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006880",
    "name": "WALLOON LAKE WATER SYSTEM",
    "population": 399,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 223,
    "totalLines": 223,
    "exceedance": "",
    "latitude": 45.2613141,
    "longitude": -84.93787131,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006880&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006885",
    "name": "WALNUT LANE APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "2025",
    "latitude": 42.73804802,
    "longitude": -85.6532143,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006885&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006900",
    "name": "WARREN, CITY OF",
    "population": 134056,
    "y2021": 99,
    "y2022": 99,
    "y2023": 65,
    "y2024": 69,
    "y2025": 56,
    "leadLines": 5,
    "gpcl": 33,
    "unknown": 15573,
    "totalToReplace": 15611,
    "totalReplaced": 388,
    "percentReplaced": 2.4251515719732484,
    "nonLead": 35146,
    "totalLines": 50757,
    "exceedance": "",
    "latitude": 42.4942148,
    "longitude": -83.02735394,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006900&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040477",
    "name": "WASHBURN LAKE VILLAGE MHP",
    "population": 108,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 44,
    "totalLines": 44,
    "exceedance": "2022",
    "latitude": 41.92172946,
    "longitude": -85.33152296,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040477&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040330",
    "name": "WASHINGTON MHP",
    "population": 268,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 107,
    "totalLines": 107,
    "exceedance": "",
    "latitude": 42.73953995,
    "longitude": -83.02863587,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040330&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006905",
    "name": "WASHINGTON TOWNSHIP",
    "population": 15828,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7025,
    "totalLines": 7025,
    "exceedance": "",
    "latitude": 42.73825379,
    "longitude": -83.03108728,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006905&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006910",
    "name": "WATERFORD TOWNSHIP",
    "population": 73441,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 2,
    "y2025": 0,
    "leadLines": 1,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 1,
    "totalReplaced": 2,
    "percentReplaced": 66.66666666666666,
    "nonLead": 25026,
    "totalLines": 25027,
    "exceedance": "",
    "latitude": 42.65952076,
    "longitude": -83.38599146,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006910&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040673",
    "name": "WATERS EDGE MH COMMUNITY",
    "population": 180,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 80,
    "totalLines": 80,
    "exceedance": "",
    "latitude": 42.00783976,
    "longitude": -84.29148993,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040673&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006920",
    "name": "WATERSMEET TOWNSHIP",
    "population": 575,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 1,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 31,
    "unknown": 127,
    "totalToReplace": 158,
    "totalReplaced": 2,
    "percentReplaced": 1.25,
    "nonLead": 60,
    "totalLines": 218,
    "exceedance": "",
    "latitude": 46.25051778,
    "longitude": -89.26496459,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006920&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006930",
    "name": "WATERVLIET",
    "population": 2735,
    "y2021": 61,
    "y2022": 3,
    "y2023": 6,
    "y2024": 6,
    "y2025": 6,
    "leadLines": 11,
    "gpcl": 624,
    "unknown": 301,
    "totalToReplace": 936,
    "totalReplaced": 82,
    "percentReplaced": 8.055009823182711,
    "nonLead": 20,
    "totalLines": 956,
    "exceedance": "",
    "latitude": 42.18699052,
    "longitude": -86.26037917,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006930&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006940",
    "name": "WAYLAND",
    "population": 4435,
    "y2021": 0,
    "y2022": 0,
    "y2023": 5,
    "y2024": 69,
    "y2025": 5,
    "leadLines": 206,
    "gpcl": 399,
    "unknown": 0,
    "totalToReplace": 605,
    "totalReplaced": 79,
    "percentReplaced": 11.549707602339181,
    "nonLead": 599,
    "totalLines": 1204,
    "exceedance": "",
    "latitude": 42.67543181,
    "longitude": -85.6402534,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006940&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006950",
    "name": "WAYNE",
    "population": 17593,
    "y2021": 43,
    "y2022": 44,
    "y2023": 153,
    "y2024": 399,
    "y2025": 529,
    "leadLines": 112,
    "gpcl": 182,
    "unknown": 4117,
    "totalToReplace": 4411,
    "totalReplaced": 1168,
    "percentReplaced": 20.93565155045707,
    "nonLead": 1504,
    "totalLines": 5915,
    "exceedance": "2023",
    "latitude": 42.27731324,
    "longitude": -83.38580385,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006950&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006960",
    "name": "WEBBER TOWNSHIP",
    "population": 15,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 13,
    "totalLines": 13,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006970",
    "name": "WEBBERVILLE, VILLAGE OF",
    "population": 1503,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 3,
    "y2025": 1,
    "leadLines": 0,
    "gpcl": 7,
    "unknown": 375,
    "totalToReplace": 382,
    "totalReplaced": 4,
    "percentReplaced": 1.0362694300518136,
    "nonLead": 90,
    "totalLines": 472,
    "exceedance": "",
    "latitude": 42.66457041,
    "longitude": -84.18240977,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006970&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0006971",
    "name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 52,
    "totalLines": 52,
    "exceedance": "",
    "latitude": 43.0350049,
    "longitude": -83.3710199,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006971&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040293",
    "name": "WELLERS TRAILER PARK",
    "population": 52,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 21,
    "totalLines": 21,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006975",
    "name": "WEST BLOOMFIELD TOWNSHIP",
    "population": 49479,
    "y2021": 0,
    "y2022": 0,
    "y2023": 3,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 454,
    "totalToReplace": 454,
    "totalReplaced": 3,
    "percentReplaced": 0.6564551422319475,
    "nonLead": 16925,
    "totalLines": 17379,
    "exceedance": "",
    "latitude": 42.56010101,
    "longitude": -83.40505954,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0006975&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007012",
    "name": "WEST BRANCH TOWNSHIP",
    "population": 61,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 80,
    "totalLines": 80,
    "exceedance": "",
    "latitude": 44.11258472,
    "longitude": -83.80837975,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007012&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007010",
    "name": "WEST BRANCH, CITY OF",
    "population": 2139,
    "y2021": 0,
    "y2022": 59,
    "y2023": 95,
    "y2024": 6,
    "y2025": 11,
    "leadLines": 2,
    "gpcl": 29,
    "unknown": 0,
    "totalToReplace": 31,
    "totalReplaced": 171,
    "percentReplaced": 84.65346534653465,
    "nonLead": 901,
    "totalLines": 932,
    "exceedance": "",
    "latitude": 44.27370821,
    "longitude": -84.23128824,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007010&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0067020",
    "name": "WEST HICKORY HAVEN",
    "population": 100,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040614",
    "name": "WEST OLIVE ESTATES",
    "population": 1850,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 743,
    "totalLines": 743,
    "exceedance": "",
    "latitude": 42.92973911,
    "longitude": -86.14108216,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040614&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0005606",
    "name": "WEST PARK APARTMENTS",
    "population": 54,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 6,
    "totalLines": 6,
    "exceedance": "",
    "latitude": 45.03725875,
    "longitude": -84.70833395,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0005606&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040650",
    "name": "WEST PINE ISLAND",
    "population": 75,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 30,
    "totalLines": 30,
    "exceedance": "",
    "latitude": 43.41421285,
    "longitude": -86.08711454,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040650&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007057",
    "name": "WEST TRAVERSE TOWNSHIP",
    "population": 414,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 172,
    "totalLines": 172,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007035",
    "name": "WESTBROOK APARTMENTS",
    "population": 330,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 105,
    "totalLines": 105,
    "exceedance": "",
    "latitude": 42.41197826,
    "longitude": -83.76258798,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007035&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0004754",
    "name": "WESTERN PINES APARTMENTS",
    "population": 50,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 43.25276743,
    "longitude": -83.78612503,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0004754&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0040162",
    "name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "population": 122,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": 42.98080595,
    "longitude": -83.73103037,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040162&sys=SDWIS",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0007040",
    "name": "WESTLAND",
    "population": 84094,
    "y2021": 7,
    "y2022": 0,
    "y2023": 2,
    "y2024": 2,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 166,
    "unknown": 13193,
    "totalToReplace": 13359,
    "totalReplaced": 13,
    "percentReplaced": 0.09721806760394855,
    "nonLead": 15095,
    "totalLines": 28454,
    "exceedance": "",
    "latitude": 42.31913795,
    "longitude": -83.37945763,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007040&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007050",
    "name": "WESTPHALIA, VILLAGE OF",
    "population": 925,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 415,
    "totalLines": 415,
    "exceedance": "",
    "latitude": 42.93322733,
    "longitude": -84.79354158,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007050&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040435",
    "name": "WHISPERING OAKS MHP",
    "population": 40,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 26,
    "totalLines": 26,
    "exceedance": "",
    "latitude": 44.29564555,
    "longitude": -84.70917886,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040435&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040576",
    "name": "WHISPERING PINES",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": 43.10966997,
    "longitude": -85.6603575,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040576&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040500",
    "name": "WHISPERING PINES ESTATES",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 50,
    "totalLines": 50,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0000575",
    "name": "WHISPERING PINES SENIOR LIVING",
    "population": 39,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040561",
    "name": "WHITE BIRCH ESTATES",
    "population": 87,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 51,
    "totalLines": 51,
    "exceedance": "",
    "latitude": 44.06791675,
    "longitude": -85.45497572,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040561&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040516",
    "name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "population": 250,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 251,
    "totalLines": 251,
    "exceedance": "",
    "latitude": 45.80704888,
    "longitude": -88.02767844,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040516&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007060",
    "name": "WHITE CLOUD",
    "population": 1408,
    "y2021": 4,
    "y2022": 0,
    "y2023": 2,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 312,
    "gpcl": 20,
    "unknown": 5,
    "totalToReplace": 337,
    "totalReplaced": 6,
    "percentReplaced": 1.749271137026239,
    "nonLead": 180,
    "totalLines": 517,
    "exceedance": "",
    "latitude": 43.55042801,
    "longitude": -85.77244794,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007060&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040294",
    "name": "WHITE CREEK COUNTRY ESTATES",
    "population": 300,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 177,
    "totalLines": 177,
    "exceedance": "",
    "latitude": 43.25439845,
    "longitude": -85.57549627,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040294&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007062",
    "name": "WHITE DEER VILLAGE",
    "population": 20,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 18,
    "totalLines": 18,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007061",
    "name": "WHITE EAGLE SUBDIVISION",
    "population": 224,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 70,
    "totalLines": 70,
    "exceedance": "",
    "latitude": 42.695452,
    "longitude": -83.56964341,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007061&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007064",
    "name": "WHITE LAKE ASSISTED LIVING CENTER",
    "population": 26,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2,
    "totalLines": 2,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007065",
    "name": "WHITE LAKE TOWNSHIP",
    "population": 5799,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2419,
    "totalLines": 2419,
    "exceedance": "2019",
    "latitude": 42.64162167,
    "longitude": -83.47774928,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007065&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007067",
    "name": "WHITE OAKS CONDOMINIUMS",
    "population": 45,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 24,
    "totalLines": 24,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007070",
    "name": "WHITE PIGEON",
    "population": 1640,
    "y2021": 86,
    "y2022": 2,
    "y2023": 5,
    "y2024": 5,
    "y2025": 92,
    "leadLines": 494,
    "gpcl": 4,
    "unknown": 0,
    "totalToReplace": 498,
    "totalReplaced": 190,
    "percentReplaced": 27.61627906976744,
    "nonLead": 155,
    "totalLines": 653,
    "exceedance": "",
    "latitude": 41.79597458,
    "longitude": -85.64459734,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007070&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040105",
    "name": "WHITE PINES MOBILE HOME PARK",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 35,
    "totalLines": 35,
    "exceedance": "",
    "latitude": 42.07257952,
    "longitude": -86.14336115,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040105&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007063",
    "name": "WHITEFORD TOWNSHIP",
    "population": 303,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 165,
    "totalLines": 165,
    "exceedance": "",
    "latitude": 41.74125877,
    "longitude": -83.68198952,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007063&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007100",
    "name": "WHITEHALL",
    "population": 2902,
    "y2021": 8,
    "y2022": 31,
    "y2023": 26,
    "y2024": 31,
    "y2025": 27,
    "leadLines": 248,
    "gpcl": 313,
    "unknown": 0,
    "totalToReplace": 561,
    "totalReplaced": 123,
    "percentReplaced": 17.982456140350877,
    "nonLead": 831,
    "totalLines": 1392,
    "exceedance": "",
    "latitude": 43.3965271,
    "longitude": -86.34250758,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007100&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007101",
    "name": "WHITMORE LAKE APARTMENTS",
    "population": 281,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 7,
    "totalLines": 7,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007104",
    "name": "WHITTEMORE SQUARE APARTMENTS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 25,
    "totalLines": 25,
    "exceedance": "",
    "latitude": 44.21157389,
    "longitude": -83.79923593,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007104&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007105",
    "name": "WILDWOOD ON WALLOON ASSOCIATION",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 36,
    "totalToReplace": 36,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 36,
    "exceedance": "",
    "latitude": 45.2672578,
    "longitude": -84.99080612,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007105&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007125",
    "name": "WILLIAMS TOWNSHIP",
    "population": 5444,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 2104,
    "totalLines": 2104,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007120",
    "name": "WILLIAMSTON, CITY OF",
    "population": 3917,
    "y2021": 3,
    "y2022": 2,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 5,
    "percentReplaced": 100,
    "nonLead": 1419,
    "totalLines": 1419,
    "exceedance": "",
    "latitude": 42.68581466,
    "longitude": -84.28306978,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007120&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0040202",
    "name": "WILLOW VILLAGE",
    "population": 65,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 0,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Inventory not received or incomplete",
    "statusExplanation": "Inventory not received or data not complete"
  },
  {
    "pwsid": "MI0001658",
    "name": "WILLOWS ON TWIN PONDS",
    "population": 147,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 14,
    "totalLines": 14,
    "exceedance": "",
    "latitude": 42.19220814,
    "longitude": -84.31900547,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0001658&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007126",
    "name": "WINDJAMMER COVE CONDOMINIUMS",
    "population": 30,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 17,
    "totalLines": 17,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040203",
    "name": "WINDMILL PARK",
    "population": 950,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 487,
    "totalLines": 487,
    "exceedance": "",
    "latitude": 42.62446772,
    "longitude": -84.54957013,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040203&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040124",
    "name": "WINDSOR ESTATES",
    "population": 718,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 471,
    "totalLines": 471,
    "exceedance": "",
    "latitude": 42.66452194,
    "longitude": -84.65962553,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040124&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007130",
    "name": "WINDWARD OWNERS ASSOCIATION",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 8,
    "totalToReplace": 8,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 12,
    "totalLines": 20,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007134",
    "name": "WISNER AREA WATER SYSTEM",
    "population": 504,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 250,
    "totalLines": 250,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007135",
    "name": "WIXOM, CITY OF",
    "population": 13928,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 4,
    "unknown": 224,
    "totalToReplace": 228,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3271,
    "totalLines": 3499,
    "exceedance": "",
    "latitude": 42.52180602,
    "longitude": -83.54003386,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007135&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040501",
    "name": "WOLF LAKE MOBILE HOME PARK",
    "population": 99,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 45,
    "totalLines": 45,
    "exceedance": "",
    "latitude": 42.27079856,
    "longitude": -85.77415644,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040501&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040480",
    "name": "WOOD VALLEY",
    "population": 348,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 140,
    "totalLines": 140,
    "exceedance": "",
    "latitude": 43.32821416,
    "longitude": -83.56725742,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040480&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007160",
    "name": "WOODBINE SUBDIVISION",
    "population": 375,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 146,
    "unknown": 0,
    "totalToReplace": 146,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 0,
    "totalLines": 146,
    "exceedance": "",
    "latitude": 42.47261322,
    "longitude": -83.32871116,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007160&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007180",
    "name": "WOODHAVEN",
    "population": 12875,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 3905,
    "totalLines": 3905,
    "exceedance": "",
    "latitude": 42.12614569,
    "longitude": -83.23402714,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007180&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0006820",
    "name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "population": 210,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 10,
    "totalLines": 10,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040296",
    "name": "WOODLAND ESTATES",
    "population": 268,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 107,
    "totalLines": 107,
    "exceedance": "",
    "latitude": 43.08826897,
    "longitude": -85.56092936,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040296&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040326",
    "name": "WOODLAND PARK AND SALES",
    "population": 125,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 63,
    "totalLines": 63,
    "exceedance": "",
    "latitude": 42.55951957,
    "longitude": -83.79275739,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040326&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007182",
    "name": "WOODLAND PARK APARTMENTS",
    "population": 16,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040669",
    "name": "WOODLAND RIDGE",
    "population": 1080,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 544,
    "totalLines": 544,
    "exceedance": "",
    "latitude": 42.44380006,
    "longitude": -83.70496966,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040669&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040404",
    "name": "WOODLANDS MHC",
    "population": 650,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 374,
    "totalLines": 374,
    "exceedance": "",
    "latitude": 42.79509997,
    "longitude": -83.16710173,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040404&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007185",
    "name": "WOODRUFF LAKE CONDOMINIUMS",
    "population": 95,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 60,
    "totalLines": 60,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040639",
    "name": "WOODS AND FIELDS COMMUNITIES EAST",
    "population": 528,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 324,
    "totalLines": 324,
    "exceedance": "",
    "latitude": 42.96397561,
    "longitude": -84.20855937,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040639&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0040455",
    "name": "WOODS AND FIELDS COMMUNITIES WEST",
    "population": 185,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 72,
    "totalLines": 72,
    "exceedance": "2025",
    "latitude": 42.99641618,
    "longitude": -84.21993424,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040455&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007186",
    "name": "WOODS OF LOCHAVEN",
    "population": 2,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1,
    "totalLines": 1,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0003856",
    "name": "WORTH TOWNSHIP",
    "population": 3854,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 1937,
    "totalLines": 1937,
    "exceedance": "",
    "latitude": 43.2050353,
    "longitude": -82.51905132,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0003856&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007210",
    "name": "WYANDOTTE",
    "population": 25883,
    "y2021": 30,
    "y2022": 53,
    "y2023": 27,
    "y2024": 75,
    "y2025": 47,
    "leadLines": 241,
    "gpcl": 11,
    "unknown": 9439,
    "totalToReplace": 9691,
    "totalReplaced": 232,
    "percentReplaced": 2.33800262017535,
    "nonLead": 578,
    "totalLines": 10269,
    "exceedance": "",
    "latitude": 42.19517239,
    "longitude": -83.15856914,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007210&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007217",
    "name": "WYNSTONE SUBDIVISION",
    "population": 1146,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 359,
    "totalLines": 359,
    "exceedance": "",
    "latitude": 42.78716069,
    "longitude": -83.12580422,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007217&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007220",
    "name": "WYOMING",
    "population": 72125,
    "y2021": 2,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 4,
    "percentReplaced": 100,
    "nonLead": 23407,
    "totalLines": 23407,
    "exceedance": "",
    "latitude": 42.88917492,
    "longitude": -85.70504552,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007220&sys=SDWIS",
    "status": "100% replaced",
    "statusExplanation": "100% replaced"
  },
  {
    "pwsid": "MI0007230",
    "name": "YALE, CITY OF",
    "population": 1900,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 2,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 38,
    "totalToReplace": 38,
    "totalReplaced": 2,
    "percentReplaced": 5,
    "nonLead": 732,
    "totalLines": 743,
    "exceedance": "",
    "latitude": 43.12772717,
    "longitude": -82.79731487,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007230&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0040585",
    "name": "YANKEE SPRINGS MEADOWS",
    "population": 710,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 274,
    "totalLines": 274,
    "exceedance": "",
    "latitude": 42.67170922,
    "longitude": -85.54157658,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0040585&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007231",
    "name": "YANKEE SPRINGS TOWNSHIP",
    "population": 660,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 278,
    "totalLines": 278,
    "exceedance": "",
    "latitude": 42.61965825,
    "longitude": -85.540165,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007231&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007235",
    "name": "YODER APARTMENTS",
    "population": 90,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 4,
    "totalLines": 4,
    "exceedance": "",
    "latitude": null,
    "longitude": null,
    "epaLink": "",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007240",
    "name": "YORK CONDOMINIUMS",
    "population": 74,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 11,
    "totalLines": 11,
    "exceedance": "",
    "latitude": 44.92232933,
    "longitude": -85.61736244,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007240&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  },
  {
    "pwsid": "MI0007260",
    "name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "population": 53988,
    "y2021": 20,
    "y2022": 67,
    "y2023": 18,
    "y2024": 22,
    "y2025": 49,
    "leadLines": 155,
    "gpcl": 364,
    "unknown": 758,
    "totalToReplace": 1277,
    "totalReplaced": 176,
    "percentReplaced": 12.112869924294563,
    "nonLead": 19135,
    "totalLines": 20412,
    "exceedance": "",
    "latitude": 42.22205608,
    "longitude": -83.60282211,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007260&sys=SDWIS",
    "status": "Not compliant",
    "statusExplanation": "Not Compliant (<25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007270",
    "name": "ZEELAND BOARD OF PUBLIC WORKS",
    "population": 8328,
    "y2021": 81,
    "y2022": 138,
    "y2023": 246,
    "y2024": 133,
    "y2025": 108,
    "leadLines": 31,
    "gpcl": 269,
    "unknown": 0,
    "totalToReplace": 300,
    "totalReplaced": 706,
    "percentReplaced": 70.17892644135189,
    "nonLead": 2169,
    "totalLines": 2469,
    "exceedance": "",
    "latitude": 42.81392373,
    "longitude": -86.01285657,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007270&sys=SDWIS",
    "status": "Compliant",
    "statusExplanation": "Compliant (≥25% average replacement, 2021–2025)"
  },
  {
    "pwsid": "MI0007280",
    "name": "ZILWAUKEE, CITY OF",
    "population": 1534,
    "y2021": 0,
    "y2022": 0,
    "y2023": 0,
    "y2024": 0,
    "y2025": 0,
    "leadLines": 0,
    "gpcl": 0,
    "unknown": 0,
    "totalToReplace": 0,
    "totalReplaced": 0,
    "percentReplaced": 0,
    "nonLead": 770,
    "totalLines": 770,
    "exceedance": "",
    "latitude": 43.48062678,
    "longitude": -83.92622577,
    "epaLink": "https://echo.epa.gov/detailed-facility-report?fid=MI0007280&sys=SDWIS",
    "status": "No lead lines",
    "statusExplanation": "Inventory completed, no lead lines identified"
  }
];

export default waterSystemsData;